"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    { zip: 8000, canton: "ZH", commune: "Zürich" },
    { zip: 8914, canton: "ZH", commune: "Aeugst am Albis" },
    { zip: 8909, canton: "ZH", commune: "Affoltern am Albis" },
    { zip: 8910, canton: "ZH", commune: "Affoltern am Albis" },
    { zip: 8906, canton: "ZH", commune: "Bonstetten" },
    { zip: 6340, canton: "ZH", commune: "Hausen am Albis" },
    { zip: 8915, canton: "ZH", commune: "Hausen am Albis" },
    { zip: 8925, canton: "ZH", commune: "Hausen am Albis" },
    { zip: 8908, canton: "ZH", commune: "Hedingen" },
    { zip: 8926, canton: "ZH", commune: "Kappel am Albis" },
    { zip: 8934, canton: "ZH", commune: "Knonau" },
    { zip: 8933, canton: "ZH", commune: "Maschwanden" },
    { zip: 8932, canton: "ZH", commune: "Mettmenstetten" },
    { zip: 8912, canton: "ZH", commune: "Obfelden" },
    { zip: 8913, canton: "ZH", commune: "Ottenbach" },
    { zip: 8911, canton: "ZH", commune: "Rifferswil" },
    { zip: 8143, canton: "ZH", commune: "Stallikon" },
    { zip: 8907, canton: "ZH", commune: "Wettswil am Albis" },
    { zip: 8452, canton: "ZH", commune: "Adlikon" },
    { zip: 8463, canton: "ZH", commune: "Benken (ZH)" },
    { zip: 8415, canton: "ZH", commune: "Berg am Irchel" },
    { zip: 8414, canton: "ZH", commune: "Buch am Irchel" },
    { zip: 8447, canton: "ZH", commune: "Dachsen" },
    { zip: 8458, canton: "ZH", commune: "Dorf" },
    { zip: 8245, canton: "ZH", commune: "Feuerthalen" },
    { zip: 8246, canton: "ZH", commune: "Feuerthalen" },
    { zip: 8416, canton: "ZH", commune: "Flaach" },
    { zip: 8247, canton: "ZH", commune: "Flurlingen" },
    { zip: 8450, canton: "ZH", commune: "Andelfingen" },
    { zip: 8444, canton: "ZH", commune: "Henggart" },
    { zip: 8457, canton: "ZH", commune: "Humlikon" },
    { zip: 8451, canton: "ZH", commune: "Kleinandelfingen" },
    { zip: 8453, canton: "ZH", commune: "Kleinandelfingen" },
    { zip: 8461, canton: "ZH", commune: "Kleinandelfingen" },
    { zip: 8212, canton: "ZH", commune: "Laufen-Uhwiesen" },
    { zip: 8248, canton: "ZH", commune: "Laufen-Uhwiesen" },
    { zip: 8447, canton: "ZH", commune: "Laufen-Uhwiesen" },
    { zip: 8460, canton: "ZH", commune: "Marthalen" },
    { zip: 8464, canton: "ZH", commune: "Marthalen" },
    { zip: 8468, canton: "ZH", commune: "Oberstammheim" },
    { zip: 8477, canton: "ZH", commune: "Oberstammheim" },
    { zip: 8525, canton: "ZH", commune: "Oberstammheim" },
    { zip: 8466, canton: "ZH", commune: "Ossingen" },
    { zip: 8475, canton: "ZH", commune: "Ossingen" },
    { zip: 8462, canton: "ZH", commune: "Rheinau" },
    { zip: 8464, canton: "ZH", commune: "Rheinau" },
    { zip: 8478, canton: "ZH", commune: "Thalheim an der Thur" },
    { zip: 8465, canton: "ZH", commune: "Trüllikon" },
    { zip: 8466, canton: "ZH", commune: "Trüllikon" },
    { zip: 8467, canton: "ZH", commune: "Truttikon" },
    { zip: 8476, canton: "ZH", commune: "Unterstammheim" },
    { zip: 8459, canton: "ZH", commune: "Volken" },
    { zip: 8468, canton: "ZH", commune: "Waltalingen" },
    { zip: 8184, canton: "ZH", commune: "Bachenbülach" },
    { zip: 8303, canton: "ZH", commune: "Bassersdorf" },
    { zip: 8180, canton: "ZH", commune: "Bülach" },
    { zip: 8305, canton: "ZH", commune: "Dietlikon" },
    { zip: 8600, canton: "ZH", commune: "Dietlikon" },
    { zip: 8193, canton: "ZH", commune: "Eglisau" },
    { zip: 8197, canton: "ZH", commune: "Eglisau" },
    { zip: 8424, canton: "ZH", commune: "Embrach" },
    { zip: 8427, canton: "ZH", commune: "Embrach" },
    { zip: 8427, canton: "ZH", commune: "Freienstein-Teufen" },
    { zip: 8428, canton: "ZH", commune: "Freienstein-Teufen" },
    { zip: 8180, canton: "ZH", commune: "Glattfelden" },
    { zip: 8192, canton: "ZH", commune: "Glattfelden" },
    { zip: 8193, canton: "ZH", commune: "Glattfelden" },
    { zip: 8182, canton: "ZH", commune: "Hochfelden" },
    { zip: 8192, canton: "ZH", commune: "Hochfelden" },
    { zip: 8181, canton: "ZH", commune: "Höri" },
    { zip: 8194, canton: "ZH", commune: "Hüntwangen" },
    { zip: 8152, canton: "ZH", commune: "Kloten" },
    { zip: 8302, canton: "ZH", commune: "Kloten" },
    { zip: 8309, canton: "ZH", commune: "Kloten" },
    { zip: 8426, canton: "ZH", commune: "Lufingen" },
    { zip: 8309, canton: "ZH", commune: "Nürensdorf" },
    { zip: 8425, canton: "ZH", commune: "Oberembrach" },
    { zip: 8052, canton: "ZH", commune: "Opfikon" },
    { zip: 8152, canton: "ZH", commune: "Opfikon" },
    { zip: 8197, canton: "ZH", commune: "Rafz" },
    { zip: 8427, canton: "ZH", commune: "Rorbas" },
    { zip: 8428, canton: "ZH", commune: "Rorbas" },
    { zip: 8304, canton: "ZH", commune: "Wallisellen" },
    { zip: 8195, canton: "ZH", commune: "Wasterkingen" },
    { zip: 8196, canton: "ZH", commune: "Wasterkingen" },
    { zip: 8196, canton: "ZH", commune: "Wil (ZH)" },
    { zip: 8180, canton: "ZH", commune: "Winkel" },
    { zip: 8185, canton: "ZH", commune: "Winkel" },
    { zip: 8164, canton: "ZH", commune: "Bachs" },
    { zip: 8113, canton: "ZH", commune: "Boppelsen" },
    { zip: 8107, canton: "ZH", commune: "Buchs (ZH)" },
    { zip: 8108, canton: "ZH", commune: "Dällikon" },
    { zip: 8114, canton: "ZH", commune: "Dänikon" },
    { zip: 8157, canton: "ZH", commune: "Dielsdorf" },
    { zip: 8115, canton: "ZH", commune: "Hüttikon" },
    { zip: 8162, canton: "ZH", commune: "Neerach" },
    { zip: 8164, canton: "ZH", commune: "Neerach" },
    { zip: 8173, canton: "ZH", commune: "Neerach" },
    { zip: 8174, canton: "ZH", commune: "Neerach" },
    { zip: 8172, canton: "ZH", commune: "Niederglatt" },
    { zip: 8155, canton: "ZH", commune: "Niederhasli" },
    { zip: 8156, canton: "ZH", commune: "Niederhasli" },
    { zip: 8166, canton: "ZH", commune: "Niederweningen" },
    { zip: 8154, canton: "ZH", commune: "Oberglatt" },
    { zip: 5462, canton: "ZH", commune: "Oberweningen" },
    { zip: 8165, canton: "ZH", commune: "Oberweningen" },
    { zip: 8107, canton: "ZH", commune: "Otelfingen" },
    { zip: 8112, canton: "ZH", commune: "Otelfingen" },
    { zip: 8158, canton: "ZH", commune: "Regensberg" },
    { zip: 8105, canton: "ZH", commune: "Regensdorf" },
    { zip: 8106, canton: "ZH", commune: "Regensdorf" },
    { zip: 8052, canton: "ZH", commune: "Rümlang" },
    { zip: 8152, canton: "ZH", commune: "Rümlang" },
    { zip: 8153, canton: "ZH", commune: "Rümlang" },
    { zip: 8165, canton: "ZH", commune: "Schleinikon" },
    { zip: 8165, canton: "ZH", commune: "Schöfflisdorf" },
    { zip: 8174, canton: "ZH", commune: "Stadel" },
    { zip: 8175, canton: "ZH", commune: "Stadel" },
    { zip: 8155, canton: "ZH", commune: "Steinmaur" },
    { zip: 8162, canton: "ZH", commune: "Steinmaur" },
    { zip: 8187, canton: "ZH", commune: "Weiach" },
    { zip: 8340, canton: "ZH", commune: "Bäretswil" },
    { zip: 8344, canton: "ZH", commune: "Bäretswil" },
    { zip: 8345, canton: "ZH", commune: "Bäretswil" },
    { zip: 8498, canton: "ZH", commune: "Bäretswil" },
    { zip: 8608, canton: "ZH", commune: "Bubikon" },
    { zip: 8633, canton: "ZH", commune: "Bubikon" },
    { zip: 8340, canton: "ZH", commune: "Dürnten" },
    { zip: 8608, canton: "ZH", commune: "Dürnten" },
    { zip: 8632, canton: "ZH", commune: "Dürnten" },
    { zip: 8635, canton: "ZH", commune: "Dürnten" },
    { zip: 8636, canton: "ZH", commune: "Dürnten" },
    { zip: 8494, canton: "ZH", commune: "Fischenthal" },
    { zip: 8496, canton: "ZH", commune: "Fischenthal" },
    { zip: 8497, canton: "ZH", commune: "Fischenthal" },
    { zip: 8498, canton: "ZH", commune: "Fischenthal" },
    { zip: 8614, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8617, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8624, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8625, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8626, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8627, canton: "ZH", commune: "Gossau (ZH)" },
    { zip: 8627, canton: "ZH", commune: "Grüningen" },
    { zip: 8340, canton: "ZH", commune: "Hinwil" },
    { zip: 8342, canton: "ZH", commune: "Hinwil" },
    { zip: 8498, canton: "ZH", commune: "Hinwil" },
    { zip: 8630, canton: "ZH", commune: "Rüti (ZH)" },
    { zip: 8636, canton: "ZH", commune: "Rüti (ZH)" },
    { zip: 8607, canton: "ZH", commune: "Seegräben" },
    { zip: 8636, canton: "ZH", commune: "Wald (ZH)" },
    { zip: 8637, canton: "ZH", commune: "Wald (ZH)" },
    { zip: 8340, canton: "ZH", commune: "Wetzikon (ZH)" },
    { zip: 8345, canton: "ZH", commune: "Wetzikon (ZH)" },
    { zip: 8620, canton: "ZH", commune: "Wetzikon (ZH)" },
    { zip: 8623, canton: "ZH", commune: "Wetzikon (ZH)" },
    { zip: 8624, canton: "ZH", commune: "Wetzikon (ZH)" },
    { zip: 8134, canton: "ZH", commune: "Adliswil" },
    { zip: 8816, canton: "ZH", commune: "Hirzel" },
    { zip: 8135, canton: "ZH", commune: "Horgen" },
    { zip: 8810, canton: "ZH", commune: "Horgen" },
    { zip: 8815, canton: "ZH", commune: "Horgen" },
    { zip: 8816, canton: "ZH", commune: "Horgen" },
    { zip: 8825, canton: "ZH", commune: "Hütten" },
    { zip: 8802, canton: "ZH", commune: "Kilchberg (ZH)" },
    { zip: 8803, canton: "ZH", commune: "Kilchberg (ZH)" },
    { zip: 8135, canton: "ZH", commune: "Langnau am Albis" },
    { zip: 8942, canton: "ZH", commune: "Oberrieden" },
    { zip: 8805, canton: "ZH", commune: "Richterswil" },
    { zip: 8833, canton: "ZH", commune: "Richterswil" },
    { zip: 8803, canton: "ZH", commune: "Rüschlikon" },
    { zip: 8824, canton: "ZH", commune: "Schönenberg (ZH)" },
    { zip: 8136, canton: "ZH", commune: "Thalwil" },
    { zip: 8800, canton: "ZH", commune: "Thalwil" },
    { zip: 8804, canton: "ZH", commune: "Wädenswil" },
    { zip: 8820, canton: "ZH", commune: "Wädenswil" },
    { zip: 8703, canton: "ZH", commune: "Erlenbach (ZH)" },
    { zip: 8703, canton: "ZH", commune: "Herrliberg" },
    { zip: 8704, canton: "ZH", commune: "Herrliberg" },
    { zip: 8627, canton: "ZH", commune: "Hombrechtikon" },
    { zip: 8634, canton: "ZH", commune: "Hombrechtikon" },
    { zip: 8714, canton: "ZH", commune: "Hombrechtikon" },
    { zip: 8127, canton: "ZH", commune: "Küsnacht (ZH)" },
    { zip: 8700, canton: "ZH", commune: "Küsnacht (ZH)" },
    { zip: 8703, canton: "ZH", commune: "Küsnacht (ZH)" },
    { zip: 8708, canton: "ZH", commune: "Männedorf" },
    { zip: 8706, canton: "ZH", commune: "Meilen" },
    { zip: 8618, canton: "ZH", commune: "Oetwil am See" },
    { zip: 8712, canton: "ZH", commune: "Stäfa" },
    { zip: 8713, canton: "ZH", commune: "Stäfa" },
    { zip: 8707, canton: "ZH", commune: "Uetikon am See" },
    { zip: 8126, canton: "ZH", commune: "Zumikon" },
    { zip: 8125, canton: "ZH", commune: "Zollikon" },
    { zip: 8702, canton: "ZH", commune: "Zollikon" },
    { zip: 8308, canton: "ZH", commune: "Fehraltorf" },
    { zip: 8320, canton: "ZH", commune: "Fehraltorf" },
    { zip: 8335, canton: "ZH", commune: "Hittnau" },
    { zip: 8310, canton: "ZH", commune: "Lindau" },
    { zip: 8312, canton: "ZH", commune: "Lindau" },
    { zip: 8315, canton: "ZH", commune: "Lindau" },
    { zip: 8317, canton: "ZH", commune: "Lindau" },
    { zip: 8330, canton: "ZH", commune: "Pfäffikon" },
    { zip: 8331, canton: "ZH", commune: "Pfäffikon" },
    { zip: 8623, canton: "ZH", commune: "Pfäffikon" },
    { zip: 8322, canton: "ZH", commune: "Russikon" },
    { zip: 8332, canton: "ZH", commune: "Russikon" },
    { zip: 8308, canton: "ZH", commune: "Weisslingen" },
    { zip: 8484, canton: "ZH", commune: "Weisslingen" },
    { zip: 8486, canton: "ZH", commune: "Weisslingen" },
    { zip: 8492, canton: "ZH", commune: "Wila" },
    { zip: 8493, canton: "ZH", commune: "Wila" },
    { zip: 8322, canton: "ZH", commune: "Wildberg" },
    { zip: 8488, canton: "ZH", commune: "Wildberg" },
    { zip: 8489, canton: "ZH", commune: "Wildberg" },
    { zip: 8044, canton: "ZH", commune: "Dübendorf" },
    { zip: 8051, canton: "ZH", commune: "Dübendorf" },
    { zip: 8304, canton: "ZH", commune: "Dübendorf" },
    { zip: 8600, canton: "ZH", commune: "Dübendorf" },
    { zip: 8603, canton: "ZH", commune: "Dübendorf" },
    { zip: 8127, canton: "ZH", commune: "Egg" },
    { zip: 8132, canton: "ZH", commune: "Egg" },
    { zip: 8133, canton: "ZH", commune: "Egg" },
    { zip: 8117, canton: "ZH", commune: "Fällanden" },
    { zip: 8118, canton: "ZH", commune: "Fällanden" },
    { zip: 8121, canton: "ZH", commune: "Fällanden" },
    { zip: 8606, canton: "ZH", commune: "Greifensee" },
    { zip: 8122, canton: "ZH", commune: "Maur" },
    { zip: 8123, canton: "ZH", commune: "Maur" },
    { zip: 8124, canton: "ZH", commune: "Maur" },
    { zip: 8127, canton: "ZH", commune: "Maur" },
    { zip: 8132, canton: "ZH", commune: "Maur" },
    { zip: 8607, canton: "ZH", commune: "Mönchaltorf" },
    { zip: 8617, canton: "ZH", commune: "Mönchaltorf" },
    { zip: 8600, canton: "ZH", commune: "Schwerzenbach" },
    { zip: 8603, canton: "ZH", commune: "Schwerzenbach" },
    { zip: 8606, canton: "ZH", commune: "Uster" },
    { zip: 8610, canton: "ZH", commune: "Uster" },
    { zip: 8614, canton: "ZH", commune: "Uster" },
    { zip: 8615, canton: "ZH", commune: "Uster" },
    { zip: 8616, canton: "ZH", commune: "Uster" },
    { zip: 8617, canton: "ZH", commune: "Uster" },
    { zip: 8307, canton: "ZH", commune: "Volketswil" },
    { zip: 8604, canton: "ZH", commune: "Volketswil" },
    { zip: 8605, canton: "ZH", commune: "Volketswil" },
    { zip: 8306, canton: "ZH", commune: "Wangen-Brüttisellen" },
    { zip: 8602, canton: "ZH", commune: "Wangen-Brüttisellen" },
    { zip: 8479, canton: "ZH", commune: "Altikon" },
    { zip: 8311, canton: "ZH", commune: "Brütten" },
    { zip: 8471, canton: "ZH", commune: "Dägerlen" },
    { zip: 8421, canton: "ZH", commune: "Dättlikon" },
    { zip: 8474, canton: "ZH", commune: "Dinhard" },
    { zip: 8353, canton: "ZH", commune: "Elgg" },
    { zip: 8354, canton: "ZH", commune: "Elgg" },
    { zip: 8355, canton: "ZH", commune: "Elgg" },
    { zip: 8523, canton: "ZH", commune: "Elgg" },
    { zip: 8548, canton: "ZH", commune: "Ellikon an der Thur" },
    { zip: 8352, canton: "ZH", commune: "Elsau" },
    { zip: 8500, canton: "ZH", commune: "Hagenbuch" },
    { zip: 8523, canton: "ZH", commune: "Hagenbuch" },
    { zip: 8442, canton: "ZH", commune: "Hettlingen" },
    { zip: 8354, canton: "ZH", commune: "Hofstetten (ZH)" },
    { zip: 8412, canton: "ZH", commune: "Neftenbach" },
    { zip: 8413, canton: "ZH", commune: "Neftenbach" },
    { zip: 8422, canton: "ZH", commune: "Pfungen" },
    { zip: 8545, canton: "ZH", commune: "Rickenbach (ZH)" },
    { zip: 8354, canton: "ZH", commune: "Schlatt (ZH)" },
    { zip: 8405, canton: "ZH", commune: "Schlatt (ZH)" },
    { zip: 8418, canton: "ZH", commune: "Schlatt (ZH)" },
    { zip: 8472, canton: "ZH", commune: "Seuzach" },
    { zip: 8363, canton: "ZH", commune: "Turbenthal" },
    { zip: 8488, canton: "ZH", commune: "Turbenthal" },
    { zip: 8492, canton: "ZH", commune: "Turbenthal" },
    { zip: 8495, canton: "ZH", commune: "Turbenthal" },
    { zip: 8310, canton: "ZH", commune: "Winterthur" },
    { zip: 8352, canton: "ZH", commune: "Winterthur" },
    { zip: 8400, canton: "ZH", commune: "Winterthur" },
    { zip: 8404, canton: "ZH", commune: "Winterthur" },
    { zip: 8405, canton: "ZH", commune: "Winterthur" },
    { zip: 8406, canton: "ZH", commune: "Winterthur" },
    { zip: 8408, canton: "ZH", commune: "Winterthur" },
    { zip: 8409, canton: "ZH", commune: "Winterthur" },
    { zip: 8482, canton: "ZH", commune: "Winterthur" },
    { zip: 8542, canton: "ZH", commune: "Winterthur" },
    { zip: 8545, canton: "ZH", commune: "Winterthur" },
    { zip: 8483, canton: "ZH", commune: "Zell (ZH)" },
    { zip: 8486, canton: "ZH", commune: "Zell (ZH)" },
    { zip: 8487, canton: "ZH", commune: "Zell (ZH)" },
    { zip: 8904, canton: "ZH", commune: "Aesch (ZH)" },
    { zip: 8142, canton: "ZH", commune: "Birmensdorf (ZH)" },
    { zip: 8903, canton: "ZH", commune: "Birmensdorf (ZH)" },
    { zip: 8952, canton: "ZH", commune: "Dietikon" },
    { zip: 8953, canton: "ZH", commune: "Dietikon" },
    { zip: 8951, canton: "ZH", commune: "Geroldswil" },
    { zip: 8954, canton: "ZH", commune: "Geroldswil" },
    { zip: 8102, canton: "ZH", commune: "Oberengstringen" },
    { zip: 8955, canton: "ZH", commune: "Oetwil an der Limmat" },
    { zip: 8902, canton: "ZH", commune: "Schlieren" },
    { zip: 8952, canton: "ZH", commune: "Schlieren" },
    { zip: 8142, canton: "ZH", commune: "Uitikon" },
    { zip: 8143, canton: "ZH", commune: "Uitikon" },
    { zip: 8103, canton: "ZH", commune: "Unterengstringen" },
    { zip: 8951, canton: "ZH", commune: "Unterengstringen" },
    { zip: 8952, canton: "ZH", commune: "Unterengstringen" },
    { zip: 8902, canton: "ZH", commune: "Urdorf" },
    { zip: 8104, canton: "ZH", commune: "Weiningen (ZH)" },
    { zip: 8951, canton: "ZH", commune: "Weiningen (ZH)" },
    { zip: 8001, canton: "ZH", commune: "Zürich" },
    { zip: 8002, canton: "ZH", commune: "Zürich" },
    { zip: 8003, canton: "ZH", commune: "Zürich" },
    { zip: 8004, canton: "ZH", commune: "Zürich" },
    { zip: 8005, canton: "ZH", commune: "Zürich" },
    { zip: 8006, canton: "ZH", commune: "Zürich" },
    { zip: 8008, canton: "ZH", commune: "Zürich" },
    { zip: 8032, canton: "ZH", commune: "Zürich" },
    { zip: 8037, canton: "ZH", commune: "Zürich" },
    { zip: 8038, canton: "ZH", commune: "Zürich" },
    { zip: 8041, canton: "ZH", commune: "Zürich" },
    { zip: 8044, canton: "ZH", commune: "Zürich" },
    { zip: 8045, canton: "ZH", commune: "Zürich" },
    { zip: 8046, canton: "ZH", commune: "Zürich" },
    { zip: 8047, canton: "ZH", commune: "Zürich" },
    { zip: 8048, canton: "ZH", commune: "Zürich" },
    { zip: 8049, canton: "ZH", commune: "Zürich" },
    { zip: 8050, canton: "ZH", commune: "Zürich" },
    { zip: 8051, canton: "ZH", commune: "Zürich" },
    { zip: 8052, canton: "ZH", commune: "Zürich" },
    { zip: 8053, canton: "ZH", commune: "Zürich" },
    { zip: 8055, canton: "ZH", commune: "Zürich" },
    { zip: 8057, canton: "ZH", commune: "Zürich" },
    { zip: 8064, canton: "ZH", commune: "Zürich" },
    { zip: 8125, canton: "ZH", commune: "Zürich" },
    { zip: 8134, canton: "ZH", commune: "Zürich" },
    { zip: 8142, canton: "ZH", commune: "Zürich" },
    { zip: 8143, canton: "ZH", commune: "Zürich" },
    { zip: 8152, canton: "ZH", commune: "Zürich" },
    { zip: 8952, canton: "ZH", commune: "Zürich" },
    { zip: 8307, canton: "ZH", commune: "Illnau-Effretikon" },
    { zip: 8308, canton: "ZH", commune: "Illnau-Effretikon" },
    { zip: 8314, canton: "ZH", commune: "Illnau-Effretikon" },
    { zip: 8482, canton: "ZH", commune: "Illnau-Effretikon" },
    { zip: 8483, canton: "ZH", commune: "Illnau-Effretikon" },
    { zip: 8493, canton: "ZH", commune: "Bauma" },
    { zip: 8494, canton: "ZH", commune: "Bauma" },
    { zip: 8499, canton: "ZH", commune: "Bauma" },
    { zip: 8542, canton: "ZH", commune: "Wiesendangen" },
    { zip: 8543, canton: "ZH", commune: "Wiesendangen" },
    { zip: 8544, canton: "ZH", commune: "Wiesendangen" },
    { zip: 8546, canton: "ZH", commune: "Wiesendangen" },
    { zip: 3250, canton: "BE", commune: "Aarberg" },
    { zip: 3267, canton: "BE", commune: "Aarberg" },
    { zip: 3270, canton: "BE", commune: "Aarberg" },
    { zip: 3273, canton: "BE", commune: "Aarberg" },
    { zip: 3282, canton: "BE", commune: "Bargen (BE)" },
    { zip: 3283, canton: "BE", commune: "Bargen (BE)" },
    { zip: 3257, canton: "BE", commune: "Grossaffoltern" },
    { zip: 3262, canton: "BE", commune: "Grossaffoltern" },
    { zip: 3226, canton: "BE", commune: "Kallnach" },
    { zip: 3283, canton: "BE", commune: "Kallnach" },
    { zip: 3250, canton: "BE", commune: "Kappelen" },
    { zip: 3252, canton: "BE", commune: "Kappelen" },
    { zip: 3273, canton: "BE", commune: "Kappelen" },
    { zip: 2557, canton: "BE", commune: "Lyss" },
    { zip: 3250, canton: "BE", commune: "Lyss" },
    { zip: 3292, canton: "BE", commune: "Lyss" },
    { zip: 3042, canton: "BE", commune: "Meikirch" },
    { zip: 3045, canton: "BE", commune: "Meikirch" },
    { zip: 3046, canton: "BE", commune: "Meikirch" },
    { zip: 3036, canton: "BE", commune: "Radelfingen" },
    { zip: 3271, canton: "BE", commune: "Radelfingen" },
    { zip: 3053, canton: "BE", commune: "Rapperswil (BE)" },
    { zip: 3251, canton: "BE", commune: "Rapperswil (BE)" },
    { zip: 3254, canton: "BE", commune: "Rapperswil (BE)" },
    { zip: 3255, canton: "BE", commune: "Rapperswil (BE)" },
    { zip: 3256, canton: "BE", commune: "Rapperswil (BE)" },
    { zip: 3053, canton: "BE", commune: "Schüpfen" },
    { zip: 3054, canton: "BE", commune: "Schüpfen" },
    { zip: 3035, canton: "BE", commune: "Seedorf (BE)" },
    { zip: 3266, canton: "BE", commune: "Seedorf (BE)" },
    { zip: 3267, canton: "BE", commune: "Seedorf (BE)" },
    { zip: 3268, canton: "BE", commune: "Seedorf (BE)" },
    { zip: 3270, canton: "BE", commune: "Seedorf (BE)" },
    { zip: 4912, canton: "BE", commune: "Aarwangen" },
    { zip: 4922, canton: "BE", commune: "Aarwangen" },
    { zip: 4938, canton: "BE", commune: "Auswil" },
    { zip: 4944, canton: "BE", commune: "Auswil" },
    { zip: 4912, canton: "BE", commune: "Bannwil" },
    { zip: 4913, canton: "BE", commune: "Bannwil" },
    { zip: 3368, canton: "BE", commune: "Bleienbach" },
    { zip: 4917, canton: "BE", commune: "Busswil bei Melchnau" },
    { zip: 4955, canton: "BE", commune: "Gondiswil" },
    { zip: 4900, canton: "BE", commune: "Langenthal" },
    { zip: 4916, canton: "BE", commune: "Langenthal" },
    { zip: 4924, canton: "BE", commune: "Langenthal" },
    { zip: 3368, canton: "BE", commune: "Lotzwil" },
    { zip: 4932, canton: "BE", commune: "Lotzwil" },
    { zip: 4919, canton: "BE", commune: "Madiswil" },
    { zip: 4932, canton: "BE", commune: "Madiswil" },
    { zip: 4934, canton: "BE", commune: "Madiswil" },
    { zip: 4935, canton: "BE", commune: "Madiswil" },
    { zip: 4936, canton: "BE", commune: "Madiswil" },
    { zip: 4917, canton: "BE", commune: "Melchnau" },
    { zip: 6146, canton: "BE", commune: "Melchnau" },
    { zip: 6147, canton: "BE", commune: "Melchnau" },
    { zip: 4924, canton: "BE", commune: "Obersteckholz" },
    { zip: 4943, canton: "BE", commune: "Oeschenbach" },
    { zip: 4919, canton: "BE", commune: "Reisiswil" },
    { zip: 4914, canton: "BE", commune: "Roggwil (BE)" },
    { zip: 4938, canton: "BE", commune: "Rohrbach" },
    { zip: 4938, canton: "BE", commune: "Rohrbachgraben" },
    { zip: 4933, canton: "BE", commune: "Rütschelen" },
    { zip: 4911, canton: "BE", commune: "Schwarzhäusern" },
    { zip: 4922, canton: "BE", commune: "Thunstetten" },
    { zip: 4936, canton: "BE", commune: "Ursenbach" },
    { zip: 4937, canton: "BE", commune: "Ursenbach" },
    { zip: 4942, canton: "BE", commune: "Ursenbach" },
    { zip: 4943, canton: "BE", commune: "Ursenbach" },
    { zip: 4853, canton: "BE", commune: "Wynau" },
    { zip: 4923, canton: "BE", commune: "Wynau" },
    { zip: 3004, canton: "BE", commune: "Bern" },
    { zip: 3005, canton: "BE", commune: "Bern" },
    { zip: 3006, canton: "BE", commune: "Bern" },
    { zip: 3007, canton: "BE", commune: "Bern" },
    { zip: 3008, canton: "BE", commune: "Bern" },
    { zip: 3010, canton: "BE", commune: "Bern" },
    { zip: 3011, canton: "BE", commune: "Bern" },
    { zip: 3012, canton: "BE", commune: "Bern" },
    { zip: 3013, canton: "BE", commune: "Bern" },
    { zip: 3014, canton: "BE", commune: "Bern" },
    { zip: 3015, canton: "BE", commune: "Bern" },
    { zip: 3018, canton: "BE", commune: "Bern" },
    { zip: 3019, canton: "BE", commune: "Bern" },
    { zip: 3020, canton: "BE", commune: "Bern" },
    { zip: 3027, canton: "BE", commune: "Bern" },
    { zip: 3032, canton: "BE", commune: "Bern" },
    { zip: 3037, canton: "BE", commune: "Bern" },
    { zip: 3048, canton: "BE", commune: "Bern" },
    { zip: 3063, canton: "BE", commune: "Bern" },
    { zip: 3072, canton: "BE", commune: "Bern" },
    { zip: 3073, canton: "BE", commune: "Bern" },
    { zip: 3084, canton: "BE", commune: "Bern" },
    { zip: 3097, canton: "BE", commune: "Bern" },
    { zip: 3065, canton: "BE", commune: "Bolligen" },
    { zip: 3066, canton: "BE", commune: "Bolligen" },
    { zip: 3326, canton: "BE", commune: "Bolligen" },
    { zip: 3047, canton: "BE", commune: "Bremgarten bei Bern" },
    { zip: 3037, canton: "BE", commune: "Kirchlindach" },
    { zip: 3038, canton: "BE", commune: "Kirchlindach" },
    { zip: 3042, canton: "BE", commune: "Kirchlindach" },
    { zip: 3007, canton: "BE", commune: "Köniz" },
    { zip: 3084, canton: "BE", commune: "Köniz" },
    { zip: 3095, canton: "BE", commune: "Köniz" },
    { zip: 3097, canton: "BE", commune: "Köniz" },
    { zip: 3098, canton: "BE", commune: "Köniz" },
    { zip: 3122, canton: "BE", commune: "Köniz" },
    { zip: 3144, canton: "BE", commune: "Köniz" },
    { zip: 3145, canton: "BE", commune: "Köniz" },
    { zip: 3147, canton: "BE", commune: "Köniz" },
    { zip: 3172, canton: "BE", commune: "Köniz" },
    { zip: 3173, canton: "BE", commune: "Köniz" },
    { zip: 3174, canton: "BE", commune: "Köniz" },
    { zip: 3073, canton: "BE", commune: "Muri bei Bern" },
    { zip: 3074, canton: "BE", commune: "Muri bei Bern" },
    { zip: 3076, canton: "BE", commune: "Muri bei Bern" },
    { zip: 3086, canton: "BE", commune: "Oberbalm" },
    { zip: 3096, canton: "BE", commune: "Oberbalm" },
    { zip: 3145, canton: "BE", commune: "Oberbalm" },
    { zip: 3147, canton: "BE", commune: "Oberbalm" },
    { zip: 3066, canton: "BE", commune: "Stettlen" },
    { zip: 3067, canton: "BE", commune: "Stettlen" },
    { zip: 3076, canton: "BE", commune: "Stettlen" },
    { zip: 3066, canton: "BE", commune: "Vechigen" },
    { zip: 3067, canton: "BE", commune: "Vechigen" },
    { zip: 3068, canton: "BE", commune: "Vechigen" },
    { zip: 3076, canton: "BE", commune: "Vechigen" },
    { zip: 3513, canton: "BE", commune: "Vechigen" },
    { zip: 3032, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3033, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3034, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3035, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3036, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3037, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3042, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3043, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3044, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3045, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3049, canton: "BE", commune: "Wohlen bei Bern" },
    { zip: 3052, canton: "BE", commune: "Zollikofen" },
    { zip: 3048, canton: "BE", commune: "Ittigen" },
    { zip: 3063, canton: "BE", commune: "Ittigen" },
    { zip: 3063, canton: "BE", commune: "Ostermundigen" },
    { zip: 3065, canton: "BE", commune: "Ostermundigen" },
    { zip: 3066, canton: "BE", commune: "Ostermundigen" },
    { zip: 3072, canton: "BE", commune: "Ostermundigen" },
    { zip: 3073, canton: "BE", commune: "Ostermundigen" },
    { zip: 2500, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2502, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2503, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2504, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2505, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2532, canton: "BE", commune: "Biel/Bienne" },
    { zip: 2532, canton: "BE", commune: "Evilard" },
    { zip: 2533, canton: "BE", commune: "Evilard" },
    { zip: 3296, canton: "BE", commune: "Arch" },
    { zip: 3263, canton: "BE", commune: "Büetigen" },
    { zip: 3294, canton: "BE", commune: "Büren an der Aare" },
    { zip: 3264, canton: "BE", commune: "Diessbach bei Büren" },
    { zip: 3293, canton: "BE", commune: "Dotzigen" },
    { zip: 3294, canton: "BE", commune: "Dotzigen" },
    { zip: 2543, canton: "BE", commune: "Lengnau (BE)" },
    { zip: 3297, canton: "BE", commune: "Leuzigen" },
    { zip: 3294, canton: "BE", commune: "Meienried" },
    { zip: 2554, canton: "BE", commune: "Meinisberg" },
    { zip: 3298, canton: "BE", commune: "Oberwil bei Büren" },
    { zip: 2542, canton: "BE", commune: "Pieterlen" },
    { zip: 3295, canton: "BE", commune: "Rüti bei Büren" },
    { zip: 3251, canton: "BE", commune: "Wengi" },
    { zip: 3426, canton: "BE", commune: "Aefligen" },
    { zip: 3473, canton: "BE", commune: "Alchenstorf" },
    { zip: 3323, canton: "BE", commune: "Bäriswil" },
    { zip: 3400, canton: "BE", commune: "Burgdorf" },
    { zip: 3413, canton: "BE", commune: "Burgdorf" },
    { zip: 3414, canton: "BE", commune: "Burgdorf" },
    { zip: 3472, canton: "BE", commune: "Burgdorf" },
    { zip: 3422, canton: "BE", commune: "Ersigen" },
    { zip: 3423, canton: "BE", commune: "Ersigen" },
    { zip: 3424, canton: "BE", commune: "Ersigen" },
    { zip: 3425, canton: "BE", commune: "Ersigen" },
    { zip: 3472, canton: "BE", commune: "Ersigen" },
    { zip: 3415, canton: "BE", commune: "Hasle bei Burgdorf" },
    { zip: 3419, canton: "BE", commune: "Hasle bei Burgdorf" },
    { zip: 3432, canton: "BE", commune: "Hasle bei Burgdorf" },
    { zip: 3433, canton: "BE", commune: "Hasle bei Burgdorf" },
    { zip: 3513, canton: "BE", commune: "Hasle bei Burgdorf" },
    { zip: 3412, canton: "BE", commune: "Heimiswil" },
    { zip: 3413, canton: "BE", commune: "Heimiswil" },
    { zip: 3415, canton: "BE", commune: "Heimiswil" },
    { zip: 3416, canton: "BE", commune: "Heimiswil" },
    { zip: 3418, canton: "BE", commune: "Heimiswil" },
    { zip: 3472, canton: "BE", commune: "Heimiswil" },
    { zip: 3429, canton: "BE", commune: "Hellsau" },
    { zip: 3324, canton: "BE", commune: "Hindelbank" },
    { zip: 3325, canton: "BE", commune: "Hindelbank" },
    { zip: 3429, canton: "BE", commune: "Höchstetten" },
    { zip: 3309, canton: "BE", commune: "Kernenried" },
    { zip: 3400, canton: "BE", commune: "Kirchberg (BE)" },
    { zip: 3422, canton: "BE", commune: "Kirchberg (BE)" },
    { zip: 3425, canton: "BE", commune: "Koppigen" },
    { zip: 3325, canton: "BE", commune: "Krauchthal" },
    { zip: 3326, canton: "BE", commune: "Krauchthal" },
    { zip: 3421, canton: "BE", commune: "Lyssach" },
    { zip: 3324, canton: "BE", commune: "Mötschwil" },
    { zip: 3325, canton: "BE", commune: "Mötschwil" },
    { zip: 3421, canton: "BE", commune: "Mötschwil" },
    { zip: 3414, canton: "BE", commune: "Oberburg" },
    { zip: 3421, canton: "BE", commune: "Oberburg" },
    { zip: 3422, canton: "BE", commune: "Rüdtligen-Alchenflüh" },
    { zip: 3472, canton: "BE", commune: "Rumendingen" },
    { zip: 3421, canton: "BE", commune: "Rüti bei Lyssach" },
    { zip: 3425, canton: "BE", commune: "Willadingen" },
    { zip: 3464, canton: "BE", commune: "Wynigen" },
    { zip: 3472, canton: "BE", commune: "Wynigen" },
    { zip: 3474, canton: "BE", commune: "Wynigen" },
    { zip: 2534, canton: "BE", commune: "Corgémont" },
    { zip: 2606, canton: "BE", commune: "Corgémont" },
    { zip: 2608, canton: "BE", commune: "Corgémont" },
    { zip: 2720, canton: "BE", commune: "Corgémont" },
    { zip: 2610, canton: "BE", commune: "Cormoret" },
    { zip: 2612, canton: "BE", commune: "Cormoret" },
    { zip: 2613, canton: "BE", commune: "Cormoret" },
    { zip: 2607, canton: "BE", commune: "Cortébert" },
    { zip: 2608, canton: "BE", commune: "Cortébert" },
    { zip: 2723, canton: "BE", commune: "Cortébert" },
    { zip: 2608, canton: "BE", commune: "Courtelary" },
    { zip: 2610, canton: "BE", commune: "Courtelary" },
    { zip: 2723, canton: "BE", commune: "Courtelary" },
    { zip: 2333, canton: "BE", commune: "La Ferrière" },
    { zip: 2720, canton: "BE", commune: "Mont-Tramelan" },
    { zip: 2723, canton: "BE", commune: "Mont-Tramelan" },
    { zip: 2534, canton: "BE", commune: "Orvin" },
    { zip: 2535, canton: "BE", commune: "Orvin" },
    { zip: 2616, canton: "BE", commune: "Renan (BE)" },
    { zip: 2536, canton: "BE", commune: "Romont (BE)" },
    { zip: 2538, canton: "BE", commune: "Romont (BE)" },
    { zip: 2603, canton: "BE", commune: "Romont (BE)" },
    { zip: 2345, canton: "BE", commune: "Saint-Imier" },
    { zip: 2610, canton: "BE", commune: "Saint-Imier" },
    { zip: 2605, canton: "BE", commune: "Sonceboz-Sombeval" },
    { zip: 2606, canton: "BE", commune: "Sonceboz-Sombeval" },
    { zip: 2720, canton: "BE", commune: "Sonceboz-Sombeval" },
    { zip: 2333, canton: "BE", commune: "Sonvilier" },
    { zip: 2345, canton: "BE", commune: "Sonvilier" },
    { zip: 2610, canton: "BE", commune: "Sonvilier" },
    { zip: 2615, canton: "BE", commune: "Sonvilier" },
    { zip: 2720, canton: "BE", commune: "Tramelan" },
    { zip: 2722, canton: "BE", commune: "Tramelan" },
    { zip: 2723, canton: "BE", commune: "Tramelan" },
    { zip: 2345, canton: "BE", commune: "Villeret" },
    { zip: 2610, canton: "BE", commune: "Villeret" },
    { zip: 2613, canton: "BE", commune: "Villeret" },
    { zip: 2535, canton: "BE", commune: "Sauge" },
    { zip: 2536, canton: "BE", commune: "Sauge" },
    { zip: 2537, canton: "BE", commune: "Sauge" },
    { zip: 2535, canton: "BE", commune: "Péry-La Heutte" },
    { zip: 2603, canton: "BE", commune: "Péry-La Heutte" },
    { zip: 2604, canton: "BE", commune: "Péry-La Heutte" },
    { zip: 2732, canton: "BE", commune: "Péry-La Heutte" },
    { zip: 2735, canton: "BE", commune: "Péry-La Heutte" },
    { zip: 3237, canton: "BE", commune: "Brüttelen" },
    { zip: 3232, canton: "BE", commune: "Erlach" },
    { zip: 3233, canton: "BE", commune: "Erlach" },
    { zip: 3235, canton: "BE", commune: "Erlach" },
    { zip: 2577, canton: "BE", commune: "Finsterhennen" },
    { zip: 2525, canton: "BE", commune: "Gals" },
    { zip: 3235, canton: "BE", commune: "Gals" },
    { zip: 3238, canton: "BE", commune: "Gals" },
    { zip: 3236, canton: "BE", commune: "Gampelen" },
    { zip: 3232, canton: "BE", commune: "Ins" },
    { zip: 3236, canton: "BE", commune: "Ins" },
    { zip: 2575, canton: "BE", commune: "Lüscherz" },
    { zip: 2576, canton: "BE", commune: "Lüscherz" },
    { zip: 3225, canton: "BE", commune: "Müntschemier" },
    { zip: 2577, canton: "BE", commune: "Siselen" },
    { zip: 3226, canton: "BE", commune: "Treiten" },
    { zip: 3233, canton: "BE", commune: "Tschugg" },
    { zip: 2576, canton: "BE", commune: "Vinelz" },
    { zip: 3234, canton: "BE", commune: "Vinelz" },
    { zip: 3314, canton: "BE", commune: "Bätterkinden" },
    { zip: 3315, canton: "BE", commune: "Bätterkinden" },
    { zip: 4573, canton: "BE", commune: "Bätterkinden" },
    { zip: 3053, canton: "BE", commune: "Deisswil b. Münchenbuch." },
    { zip: 3053, canton: "BE", commune: "Diemerswil" },
    { zip: 3306, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3308, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3309, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3312, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3313, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3314, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3317, canton: "BE", commune: "Fraubrunnen" },
    { zip: 3303, canton: "BE", commune: "Jegenstorf" },
    { zip: 3305, canton: "BE", commune: "Jegenstorf" },
    { zip: 3305, canton: "BE", commune: "Iffwil" },
    { zip: 3322, canton: "BE", commune: "Mattstetten" },
    { zip: 3053, canton: "BE", commune: "Moosseedorf" },
    { zip: 3302, canton: "BE", commune: "Moosseedorf" },
    { zip: 3322, canton: "BE", commune: "Moosseedorf" },
    { zip: 3052, canton: "BE", commune: "Münchenbuchsee" },
    { zip: 3053, canton: "BE", commune: "Münchenbuchsee" },
    { zip: 3322, canton: "BE", commune: "Urtenen-Schönbühl" },
    { zip: 3427, canton: "BE", commune: "Utzenstorf" },
    { zip: 3053, canton: "BE", commune: "Wiggiswil" },
    { zip: 3427, canton: "BE", commune: "Wiler bei Utzenstorf" },
    { zip: 3428, canton: "BE", commune: "Wiler bei Utzenstorf" },
    { zip: 4564, canton: "BE", commune: "Zielebach" },
    { zip: 3303, canton: "BE", commune: "Zuzwil (BE)" },
    { zip: 3715, canton: "BE", commune: "Adelboden" },
    { zip: 3725, canton: "BE", commune: "Adelboden" },
    { zip: 3702, canton: "BE", commune: "Aeschi bei Spiez" },
    { zip: 3703, canton: "BE", commune: "Aeschi bei Spiez" },
    { zip: 3704, canton: "BE", commune: "Aeschi bei Spiez" },
    { zip: 3711, canton: "BE", commune: "Aeschi bei Spiez" },
    { zip: 3713, canton: "BE", commune: "Frutigen" },
    { zip: 3714, canton: "BE", commune: "Frutigen" },
    { zip: 3715, canton: "BE", commune: "Frutigen" },
    { zip: 3716, canton: "BE", commune: "Frutigen" },
    { zip: 3724, canton: "BE", commune: "Frutigen" },
    { zip: 3725, canton: "BE", commune: "Frutigen" },
    { zip: 3716, canton: "BE", commune: "Kandergrund" },
    { zip: 3717, canton: "BE", commune: "Kandergrund" },
    { zip: 3718, canton: "BE", commune: "Kandersteg" },
    { zip: 3704, canton: "BE", commune: "Krattigen" },
    { zip: 3711, canton: "BE", commune: "Reichenbach im Kandertal" },
    { zip: 3713, canton: "BE", commune: "Reichenbach im Kandertal" },
    { zip: 3714, canton: "BE", commune: "Reichenbach im Kandertal" },
    { zip: 3722, canton: "BE", commune: "Reichenbach im Kandertal" },
    { zip: 3723, canton: "BE", commune: "Reichenbach im Kandertal" },
    { zip: 3800, canton: "BE", commune: "Beatenberg" },
    { zip: 3803, canton: "BE", commune: "Beatenberg" },
    { zip: 3806, canton: "BE", commune: "Bönigen" },
    { zip: 3855, canton: "BE", commune: "Brienz (BE)" },
    { zip: 3856, canton: "BE", commune: "Brienz (BE)" },
    { zip: 3856, canton: "BE", commune: "Brienzwiler" },
    { zip: 3706, canton: "BE", commune: "Därligen" },
    { zip: 3707, canton: "BE", commune: "Därligen" },
    { zip: 3816, canton: "BE", commune: "Grindelwald" },
    { zip: 3818, canton: "BE", commune: "Grindelwald" },
    { zip: 3823, canton: "BE", commune: "Grindelwald" },
    { zip: 3800, canton: "BE", commune: "Gsteigwiler" },
    { zip: 3813, canton: "BE", commune: "Gsteigwiler" },
    { zip: 3814, canton: "BE", commune: "Gsteigwiler" },
    { zip: 3815, canton: "BE", commune: "Gündlischwand" },
    { zip: 3804, canton: "BE", commune: "Habkern" },
    { zip: 3858, canton: "BE", commune: "Hofstetten bei Brienz" },
    { zip: 3800, canton: "BE", commune: "Interlaken" },
    { zip: 3807, canton: "BE", commune: "Iseltwald" },
    { zip: 3822, canton: "BE", commune: "Lauterbrunnen" },
    { zip: 3823, canton: "BE", commune: "Lauterbrunnen" },
    { zip: 3824, canton: "BE", commune: "Lauterbrunnen" },
    { zip: 3825, canton: "BE", commune: "Lauterbrunnen" },
    { zip: 3826, canton: "BE", commune: "Lauterbrunnen" },
    { zip: 3706, canton: "BE", commune: "Leissigen" },
    { zip: 3816, canton: "BE", commune: "Lütschental" },
    { zip: 3800, canton: "BE", commune: "Matten bei Interlaken" },
    { zip: 3853, canton: "BE", commune: "Niederried b. Interlaken" },
    { zip: 3854, canton: "BE", commune: "Oberried am Brienzersee" },
    { zip: 3855, canton: "BE", commune: "Oberried am Brienzersee" },
    { zip: 3805, canton: "BE", commune: "Ringgenberg (BE)" },
    { zip: 3852, canton: "BE", commune: "Ringgenberg (BE)" },
    { zip: 3813, canton: "BE", commune: "Saxeten" },
    { zip: 3855, canton: "BE", commune: "Schwanden bei Brienz" },
    { zip: 3800, canton: "BE", commune: "Unterseen" },
    { zip: 3800, canton: "BE", commune: "Wilderswil" },
    { zip: 3812, canton: "BE", commune: "Wilderswil" },
    { zip: 3815, canton: "BE", commune: "Wilderswil" },
    { zip: 3507, canton: "BE", commune: "Arni (BE)" },
    { zip: 3508, canton: "BE", commune: "Arni (BE)" },
    { zip: 3507, canton: "BE", commune: "Biglen" },
    { zip: 3531, canton: "BE", commune: "Bowil" },
    { zip: 3533, canton: "BE", commune: "Bowil" },
    { zip: 3534, canton: "BE", commune: "Bowil" },
    { zip: 3538, canton: "BE", commune: "Bowil" },
    { zip: 3673, canton: "BE", commune: "Bowil" },
    { zip: 3671, canton: "BE", commune: "Brenzikofen" },
    { zip: 3510, canton: "BE", commune: "Freimettigen" },
    { zip: 3506, canton: "BE", commune: "Grosshöchstetten" },
    { zip: 3510, canton: "BE", commune: "Häutligen" },
    { zip: 3671, canton: "BE", commune: "Herbligen" },
    { zip: 3114, canton: "BE", commune: "Kiesen" },
    { zip: 3629, canton: "BE", commune: "Kiesen" },
    { zip: 3503, canton: "BE", commune: "Konolfingen" },
    { zip: 3510, canton: "BE", commune: "Konolfingen" },
    { zip: 3434, canton: "BE", commune: "Landiswil" },
    { zip: 3508, canton: "BE", commune: "Landiswil" },
    { zip: 3538, canton: "BE", commune: "Linden" },
    { zip: 3615, canton: "BE", commune: "Linden" },
    { zip: 3672, canton: "BE", commune: "Linden" },
    { zip: 3673, canton: "BE", commune: "Linden" },
    { zip: 3506, canton: "BE", commune: "Mirchel" },
    { zip: 3532, canton: "BE", commune: "Mirchel" },
    { zip: 3083, canton: "BE", commune: "Münsingen" },
    { zip: 3110, canton: "BE", commune: "Münsingen" },
    { zip: 3111, canton: "BE", commune: "Münsingen" },
    { zip: 3504, canton: "BE", commune: "Niederhünigen" },
    { zip: 3672, canton: "BE", commune: "Oberdiessbach" },
    { zip: 3674, canton: "BE", commune: "Oberdiessbach" },
    { zip: 3506, canton: "BE", commune: "Oberthal" },
    { zip: 3508, canton: "BE", commune: "Oberthal" },
    { zip: 3531, canton: "BE", commune: "Oberthal" },
    { zip: 3629, canton: "BE", commune: "Oppligen" },
    { zip: 3112, canton: "BE", commune: "Rubigen" },
    { zip: 3113, canton: "BE", commune: "Rubigen" },
    { zip: 3082, canton: "BE", commune: "Schlosswil" },
    { zip: 3068, canton: "BE", commune: "Walkringen" },
    { zip: 3512, canton: "BE", commune: "Walkringen" },
    { zip: 3513, canton: "BE", commune: "Walkringen" },
    { zip: 3068, canton: "BE", commune: "Worb" },
    { zip: 3075, canton: "BE", commune: "Worb" },
    { zip: 3076, canton: "BE", commune: "Worb" },
    { zip: 3077, canton: "BE", commune: "Worb" },
    { zip: 3078, canton: "BE", commune: "Worb" },
    { zip: 3082, canton: "BE", commune: "Worb" },
    { zip: 3113, canton: "BE", commune: "Worb" },
    { zip: 3506, canton: "BE", commune: "Zäziwil" },
    { zip: 3531, canton: "BE", commune: "Zäziwil" },
    { zip: 3532, canton: "BE", commune: "Zäziwil" },
    { zip: 3533, canton: "BE", commune: "Zäziwil" },
    { zip: 3504, canton: "BE", commune: "Oberhünigen" },
    { zip: 3532, canton: "BE", commune: "Oberhünigen" },
    { zip: 3533, canton: "BE", commune: "Oberhünigen" },
    { zip: 3673, canton: "BE", commune: "Oberhünigen" },
    { zip: 3112, canton: "BE", commune: "Allmendingen" },
    { zip: 3114, canton: "BE", commune: "Wichtrach" },
    { zip: 3510, canton: "BE", commune: "Wichtrach" },
    { zip: 1595, canton: "BE", commune: "Clavaleyres" },
    { zip: 3177, canton: "BE", commune: "Ferenbalm" },
    { zip: 3205, canton: "BE", commune: "Ferenbalm" },
    { zip: 3206, canton: "BE", commune: "Ferenbalm" },
    { zip: 3207, canton: "BE", commune: "Ferenbalm" },
    { zip: 3020, canton: "BE", commune: "Frauenkappelen" },
    { zip: 3033, canton: "BE", commune: "Frauenkappelen" },
    { zip: 3202, canton: "BE", commune: "Frauenkappelen" },
    { zip: 3207, canton: "BE", commune: "Golaten" },
    { zip: 3208, canton: "BE", commune: "Gurbrü" },
    { zip: 3210, canton: "BE", commune: "Gurbrü" },
    { zip: 3179, canton: "BE", commune: "Kriechenwil" },
    { zip: 3177, canton: "BE", commune: "Laupen" },
    { zip: 3202, canton: "BE", commune: "Mühleberg" },
    { zip: 3203, canton: "BE", commune: "Mühleberg" },
    { zip: 3204, canton: "BE", commune: "Mühleberg" },
    { zip: 3205, canton: "BE", commune: "Mühleberg" },
    { zip: 1797, canton: "BE", commune: "Münchenwiler" },
    { zip: 3174, canton: "BE", commune: "Neuenegg" },
    { zip: 3176, canton: "BE", commune: "Neuenegg" },
    { zip: 3177, canton: "BE", commune: "Neuenegg" },
    { zip: 3204, canton: "BE", commune: "Neuenegg" },
    { zip: 3207, canton: "BE", commune: "Wileroltigen" },
    { zip: 2744, canton: "BE", commune: "Belprahon" },
    { zip: 2735, canton: "BE", commune: "Champoz" },
    { zip: 2747, canton: "BE", commune: "Corcelles (BE)" },
    { zip: 2735, canton: "BE", commune: "Court" },
    { zip: 2738, canton: "BE", commune: "Court" },
    { zip: 2746, canton: "BE", commune: "Crémines" },
    { zip: 2747, canton: "BE", commune: "Crémines" },
    { zip: 4716, canton: "BE", commune: "Crémines" },
    { zip: 2743, canton: "BE", commune: "Eschert" },
    { zip: 2745, canton: "BE", commune: "Grandval" },
    { zip: 2732, canton: "BE", commune: "Loveresse" },
    { zip: 2740, canton: "BE", commune: "Moutier" },
    { zip: 2740, canton: "BE", commune: "Perrefitte" },
    { zip: 2742, canton: "BE", commune: "Perrefitte" },
    { zip: 2748, canton: "BE", commune: "Perrefitte" },
    { zip: 2710, canton: "BE", commune: "Reconvilier" },
    { zip: 2732, canton: "BE", commune: "Reconvilier" },
    { zip: 2740, canton: "BE", commune: "Roches (BE)" },
    { zip: 2762, canton: "BE", commune: "Roches (BE)" },
    { zip: 2712, canton: "BE", commune: "Saicourt" },
    { zip: 2713, canton: "BE", commune: "Saicourt" },
    { zip: 2720, canton: "BE", commune: "Saicourt" },
    { zip: 2732, canton: "BE", commune: "Saicourt" },
    { zip: 2732, canton: "BE", commune: "Saules (BE)" },
    { zip: 2827, canton: "BE", commune: "Schelten" },
    { zip: 2747, canton: "BE", commune: "Seehof" },
    { zip: 2736, canton: "BE", commune: "Sorvilier" },
    { zip: 2710, canton: "BE", commune: "Tavannes" },
    { zip: 2720, canton: "BE", commune: "Tavannes" },
    { zip: 2717, canton: "BE", commune: "Rebévelier" },
    { zip: 2712, canton: "BE", commune: "Petit-Val" },
    { zip: 2715, canton: "BE", commune: "Petit-Val" },
    { zip: 2716, canton: "BE", commune: "Petit-Val" },
    { zip: 2717, canton: "BE", commune: "Petit-Val" },
    { zip: 2748, canton: "BE", commune: "Petit-Val" },
    { zip: 2733, canton: "BE", commune: "Valbirse" },
    { zip: 2735, canton: "BE", commune: "Valbirse" },
    { zip: 2514, canton: "BE", commune: "La Neuveville" },
    { zip: 2520, canton: "BE", commune: "La Neuveville" },
    { zip: 2523, canton: "BE", commune: "La Neuveville" },
    { zip: 2518, canton: "BE", commune: "Nods" },
    { zip: 2523, canton: "BE", commune: "Nods" },
    { zip: 2534, canton: "BE", commune: "Nods" },
    { zip: 2515, canton: "BE", commune: "Plateau de Diesse" },
    { zip: 2516, canton: "BE", commune: "Plateau de Diesse" },
    { zip: 2517, canton: "BE", commune: "Plateau de Diesse" },
    { zip: 2523, canton: "BE", commune: "Plateau de Diesse" },
    { zip: 2558, canton: "BE", commune: "Aegerten" },
    { zip: 2562, canton: "BE", commune: "Bellmund" },
    { zip: 2563, canton: "BE", commune: "Bellmund" },
    { zip: 2564, canton: "BE", commune: "Bellmund" },
    { zip: 2503, canton: "BE", commune: "Brügg" },
    { zip: 2504, canton: "BE", commune: "Brügg" },
    { zip: 2552, canton: "BE", commune: "Brügg" },
    { zip: 2555, canton: "BE", commune: "Brügg" },
    { zip: 3274, canton: "BE", commune: "Bühl" },
    { zip: 3272, canton: "BE", commune: "Epsach" },
    { zip: 2575, canton: "BE", commune: "Hagneck" },
    { zip: 3274, canton: "BE", commune: "Hermrigen" },
    { zip: 2565, canton: "BE", commune: "Jens" },
    { zip: 2563, canton: "BE", commune: "Ipsach" },
    { zip: 2513, canton: "BE", commune: "Ligerz" },
    { zip: 2514, canton: "BE", commune: "Ligerz" },
    { zip: 3274, canton: "BE", commune: "Merzligen" },
    { zip: 2572, canton: "BE", commune: "Mörigen" },
    { zip: 2560, canton: "BE", commune: "Nidau" },
    { zip: 2504, canton: "BE", commune: "Orpund" },
    { zip: 2552, canton: "BE", commune: "Orpund" },
    { zip: 2560, canton: "BE", commune: "Port" },
    { zip: 2562, canton: "BE", commune: "Port" },
    { zip: 2553, canton: "BE", commune: "Safnern" },
    { zip: 2556, canton: "BE", commune: "Scheuren" },
    { zip: 2556, canton: "BE", commune: "Schwadernau" },
    { zip: 2558, canton: "BE", commune: "Schwadernau" },
    { zip: 2557, canton: "BE", commune: "Studen (BE)" },
    { zip: 2572, canton: "BE", commune: "Sutz-Lattrigen" },
    { zip: 2575, canton: "BE", commune: "Täuffelen" },
    { zip: 3272, canton: "BE", commune: "Walperswil" },
    { zip: 3252, canton: "BE", commune: "Worben" },
    { zip: 2505, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 2512, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 2513, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 2516, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 2532, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 3235, canton: "BE", commune: "Twann-Tüscherz" },
    { zip: 3763, canton: "BE", commune: "Därstetten" },
    { zip: 3764, canton: "BE", commune: "Därstetten" },
    { zip: 3753, canton: "BE", commune: "Diemtigen" },
    { zip: 3754, canton: "BE", commune: "Diemtigen" },
    { zip: 3755, canton: "BE", commune: "Diemtigen" },
    { zip: 3756, canton: "BE", commune: "Diemtigen" },
    { zip: 3757, canton: "BE", commune: "Diemtigen" },
    { zip: 3754, canton: "BE", commune: "Erlenbach im Simmental" },
    { zip: 3758, canton: "BE", commune: "Erlenbach im Simmental" },
    { zip: 3762, canton: "BE", commune: "Erlenbach im Simmental" },
    { zip: 3764, canton: "BE", commune: "Oberwil im Simmental" },
    { zip: 3765, canton: "BE", commune: "Oberwil im Simmental" },
    { zip: 3766, canton: "BE", commune: "Oberwil im Simmental" },
    { zip: 3647, canton: "BE", commune: "Reutigen" },
    { zip: 3645, canton: "BE", commune: "Spiez" },
    { zip: 3646, canton: "BE", commune: "Spiez" },
    { zip: 3700, canton: "BE", commune: "Spiez" },
    { zip: 3702, canton: "BE", commune: "Spiez" },
    { zip: 3704, canton: "BE", commune: "Spiez" },
    { zip: 3705, canton: "BE", commune: "Spiez" },
    { zip: 3711, canton: "BE", commune: "Wimmis" },
    { zip: 3752, canton: "BE", commune: "Wimmis" },
    { zip: 3631, canton: "BE", commune: "Stocken-Höfen" },
    { zip: 3632, canton: "BE", commune: "Stocken-Höfen" },
    { zip: 3864, canton: "BE", commune: "Guttannen" },
    { zip: 6083, canton: "BE", commune: "Hasliberg" },
    { zip: 6084, canton: "BE", commune: "Hasliberg" },
    { zip: 6085, canton: "BE", commune: "Hasliberg" },
    { zip: 6086, canton: "BE", commune: "Hasliberg" },
    { zip: 3862, canton: "BE", commune: "Innertkirchen" },
    { zip: 3863, canton: "BE", commune: "Innertkirchen" },
    { zip: 3856, canton: "BE", commune: "Meiringen" },
    { zip: 3857, canton: "BE", commune: "Meiringen" },
    { zip: 3860, canton: "BE", commune: "Meiringen" },
    { zip: 3860, canton: "BE", commune: "Schattenhalb" },
    { zip: 1657, canton: "BE", commune: "Boltigen" },
    { zip: 3766, canton: "BE", commune: "Boltigen" },
    { zip: 3770, canton: "BE", commune: "Boltigen" },
    { zip: 3773, canton: "BE", commune: "Lenk" },
    { zip: 3775, canton: "BE", commune: "Lenk" },
    { zip: 3772, canton: "BE", commune: "St. Stephan" },
    { zip: 3773, canton: "BE", commune: "St. Stephan" },
    { zip: 3770, canton: "BE", commune: "Zweisimmen" },
    { zip: 3771, canton: "BE", commune: "Zweisimmen" },
    { zip: 3776, canton: "BE", commune: "Zweisimmen" },
    { zip: 3777, canton: "BE", commune: "Zweisimmen" },
    { zip: 3784, canton: "BE", commune: "Gsteig" },
    { zip: 3785, canton: "BE", commune: "Gsteig" },
    { zip: 3782, canton: "BE", commune: "Lauenen" },
    { zip: 1657, canton: "BE", commune: "Saanen" },
    { zip: 3777, canton: "BE", commune: "Saanen" },
    { zip: 3778, canton: "BE", commune: "Saanen" },
    { zip: 3780, canton: "BE", commune: "Saanen" },
    { zip: 3781, canton: "BE", commune: "Saanen" },
    { zip: 3783, canton: "BE", commune: "Saanen" },
    { zip: 3792, canton: "BE", commune: "Saanen" },
    { zip: 1738, canton: "BE", commune: "Guggisberg" },
    { zip: 3150, canton: "BE", commune: "Guggisberg" },
    { zip: 3156, canton: "BE", commune: "Guggisberg" },
    { zip: 3157, canton: "BE", commune: "Guggisberg" },
    { zip: 3158, canton: "BE", commune: "Guggisberg" },
    { zip: 3159, canton: "BE", commune: "Guggisberg" },
    { zip: 1738, canton: "BE", commune: "Rüschegg" },
    { zip: 3099, canton: "BE", commune: "Rüschegg" },
    { zip: 3152, canton: "BE", commune: "Rüschegg" },
    { zip: 3153, canton: "BE", commune: "Rüschegg" },
    { zip: 3154, canton: "BE", commune: "Rüschegg" },
    { zip: 3156, canton: "BE", commune: "Rüschegg" },
    { zip: 3157, canton: "BE", commune: "Rüschegg" },
    { zip: 3148, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3150, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3152, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3154, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3157, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3183, canton: "BE", commune: "Schwarzenburg" },
    { zip: 3086, canton: "BE", commune: "Belp" },
    { zip: 3115, canton: "BE", commune: "Belp" },
    { zip: 3122, canton: "BE", commune: "Belp" },
    { zip: 3123, canton: "BE", commune: "Belp" },
    { zip: 3124, canton: "BE", commune: "Belp" },
    { zip: 3125, canton: "BE", commune: "Belp" },
    { zip: 3664, canton: "BE", commune: "Burgistein" },
    { zip: 3665, canton: "BE", commune: "Burgistein" },
    { zip: 3125, canton: "BE", commune: "Gelterfingen" },
    { zip: 3126, canton: "BE", commune: "Gelterfingen" },
    { zip: 3115, canton: "BE", commune: "Gerzensee" },
    { zip: 3663, canton: "BE", commune: "Gurzelen" },
    { zip: 3664, canton: "BE", commune: "Gurzelen" },
    { zip: 3629, canton: "BE", commune: "Jaberg" },
    { zip: 3126, canton: "BE", commune: "Kaufdorf" },
    { zip: 3122, canton: "BE", commune: "Kehrsatz" },
    { zip: 3123, canton: "BE", commune: "Kehrsatz" },
    { zip: 3116, canton: "BE", commune: "Kirchdorf (BE)" },
    { zip: 3629, canton: "BE", commune: "Kirchdorf (BE)" },
    { zip: 3128, canton: "BE", commune: "Kirchenthurnen" },
    { zip: 3127, canton: "BE", commune: "Lohnstorf" },
    { zip: 3115, canton: "BE", commune: "Mühledorf (BE)" },
    { zip: 3116, canton: "BE", commune: "Mühledorf (BE)" },
    { zip: 3127, canton: "BE", commune: "Mühlethurnen" },
    { zip: 3128, canton: "BE", commune: "Mühlethurnen" },
    { zip: 3086, canton: "BE", commune: "Niedermuhlern" },
    { zip: 3087, canton: "BE", commune: "Niedermuhlern" },
    { zip: 3116, canton: "BE", commune: "Noflen" },
    { zip: 3099, canton: "BE", commune: "Riggisberg" },
    { zip: 3132, canton: "BE", commune: "Riggisberg" },
    { zip: 3155, canton: "BE", commune: "Riggisberg" },
    { zip: 3664, canton: "BE", commune: "Riggisberg" },
    { zip: 3087, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3088, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3089, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3099, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3132, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3154, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3155, canton: "BE", commune: "Rüeggisberg" },
    { zip: 3128, canton: "BE", commune: "Rümligen" },
    { zip: 3132, canton: "BE", commune: "Rümligen" },
    { zip: 3662, canton: "BE", commune: "Seftigen" },
    { zip: 3123, canton: "BE", commune: "Toffen" },
    { zip: 3125, canton: "BE", commune: "Toffen" },
    { zip: 3628, canton: "BE", commune: "Uttigen" },
    { zip: 3664, canton: "BE", commune: "Wattenwil" },
    { zip: 3665, canton: "BE", commune: "Wattenwil" },
    { zip: 3086, canton: "BE", commune: "Wald (BE)" },
    { zip: 3087, canton: "BE", commune: "Wald (BE)" },
    { zip: 3096, canton: "BE", commune: "Wald (BE)" },
    { zip: 3536, canton: "BE", commune: "Eggiwil" },
    { zip: 3537, canton: "BE", commune: "Eggiwil" },
    { zip: 3550, canton: "BE", commune: "Eggiwil" },
    { zip: 3618, canton: "BE", commune: "Eggiwil" },
    { zip: 6197, canton: "BE", commune: "Eggiwil" },
    { zip: 3535, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3543, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3550, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3551, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3552, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3553, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3555, canton: "BE", commune: "Langnau im Emmental" },
    { zip: 3434, canton: "BE", commune: "Lauperswil" },
    { zip: 3436, canton: "BE", commune: "Lauperswil" },
    { zip: 3438, canton: "BE", commune: "Lauperswil" },
    { zip: 3543, canton: "BE", commune: "Lauperswil" },
    { zip: 3550, canton: "BE", commune: "Lauperswil" },
    { zip: 3551, canton: "BE", commune: "Lauperswil" },
    { zip: 3533, canton: "BE", commune: "Röthenbach im Emmental" },
    { zip: 3537, canton: "BE", commune: "Röthenbach im Emmental" },
    { zip: 3538, canton: "BE", commune: "Röthenbach im Emmental" },
    { zip: 3615, canton: "BE", commune: "Röthenbach im Emmental" },
    { zip: 3618, canton: "BE", commune: "Röthenbach im Emmental" },
    { zip: 3432, canton: "BE", commune: "Rüderswil" },
    { zip: 3433, canton: "BE", commune: "Rüderswil" },
    { zip: 3436, canton: "BE", commune: "Rüderswil" },
    { zip: 3437, canton: "BE", commune: "Rüderswil" },
    { zip: 3438, canton: "BE", commune: "Rüderswil" },
    { zip: 3439, canton: "BE", commune: "Rüderswil" },
    { zip: 3453, canton: "BE", commune: "Rüderswil" },
    { zip: 6197, canton: "BE", commune: "Schangnau" },
    { zip: 3534, canton: "BE", commune: "Signau" },
    { zip: 3535, canton: "BE", commune: "Signau" },
    { zip: 3543, canton: "BE", commune: "Signau" },
    { zip: 3537, canton: "BE", commune: "Trub" },
    { zip: 3552, canton: "BE", commune: "Trub" },
    { zip: 3555, canton: "BE", commune: "Trub" },
    { zip: 3556, canton: "BE", commune: "Trub" },
    { zip: 3557, canton: "BE", commune: "Trub" },
    { zip: 3537, canton: "BE", commune: "Trubschachen" },
    { zip: 3555, canton: "BE", commune: "Trubschachen" },
    { zip: 3556, canton: "BE", commune: "Trubschachen" },
    { zip: 3633, canton: "BE", commune: "Amsoldingen" },
    { zip: 3638, canton: "BE", commune: "Blumenstein" },
    { zip: 3614, canton: "BE", commune: "Buchholterberg" },
    { zip: 3615, canton: "BE", commune: "Buchholterberg" },
    { zip: 3618, canton: "BE", commune: "Buchholterberg" },
    { zip: 3674, canton: "BE", commune: "Buchholterberg" },
    { zip: 3616, canton: "BE", commune: "Eriz" },
    { zip: 3619, canton: "BE", commune: "Eriz" },
    { zip: 6197, canton: "BE", commune: "Eriz" },
    { zip: 3612, canton: "BE", commune: "Fahrni" },
    { zip: 3617, canton: "BE", commune: "Fahrni" },
    { zip: 3625, canton: "BE", commune: "Heiligenschwendi" },
    { zip: 3613, canton: "BE", commune: "Heimberg" },
    { zip: 3627, canton: "BE", commune: "Heimberg" },
    { zip: 3671, canton: "BE", commune: "Heimberg" },
    { zip: 3600, canton: "BE", commune: "Hilterfingen" },
    { zip: 3625, canton: "BE", commune: "Hilterfingen" },
    { zip: 3626, canton: "BE", commune: "Hilterfingen" },
    { zip: 3652, canton: "BE", commune: "Hilterfingen" },
    { zip: 3622, canton: "BE", commune: "Homberg" },
    { zip: 3624, canton: "BE", commune: "Homberg" },
    { zip: 3619, canton: "BE", commune: "Horrenbach-Buchen" },
    { zip: 3623, canton: "BE", commune: "Horrenbach-Buchen" },
    { zip: 3652, canton: "BE", commune: "Oberhofen am Thunersee" },
    { zip: 3653, canton: "BE", commune: "Oberhofen am Thunersee" },
    { zip: 3654, canton: "BE", commune: "Oberhofen am Thunersee" },
    { zip: 3616, canton: "BE", commune: "Oberlangenegg" },
    { zip: 3618, canton: "BE", commune: "Oberlangenegg" },
    { zip: 3638, canton: "BE", commune: "Pohlern" },
    { zip: 3612, canton: "BE", commune: "Schwendibach" },
    { zip: 3624, canton: "BE", commune: "Schwendibach" },
    { zip: 3619, canton: "BE", commune: "Sigriswil" },
    { zip: 3623, canton: "BE", commune: "Sigriswil" },
    { zip: 3654, canton: "BE", commune: "Sigriswil" },
    { zip: 3655, canton: "BE", commune: "Sigriswil" },
    { zip: 3656, canton: "BE", commune: "Sigriswil" },
    { zip: 3657, canton: "BE", commune: "Sigriswil" },
    { zip: 3658, canton: "BE", commune: "Sigriswil" },
    { zip: 3612, canton: "BE", commune: "Steffisburg" },
    { zip: 3613, canton: "BE", commune: "Steffisburg" },
    { zip: 3617, canton: "BE", commune: "Steffisburg" },
    { zip: 3627, canton: "BE", commune: "Steffisburg" },
    { zip: 3623, canton: "BE", commune: "Teuffenthal (BE)" },
    { zip: 3633, canton: "BE", commune: "Thierachern" },
    { zip: 3634, canton: "BE", commune: "Thierachern" },
    { zip: 3635, canton: "BE", commune: "Thierachern" },
    { zip: 3636, canton: "BE", commune: "Thierachern" },
    { zip: 3600, canton: "BE", commune: "Thun" },
    { zip: 3603, canton: "BE", commune: "Thun" },
    { zip: 3604, canton: "BE", commune: "Thun" },
    { zip: 3608, canton: "BE", commune: "Thun" },
    { zip: 3612, canton: "BE", commune: "Thun" },
    { zip: 3624, canton: "BE", commune: "Thun" },
    { zip: 3626, canton: "BE", commune: "Thun" },
    { zip: 3645, canton: "BE", commune: "Thun" },
    { zip: 3635, canton: "BE", commune: "Uebeschi" },
    { zip: 3661, canton: "BE", commune: "Uetendorf" },
    { zip: 3614, canton: "BE", commune: "Unterlangenegg" },
    { zip: 3616, canton: "BE", commune: "Unterlangenegg" },
    { zip: 3618, canton: "BE", commune: "Wachseldorn" },
    { zip: 3645, canton: "BE", commune: "Zwieselberg" },
    { zip: 3636, canton: "BE", commune: "Forst-Längenbühl" },
    { zip: 3663, canton: "BE", commune: "Forst-Längenbühl" },
    { zip: 3665, canton: "BE", commune: "Forst-Längenbühl" },
    { zip: 3413, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3416, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3418, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3462, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3463, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3464, canton: "BE", commune: "Affoltern im Emmental" },
    { zip: 3463, canton: "BE", commune: "Dürrenroth" },
    { zip: 3464, canton: "BE", commune: "Dürrenroth" },
    { zip: 3465, canton: "BE", commune: "Dürrenroth" },
    { zip: 4942, canton: "BE", commune: "Dürrenroth" },
    { zip: 4952, canton: "BE", commune: "Eriswil" },
    { zip: 4938, canton: "BE", commune: "Huttwil" },
    { zip: 4950, canton: "BE", commune: "Huttwil" },
    { zip: 4952, canton: "BE", commune: "Huttwil" },
    { zip: 4953, canton: "BE", commune: "Huttwil" },
    { zip: 3414, canton: "BE", commune: "Lützelflüh" },
    { zip: 3415, canton: "BE", commune: "Lützelflüh" },
    { zip: 3418, canton: "BE", commune: "Lützelflüh" },
    { zip: 3419, canton: "BE", commune: "Lützelflüh" },
    { zip: 3432, canton: "BE", commune: "Lützelflüh" },
    { zip: 3433, canton: "BE", commune: "Lützelflüh" },
    { zip: 3434, canton: "BE", commune: "Lützelflüh" },
    { zip: 3435, canton: "BE", commune: "Lützelflüh" },
    { zip: 3439, canton: "BE", commune: "Lützelflüh" },
    { zip: 3452, canton: "BE", commune: "Lützelflüh" },
    { zip: 3453, canton: "BE", commune: "Lützelflüh" },
    { zip: 3454, canton: "BE", commune: "Lützelflüh" },
    { zip: 3456, canton: "BE", commune: "Lützelflüh" },
    { zip: 3415, canton: "BE", commune: "Rüegsau" },
    { zip: 3416, canton: "BE", commune: "Rüegsau" },
    { zip: 3417, canton: "BE", commune: "Rüegsau" },
    { zip: 3418, canton: "BE", commune: "Rüegsau" },
    { zip: 3454, canton: "BE", commune: "Rüegsau" },
    { zip: 3416, canton: "BE", commune: "Sumiswald" },
    { zip: 3454, canton: "BE", commune: "Sumiswald" },
    { zip: 3455, canton: "BE", commune: "Sumiswald" },
    { zip: 3457, canton: "BE", commune: "Sumiswald" },
    { zip: 3462, canton: "BE", commune: "Sumiswald" },
    { zip: 4952, canton: "BE", commune: "Sumiswald" },
    { zip: 4954, canton: "BE", commune: "Sumiswald" },
    { zip: 3453, canton: "BE", commune: "Trachselwald" },
    { zip: 3456, canton: "BE", commune: "Trachselwald" },
    { zip: 3551, canton: "BE", commune: "Trachselwald" },
    { zip: 3463, canton: "BE", commune: "Walterswil (BE)" },
    { zip: 3464, canton: "BE", commune: "Walterswil (BE)" },
    { zip: 4942, canton: "BE", commune: "Walterswil (BE)" },
    { zip: 4943, canton: "BE", commune: "Walterswil (BE)" },
    { zip: 3457, canton: "BE", commune: "Wyssachen" },
    { zip: 4953, canton: "BE", commune: "Wyssachen" },
    { zip: 4954, canton: "BE", commune: "Wyssachen" },
    { zip: 4536, canton: "BE", commune: "Attiswil" },
    { zip: 3376, canton: "BE", commune: "Berken" },
    { zip: 3366, canton: "BE", commune: "Bettenhausen" },
    { zip: 4539, canton: "BE", commune: "Farnern" },
    { zip: 3376, canton: "BE", commune: "Graben" },
    { zip: 3372, canton: "BE", commune: "Heimenhausen" },
    { zip: 3373, canton: "BE", commune: "Heimenhausen" },
    { zip: 3360, canton: "BE", commune: "Herzogenbuchsee" },
    { zip: 3363, canton: "BE", commune: "Herzogenbuchsee" },
    { zip: 3375, canton: "BE", commune: "Inkwil" },
    { zip: 4704, canton: "BE", commune: "Niederbipp" },
    { zip: 3362, canton: "BE", commune: "Niederönz" },
    { zip: 4556, canton: "BE", commune: "Niederönz" },
    { zip: 4538, canton: "BE", commune: "Oberbipp" },
    { zip: 3367, canton: "BE", commune: "Ochlenberg" },
    { zip: 3476, canton: "BE", commune: "Ochlenberg" },
    { zip: 4539, canton: "BE", commune: "Rumisberg" },
    { zip: 3365, canton: "BE", commune: "Seeberg" },
    { zip: 3474, canton: "BE", commune: "Seeberg" },
    { zip: 3475, canton: "BE", commune: "Seeberg" },
    { zip: 3476, canton: "BE", commune: "Seeberg" },
    { zip: 4943, canton: "BE", commune: "Seeberg" },
    { zip: 3367, canton: "BE", commune: "Thörigen" },
    { zip: 3476, canton: "BE", commune: "Thörigen" },
    { zip: 3380, canton: "BE", commune: "Walliswil bei Niederbipp" },
    { zip: 3377, canton: "BE", commune: "Walliswil bei Wangen" },
    { zip: 3380, canton: "BE", commune: "Wangen an der Aare" },
    { zip: 4536, canton: "BE", commune: "Wangen an der Aare" },
    { zip: 3374, canton: "BE", commune: "Wangenried" },
    { zip: 3380, canton: "BE", commune: "Wiedlisbach" },
    { zip: 4537, canton: "BE", commune: "Wiedlisbach" },
    { zip: 4704, canton: "BE", commune: "Wolfisberg" },
    { zip: 6110, canton: "LU", commune: "Doppleschwand" },
    { zip: 6112, canton: "LU", commune: "Doppleschwand" },
    { zip: 6105, canton: "LU", commune: "Entlebuch" },
    { zip: 6110, canton: "LU", commune: "Entlebuch" },
    { zip: 6162, canton: "LU", commune: "Entlebuch" },
    { zip: 6163, canton: "LU", commune: "Entlebuch" },
    { zip: 6166, canton: "LU", commune: "Entlebuch" },
    { zip: 6170, canton: "LU", commune: "Flühli" },
    { zip: 6173, canton: "LU", commune: "Flühli" },
    { zip: 6174, canton: "LU", commune: "Flühli" },
    { zip: 6192, canton: "LU", commune: "Flühli" },
    { zip: 6197, canton: "LU", commune: "Flühli" },
    { zip: 6162, canton: "LU", commune: "Hasle (LU)" },
    { zip: 6166, canton: "LU", commune: "Hasle (LU)" },
    { zip: 6170, canton: "LU", commune: "Hasle (LU)" },
    { zip: 6110, canton: "LU", commune: "Romoos" },
    { zip: 6113, canton: "LU", commune: "Romoos" },
    { zip: 6166, canton: "LU", commune: "Romoos" },
    { zip: 6167, canton: "LU", commune: "Romoos" },
    { zip: 6170, canton: "LU", commune: "Romoos" },
    { zip: 6170, canton: "LU", commune: "Schüpfheim" },
    { zip: 6105, canton: "LU", commune: "Werthenstein" },
    { zip: 6106, canton: "LU", commune: "Werthenstein" },
    { zip: 6110, canton: "LU", commune: "Werthenstein" },
    { zip: 3555, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6170, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6173, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6182, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6192, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6196, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6197, canton: "LU", commune: "Escholzmatt-Marbach" },
    { zip: 6287, canton: "LU", commune: "Aesch (LU)" },
    { zip: 6286, canton: "LU", commune: "Altwis" },
    { zip: 6034, canton: "LU", commune: "Ballwil" },
    { zip: 6274, canton: "LU", commune: "Ballwil" },
    { zip: 6275, canton: "LU", commune: "Ballwil" },
    { zip: 6020, canton: "LU", commune: "Emmen" },
    { zip: 6032, canton: "LU", commune: "Emmen" },
    { zip: 6206, canton: "LU", commune: "Emmen" },
    { zip: 6294, canton: "LU", commune: "Ermensee" },
    { zip: 6026, canton: "LU", commune: "Eschenbach (LU)" },
    { zip: 6034, canton: "LU", commune: "Eschenbach (LU)" },
    { zip: 6274, canton: "LU", commune: "Eschenbach (LU)" },
    { zip: 6284, canton: "LU", commune: "Hitzkirch" },
    { zip: 6285, canton: "LU", commune: "Hitzkirch" },
    { zip: 6288, canton: "LU", commune: "Hitzkirch" },
    { zip: 6289, canton: "LU", commune: "Hitzkirch" },
    { zip: 6295, canton: "LU", commune: "Hitzkirch" },
    { zip: 6274, canton: "LU", commune: "Hochdorf" },
    { zip: 6275, canton: "LU", commune: "Hochdorf" },
    { zip: 6280, canton: "LU", commune: "Hochdorf" },
    { zip: 6283, canton: "LU", commune: "Hochdorf" },
    { zip: 6275, canton: "LU", commune: "Hohenrain" },
    { zip: 6276, canton: "LU", commune: "Hohenrain" },
    { zip: 6277, canton: "LU", commune: "Hohenrain" },
    { zip: 6280, canton: "LU", commune: "Hohenrain" },
    { zip: 6283, canton: "LU", commune: "Hohenrain" },
    { zip: 6034, canton: "LU", commune: "Inwil" },
    { zip: 6038, canton: "LU", commune: "Inwil" },
    { zip: 6026, canton: "LU", commune: "Rain" },
    { zip: 6026, canton: "LU", commune: "Römerswil" },
    { zip: 6027, canton: "LU", commune: "Römerswil" },
    { zip: 6028, canton: "LU", commune: "Römerswil" },
    { zip: 6280, canton: "LU", commune: "Römerswil" },
    { zip: 6283, canton: "LU", commune: "Römerswil" },
    { zip: 6023, canton: "LU", commune: "Rothenburg" },
    { zip: 6026, canton: "LU", commune: "Rothenburg" },
    { zip: 6206, canton: "LU", commune: "Rothenburg" },
    { zip: 6287, canton: "LU", commune: "Schongau" },
    { zip: 6288, canton: "LU", commune: "Schongau" },
    { zip: 6030, canton: "LU", commune: "Adligenswil" },
    { zip: 6043, canton: "LU", commune: "Adligenswil" },
    { zip: 6030, canton: "LU", commune: "Buchrain" },
    { zip: 6033, canton: "LU", commune: "Buchrain" },
    { zip: 6035, canton: "LU", commune: "Buchrain" },
    { zip: 6036, canton: "LU", commune: "Dierikon" },
    { zip: 6004, canton: "LU", commune: "Ebikon" },
    { zip: 6006, canton: "LU", commune: "Ebikon" },
    { zip: 6020, canton: "LU", commune: "Ebikon" },
    { zip: 6030, canton: "LU", commune: "Ebikon" },
    { zip: 6032, canton: "LU", commune: "Ebikon" },
    { zip: 6038, canton: "LU", commune: "Gisikon" },
    { zip: 6404, canton: "LU", commune: "Greppen" },
    { zip: 6038, canton: "LU", commune: "Honau" },
    { zip: 6005, canton: "LU", commune: "Horw" },
    { zip: 6047, canton: "LU", commune: "Horw" },
    { zip: 6048, canton: "LU", commune: "Horw" },
    { zip: 6052, canton: "LU", commune: "Horw" },
    { zip: 6005, canton: "LU", commune: "Kriens" },
    { zip: 6010, canton: "LU", commune: "Kriens" },
    { zip: 6012, canton: "LU", commune: "Kriens" },
    { zip: 6013, canton: "LU", commune: "Kriens" },
    { zip: 6048, canton: "LU", commune: "Kriens" },
    { zip: 6000, canton: "LU", commune: "Luzern" },
    { zip: 6003, canton: "LU", commune: "Luzern" },
    { zip: 6004, canton: "LU", commune: "Luzern" },
    { zip: 6005, canton: "LU", commune: "Luzern" },
    { zip: 6006, canton: "LU", commune: "Luzern" },
    { zip: 6014, canton: "LU", commune: "Luzern" },
    { zip: 6015, canton: "LU", commune: "Luzern" },
    { zip: 6016, canton: "LU", commune: "Luzern" },
    { zip: 6020, canton: "LU", commune: "Luzern" },
    { zip: 6014, canton: "LU", commune: "Malters" },
    { zip: 6016, canton: "LU", commune: "Malters" },
    { zip: 6019, canton: "LU", commune: "Malters" },
    { zip: 6102, canton: "LU", commune: "Malters" },
    { zip: 6006, canton: "LU", commune: "Meggen" },
    { zip: 6045, canton: "LU", commune: "Meggen" },
    { zip: 6344, canton: "LU", commune: "Meierskappel" },
    { zip: 6035, canton: "LU", commune: "Root" },
    { zip: 6037, canton: "LU", commune: "Root" },
    { zip: 6038, canton: "LU", commune: "Root" },
    { zip: 6039, canton: "LU", commune: "Root" },
    { zip: 6044, canton: "LU", commune: "Root" },
    { zip: 6013, canton: "LU", commune: "Schwarzenberg" },
    { zip: 6103, canton: "LU", commune: "Schwarzenberg" },
    { zip: 6044, canton: "LU", commune: "Udligenswil" },
    { zip: 6354, canton: "LU", commune: "Vitznau" },
    { zip: 6356, canton: "LU", commune: "Vitznau" },
    { zip: 6353, canton: "LU", commune: "Weggis" },
    { zip: 6354, canton: "LU", commune: "Weggis" },
    { zip: 6356, canton: "LU", commune: "Weggis" },
    { zip: 6025, canton: "LU", commune: "Beromünster" },
    { zip: 6028, canton: "LU", commune: "Beromünster" },
    { zip: 6215, canton: "LU", commune: "Beromünster" },
    { zip: 6221, canton: "LU", commune: "Beromünster" },
    { zip: 6222, canton: "LU", commune: "Beromünster" },
    { zip: 6233, canton: "LU", commune: "Büron" },
    { zip: 6018, canton: "LU", commune: "Buttisholz" },
    { zip: 6022, canton: "LU", commune: "Buttisholz" },
    { zip: 6205, canton: "LU", commune: "Eich" },
    { zip: 6214, canton: "LU", commune: "Eich" },
    { zip: 6232, canton: "LU", commune: "Geuensee" },
    { zip: 6022, canton: "LU", commune: "Grosswangen" },
    { zip: 6024, canton: "LU", commune: "Hildisrieden" },
    { zip: 6212, canton: "LU", commune: "Knutwil" },
    { zip: 6213, canton: "LU", commune: "Knutwil" },
    { zip: 6210, canton: "LU", commune: "Mauensee" },
    { zip: 6212, canton: "LU", commune: "Mauensee" },
    { zip: 6216, canton: "LU", commune: "Mauensee" },
    { zip: 6242, canton: "LU", commune: "Mauensee" },
    { zip: 6016, canton: "LU", commune: "Neuenkirch" },
    { zip: 6023, canton: "LU", commune: "Neuenkirch" },
    { zip: 6203, canton: "LU", commune: "Neuenkirch" },
    { zip: 6204, canton: "LU", commune: "Neuenkirch" },
    { zip: 6206, canton: "LU", commune: "Neuenkirch" },
    { zip: 6207, canton: "LU", commune: "Neuenkirch" },
    { zip: 6207, canton: "LU", commune: "Nottwil" },
    { zip: 6018, canton: "LU", commune: "Oberkirch" },
    { zip: 6207, canton: "LU", commune: "Oberkirch" },
    { zip: 6208, canton: "LU", commune: "Oberkirch" },
    { zip: 6210, canton: "LU", commune: "Oberkirch" },
    { zip: 6216, canton: "LU", commune: "Oberkirch" },
    { zip: 5735, canton: "LU", commune: "Rickenbach (LU)" },
    { zip: 6221, canton: "LU", commune: "Rickenbach (LU)" },
    { zip: 6016, canton: "LU", commune: "Ruswil" },
    { zip: 6017, canton: "LU", commune: "Ruswil" },
    { zip: 6018, canton: "LU", commune: "Ruswil" },
    { zip: 6019, canton: "LU", commune: "Ruswil" },
    { zip: 6105, canton: "LU", commune: "Ruswil" },
    { zip: 6106, canton: "LU", commune: "Ruswil" },
    { zip: 6110, canton: "LU", commune: "Ruswil" },
    { zip: 6206, canton: "LU", commune: "Ruswil" },
    { zip: 6207, canton: "LU", commune: "Ruswil" },
    { zip: 6210, canton: "LU", commune: "Schenkon" },
    { zip: 6214, canton: "LU", commune: "Schenkon" },
    { zip: 6222, canton: "LU", commune: "Schenkon" },
    { zip: 6231, canton: "LU", commune: "Schlierbach" },
    { zip: 6204, canton: "LU", commune: "Sempach" },
    { zip: 6210, canton: "LU", commune: "Sursee" },
    { zip: 6213, canton: "LU", commune: "Triengen" },
    { zip: 6234, canton: "LU", commune: "Triengen" },
    { zip: 6235, canton: "LU", commune: "Triengen" },
    { zip: 6236, canton: "LU", commune: "Triengen" },
    { zip: 6110, canton: "LU", commune: "Wolhusen" },
    { zip: 6114, canton: "LU", commune: "Wolhusen" },
    { zip: 6122, canton: "LU", commune: "Wolhusen" },
    { zip: 6248, canton: "LU", commune: "Alberswil" },
    { zip: 6147, canton: "LU", commune: "Altbüron" },
    { zip: 6244, canton: "LU", commune: "Altishofen" },
    { zip: 6246, canton: "LU", commune: "Altishofen" },
    { zip: 6263, canton: "LU", commune: "Altishofen" },
    { zip: 6211, canton: "LU", commune: "Dagmersellen" },
    { zip: 6235, canton: "LU", commune: "Dagmersellen" },
    { zip: 6246, canton: "LU", commune: "Dagmersellen" },
    { zip: 6252, canton: "LU", commune: "Dagmersellen" },
    { zip: 6253, canton: "LU", commune: "Dagmersellen" },
    { zip: 6260, canton: "LU", commune: "Dagmersellen" },
    { zip: 6144, canton: "LU", commune: "Ebersecken" },
    { zip: 6244, canton: "LU", commune: "Ebersecken" },
    { zip: 6245, canton: "LU", commune: "Ebersecken" },
    { zip: 6247, canton: "LU", commune: "Ebersecken" },
    { zip: 6243, canton: "LU", commune: "Egolzwil" },
    { zip: 6244, canton: "LU", commune: "Egolzwil" },
    { zip: 6217, canton: "LU", commune: "Ettiswil" },
    { zip: 6218, canton: "LU", commune: "Ettiswil" },
    { zip: 6145, canton: "LU", commune: "Fischbach" },
    { zip: 6152, canton: "LU", commune: "Fischbach" },
    { zip: 6142, canton: "LU", commune: "Gettnau" },
    { zip: 6143, canton: "LU", commune: "Gettnau" },
    { zip: 6146, canton: "LU", commune: "Grossdietwil" },
    { zip: 6147, canton: "LU", commune: "Grossdietwil" },
    { zip: 6245, canton: "LU", commune: "Grossdietwil" },
    { zip: 6125, canton: "LU", commune: "Hergiswil bei Willisau" },
    { zip: 6130, canton: "LU", commune: "Hergiswil bei Willisau" },
    { zip: 6132, canton: "LU", commune: "Hergiswil bei Willisau" },
    { zip: 6133, canton: "LU", commune: "Hergiswil bei Willisau" },
    { zip: 6156, canton: "LU", commune: "Hergiswil bei Willisau" },
    { zip: 4952, canton: "LU", commune: "Luthern" },
    { zip: 6153, canton: "LU", commune: "Luthern" },
    { zip: 6154, canton: "LU", commune: "Luthern" },
    { zip: 6156, canton: "LU", commune: "Luthern" },
    { zip: 6110, canton: "LU", commune: "Menznau" },
    { zip: 6122, canton: "LU", commune: "Menznau" },
    { zip: 6123, canton: "LU", commune: "Menznau" },
    { zip: 6125, canton: "LU", commune: "Menznau" },
    { zip: 6130, canton: "LU", commune: "Menznau" },
    { zip: 6244, canton: "LU", commune: "Nebikon" },
    { zip: 4915, canton: "LU", commune: "Pfaffnau" },
    { zip: 6147, canton: "LU", commune: "Pfaffnau" },
    { zip: 6264, canton: "LU", commune: "Pfaffnau" },
    { zip: 6265, canton: "LU", commune: "Pfaffnau" },
    { zip: 6252, canton: "LU", commune: "Reiden" },
    { zip: 6260, canton: "LU", commune: "Reiden" },
    { zip: 6262, canton: "LU", commune: "Reiden" },
    { zip: 6263, canton: "LU", commune: "Reiden" },
    { zip: 6265, canton: "LU", commune: "Roggliswil" },
    { zip: 6143, canton: "LU", commune: "Schötz" },
    { zip: 6247, canton: "LU", commune: "Schötz" },
    { zip: 4952, canton: "LU", commune: "Ufhusen" },
    { zip: 4955, canton: "LU", commune: "Ufhusen" },
    { zip: 6153, canton: "LU", commune: "Ufhusen" },
    { zip: 6242, canton: "LU", commune: "Wauwil" },
    { zip: 4806, canton: "LU", commune: "Wikon" },
    { zip: 6260, canton: "LU", commune: "Wikon" },
    { zip: 6144, canton: "LU", commune: "Zell (LU)" },
    { zip: 6152, canton: "LU", commune: "Zell (LU)" },
    { zip: 6153, canton: "LU", commune: "Zell (LU)" },
    { zip: 6122, canton: "LU", commune: "Willisau" },
    { zip: 6125, canton: "LU", commune: "Willisau" },
    { zip: 6126, canton: "LU", commune: "Willisau" },
    { zip: 6130, canton: "LU", commune: "Willisau" },
    { zip: 6132, canton: "LU", commune: "Willisau" },
    { zip: 6133, canton: "LU", commune: "Willisau" },
    { zip: 6144, canton: "LU", commune: "Willisau" },
    { zip: 6154, canton: "LU", commune: "Willisau" },
    { zip: 6156, canton: "LU", commune: "Willisau" },
    { zip: 6248, canton: "LU", commune: "Willisau" },
    { zip: 6460, canton: "UR", commune: "Altdorf (UR)" },
    { zip: 6490, canton: "UR", commune: "Andermatt" },
    { zip: 6390, canton: "UR", commune: "Attinghausen" },
    { zip: 6468, canton: "UR", commune: "Attinghausen" },
    { zip: 6466, canton: "UR", commune: "Bauen" },
    { zip: 6460, canton: "UR", commune: "Bürglen (UR)" },
    { zip: 6463, canton: "UR", commune: "Bürglen (UR)" },
    { zip: 6464, canton: "UR", commune: "Bürglen (UR)" },
    { zip: 6469, canton: "UR", commune: "Bürglen (UR)" },
    { zip: 6472, canton: "UR", commune: "Erstfeld" },
    { zip: 6454, canton: "UR", commune: "Flüelen" },
    { zip: 6460, canton: "UR", commune: "Flüelen" },
    { zip: 6487, canton: "UR", commune: "Göschenen" },
    { zip: 6473, canton: "UR", commune: "Gurtnellen" },
    { zip: 6474, canton: "UR", commune: "Gurtnellen" },
    { zip: 6476, canton: "UR", commune: "Gurtnellen" },
    { zip: 6482, canton: "UR", commune: "Gurtnellen" },
    { zip: 6493, canton: "UR", commune: "Hospental" },
    { zip: 6461, canton: "UR", commune: "Isenthal" },
    { zip: 6491, canton: "UR", commune: "Realp" },
    { zip: 6467, canton: "UR", commune: "Schattdorf" },
    { zip: 6469, canton: "UR", commune: "Schattdorf" },
    { zip: 6462, canton: "UR", commune: "Seedorf (UR)" },
    { zip: 6377, canton: "UR", commune: "Seelisberg" },
    { zip: 6441, canton: "UR", commune: "Seelisberg" },
    { zip: 6473, canton: "UR", commune: "Silenen" },
    { zip: 6474, canton: "UR", commune: "Silenen" },
    { zip: 6475, canton: "UR", commune: "Silenen" },
    { zip: 6476, canton: "UR", commune: "Silenen" },
    { zip: 6452, canton: "UR", commune: "Sisikon" },
    { zip: 6464, canton: "UR", commune: "Spiringen" },
    { zip: 8751, canton: "UR", commune: "Spiringen" },
    { zip: 6465, canton: "UR", commune: "Unterschächen" },
    { zip: 6482, canton: "UR", commune: "Wassen" },
    { zip: 6484, canton: "UR", commune: "Wassen" },
    { zip: 6485, canton: "UR", commune: "Wassen" },
    { zip: 8836, canton: "SZ", commune: "Einsiedeln" },
    { zip: 8840, canton: "SZ", commune: "Einsiedeln" },
    { zip: 8841, canton: "SZ", commune: "Einsiedeln" },
    { zip: 8844, canton: "SZ", commune: "Einsiedeln" },
    { zip: 8846, canton: "SZ", commune: "Einsiedeln" },
    { zip: 8847, canton: "SZ", commune: "Einsiedeln" },
    { zip: 6354, canton: "SZ", commune: "Gersau" },
    { zip: 6410, canton: "SZ", commune: "Gersau" },
    { zip: 6442, canton: "SZ", commune: "Gersau" },
    { zip: 8832, canton: "SZ", commune: "Feusisberg" },
    { zip: 8834, canton: "SZ", commune: "Feusisberg" },
    { zip: 8835, canton: "SZ", commune: "Feusisberg" },
    { zip: 8836, canton: "SZ", commune: "Feusisberg" },
    { zip: 8847, canton: "SZ", commune: "Feusisberg" },
    { zip: 8640, canton: "SZ", commune: "Freienbach" },
    { zip: 8806, canton: "SZ", commune: "Freienbach" },
    { zip: 8807, canton: "SZ", commune: "Freienbach" },
    { zip: 8808, canton: "SZ", commune: "Freienbach" },
    { zip: 8832, canton: "SZ", commune: "Freienbach" },
    { zip: 8806, canton: "SZ", commune: "Wollerau" },
    { zip: 8825, canton: "SZ", commune: "Wollerau" },
    { zip: 8832, canton: "SZ", commune: "Wollerau" },
    { zip: 8833, canton: "SZ", commune: "Wollerau" },
    { zip: 8834, canton: "SZ", commune: "Wollerau" },
    { zip: 6402, canton: "SZ", commune: "Küssnacht (SZ)" },
    { zip: 6403, canton: "SZ", commune: "Küssnacht (SZ)" },
    { zip: 6405, canton: "SZ", commune: "Küssnacht (SZ)" },
    { zip: 8846, canton: "SZ", commune: "Altendorf" },
    { zip: 8852, canton: "SZ", commune: "Altendorf" },
    { zip: 8853, canton: "SZ", commune: "Galgenen" },
    { zip: 8854, canton: "SZ", commune: "Galgenen" },
    { zip: 8858, canton: "SZ", commune: "Innerthal" },
    { zip: 8853, canton: "SZ", commune: "Lachen" },
    { zip: 8864, canton: "SZ", commune: "Reichenburg" },
    { zip: 8717, canton: "SZ", commune: "Schübelbach" },
    { zip: 8854, canton: "SZ", commune: "Schübelbach" },
    { zip: 8855, canton: "SZ", commune: "Schübelbach" },
    { zip: 8862, canton: "SZ", commune: "Schübelbach" },
    { zip: 8863, canton: "SZ", commune: "Schübelbach" },
    { zip: 8730, canton: "SZ", commune: "Tuggen" },
    { zip: 8855, canton: "SZ", commune: "Tuggen" },
    { zip: 8856, canton: "SZ", commune: "Tuggen" },
    { zip: 8857, canton: "SZ", commune: "Vorderthal" },
    { zip: 8853, canton: "SZ", commune: "Wangen (SZ)" },
    { zip: 8854, canton: "SZ", commune: "Wangen (SZ)" },
    { zip: 8855, canton: "SZ", commune: "Wangen (SZ)" },
    { zip: 6430, canton: "SZ", commune: "Alpthal" },
    { zip: 6432, canton: "SZ", commune: "Alpthal" },
    { zip: 8849, canton: "SZ", commune: "Alpthal" },
    { zip: 6318, canton: "SZ", commune: "Arth" },
    { zip: 6356, canton: "SZ", commune: "Arth" },
    { zip: 6410, canton: "SZ", commune: "Arth" },
    { zip: 6414, canton: "SZ", commune: "Arth" },
    { zip: 6415, canton: "SZ", commune: "Arth" },
    { zip: 6416, canton: "SZ", commune: "Arth" },
    { zip: 6434, canton: "SZ", commune: "Illgau" },
    { zip: 6423, canton: "SZ", commune: "Ingenbohl" },
    { zip: 6440, canton: "SZ", commune: "Ingenbohl" },
    { zip: 6424, canton: "SZ", commune: "Lauerz" },
    { zip: 6433, canton: "SZ", commune: "Morschach" },
    { zip: 6440, canton: "SZ", commune: "Morschach" },
    { zip: 6443, canton: "SZ", commune: "Morschach" },
    { zip: 6452, canton: "SZ", commune: "Morschach" },
    { zip: 6433, canton: "SZ", commune: "Muotathal" },
    { zip: 6436, canton: "SZ", commune: "Muotathal" },
    { zip: 8750, canton: "SZ", commune: "Muotathal" },
    { zip: 8842, canton: "SZ", commune: "Oberiberg" },
    { zip: 8843, canton: "SZ", commune: "Oberiberg" },
    { zip: 6452, canton: "SZ", commune: "Riemenstalden" },
    { zip: 6418, canton: "SZ", commune: "Rothenthurm" },
    { zip: 6315, canton: "SZ", commune: "Sattel" },
    { zip: 6417, canton: "SZ", commune: "Sattel" },
    { zip: 6418, canton: "SZ", commune: "Sattel" },
    { zip: 6422, canton: "SZ", commune: "Sattel" },
    { zip: 6417, canton: "SZ", commune: "Schwyz" },
    { zip: 6423, canton: "SZ", commune: "Schwyz" },
    { zip: 6430, canton: "SZ", commune: "Schwyz" },
    { zip: 6432, canton: "SZ", commune: "Schwyz" },
    { zip: 6438, canton: "SZ", commune: "Schwyz" },
    { zip: 8842, canton: "SZ", commune: "Schwyz" },
    { zip: 8843, canton: "SZ", commune: "Schwyz" },
    { zip: 8849, canton: "SZ", commune: "Schwyz" },
    { zip: 6422, canton: "SZ", commune: "Steinen" },
    { zip: 6416, canton: "SZ", commune: "Steinerberg" },
    { zip: 8842, canton: "SZ", commune: "Unteriberg" },
    { zip: 8844, canton: "SZ", commune: "Unteriberg" },
    { zip: 8845, canton: "SZ", commune: "Unteriberg" },
    { zip: 6053, canton: "OW", commune: "Alpnach" },
    { zip: 6055, canton: "OW", commune: "Alpnach" },
    { zip: 6388, canton: "OW", commune: "Engelberg" },
    { zip: 6390, canton: "OW", commune: "Engelberg" },
    { zip: 6074, canton: "OW", commune: "Giswil" },
    { zip: 6064, canton: "OW", commune: "Kerns" },
    { zip: 6066, canton: "OW", commune: "Kerns" },
    { zip: 6067, canton: "OW", commune: "Kerns" },
    { zip: 6068, canton: "OW", commune: "Kerns" },
    { zip: 6078, canton: "OW", commune: "Lungern" },
    { zip: 6067, canton: "OW", commune: "Sachseln" },
    { zip: 6072, canton: "OW", commune: "Sachseln" },
    { zip: 6073, canton: "OW", commune: "Sachseln" },
    { zip: 6074, canton: "OW", commune: "Sachseln" },
    { zip: 6056, canton: "OW", commune: "Sarnen" },
    { zip: 6060, canton: "OW", commune: "Sarnen" },
    { zip: 6062, canton: "OW", commune: "Sarnen" },
    { zip: 6063, canton: "OW", commune: "Sarnen" },
    { zip: 6375, canton: "NW", commune: "Beckenried" },
    { zip: 6376, canton: "NW", commune: "Beckenried" },
    { zip: 6374, canton: "NW", commune: "Buochs" },
    { zip: 6383, canton: "NW", commune: "Dallenwil" },
    { zip: 6386, canton: "NW", commune: "Dallenwil" },
    { zip: 6376, canton: "NW", commune: "Emmetten" },
    { zip: 6377, canton: "NW", commune: "Emmetten" },
    { zip: 6363, canton: "NW", commune: "Ennetbürgen" },
    { zip: 6373, canton: "NW", commune: "Ennetbürgen" },
    { zip: 6374, canton: "NW", commune: "Ennetbürgen" },
    { zip: 6362, canton: "NW", commune: "Ennetmoos" },
    { zip: 6372, canton: "NW", commune: "Ennetmoos" },
    { zip: 6010, canton: "NW", commune: "Hergiswil (NW)" },
    { zip: 6013, canton: "NW", commune: "Hergiswil (NW)" },
    { zip: 6052, canton: "NW", commune: "Hergiswil (NW)" },
    { zip: 6370, canton: "NW", commune: "Oberdorf (NW)" },
    { zip: 6374, canton: "NW", commune: "Oberdorf (NW)" },
    { zip: 6382, canton: "NW", commune: "Oberdorf (NW)" },
    { zip: 6383, canton: "NW", commune: "Oberdorf (NW)" },
    { zip: 6370, canton: "NW", commune: "Stans" },
    { zip: 6362, canton: "NW", commune: "Stansstad" },
    { zip: 6363, canton: "NW", commune: "Stansstad" },
    { zip: 6365, canton: "NW", commune: "Stansstad" },
    { zip: 6383, canton: "NW", commune: "Wolfenschiessen" },
    { zip: 6386, canton: "NW", commune: "Wolfenschiessen" },
    { zip: 6387, canton: "NW", commune: "Wolfenschiessen" },
    { zip: 6388, canton: "NW", commune: "Wolfenschiessen" },
    { zip: 6390, canton: "NW", commune: "Wolfenschiessen" },
    { zip: 8752, canton: "GL", commune: "Glarus Nord" },
    { zip: 8753, canton: "GL", commune: "Glarus Nord" },
    { zip: 8754, canton: "GL", commune: "Glarus Nord" },
    { zip: 8757, canton: "GL", commune: "Glarus Nord" },
    { zip: 8758, canton: "GL", commune: "Glarus Nord" },
    { zip: 8865, canton: "GL", commune: "Glarus Nord" },
    { zip: 8866, canton: "GL", commune: "Glarus Nord" },
    { zip: 8867, canton: "GL", commune: "Glarus Nord" },
    { zip: 8868, canton: "GL", commune: "Glarus Nord" },
    { zip: 8872, canton: "GL", commune: "Glarus Nord" },
    { zip: 8874, canton: "GL", commune: "Glarus Nord" },
    { zip: 8755, canton: "GL", commune: "Glarus Süd" },
    { zip: 8756, canton: "GL", commune: "Glarus Süd" },
    { zip: 8762, canton: "GL", commune: "Glarus Süd" },
    { zip: 8765, canton: "GL", commune: "Glarus Süd" },
    { zip: 8766, canton: "GL", commune: "Glarus Süd" },
    { zip: 8767, canton: "GL", commune: "Glarus Süd" },
    { zip: 8772, canton: "GL", commune: "Glarus Süd" },
    { zip: 8773, canton: "GL", commune: "Glarus Süd" },
    { zip: 8774, canton: "GL", commune: "Glarus Süd" },
    { zip: 8775, canton: "GL", commune: "Glarus Süd" },
    { zip: 8777, canton: "GL", commune: "Glarus Süd" },
    { zip: 8782, canton: "GL", commune: "Glarus Süd" },
    { zip: 8783, canton: "GL", commune: "Glarus Süd" },
    { zip: 8784, canton: "GL", commune: "Glarus Süd" },
    { zip: 8750, canton: "GL", commune: "Glarus" },
    { zip: 8754, canton: "GL", commune: "Glarus" },
    { zip: 8755, canton: "GL", commune: "Glarus" },
    { zip: 6300, canton: "ZG", commune: "Baar" },
    { zip: 6312, canton: "ZG", commune: "Baar" },
    { zip: 6314, canton: "ZG", commune: "Baar" },
    { zip: 6319, canton: "ZG", commune: "Baar" },
    { zip: 6340, canton: "ZG", commune: "Baar" },
    { zip: 6345, canton: "ZG", commune: "Baar" },
    { zip: 6330, canton: "ZG", commune: "Cham" },
    { zip: 6331, canton: "ZG", commune: "Cham" },
    { zip: 6332, canton: "ZG", commune: "Cham" },
    { zip: 5642, canton: "ZG", commune: "Hünenberg" },
    { zip: 6331, canton: "ZG", commune: "Hünenberg" },
    { zip: 6332, canton: "ZG", commune: "Hünenberg" },
    { zip: 6333, canton: "ZG", commune: "Hünenberg" },
    { zip: 6313, canton: "ZG", commune: "Menzingen" },
    { zip: 6314, canton: "ZG", commune: "Menzingen" },
    { zip: 6315, canton: "ZG", commune: "Menzingen" },
    { zip: 6313, canton: "ZG", commune: "Neuheim" },
    { zip: 6340, canton: "ZG", commune: "Neuheim" },
    { zip: 6345, canton: "ZG", commune: "Neuheim" },
    { zip: 6314, canton: "ZG", commune: "Oberägeri" },
    { zip: 6315, canton: "ZG", commune: "Oberägeri" },
    { zip: 6417, canton: "ZG", commune: "Oberägeri" },
    { zip: 6418, canton: "ZG", commune: "Oberägeri" },
    { zip: 8836, canton: "ZG", commune: "Oberägeri" },
    { zip: 6343, canton: "ZG", commune: "Risch" },
    { zip: 6300, canton: "ZG", commune: "Steinhausen" },
    { zip: 6312, canton: "ZG", commune: "Steinhausen" },
    { zip: 6330, canton: "ZG", commune: "Steinhausen" },
    { zip: 6314, canton: "ZG", commune: "Unterägeri" },
    { zip: 6315, canton: "ZG", commune: "Unterägeri" },
    { zip: 6318, canton: "ZG", commune: "Walchwil" },
    { zip: 6300, canton: "ZG", commune: "Zug" },
    { zip: 6314, canton: "ZG", commune: "Zug" },
    { zip: 6317, canton: "ZG", commune: "Zug" },
    { zip: 6318, canton: "ZG", commune: "Zug" },
    { zip: 6330, canton: "ZG", commune: "Zug" },
    { zip: 1473, canton: "FR", commune: "Châtillon (FR)" },
    { zip: 1529, canton: "FR", commune: "Cheiry" },
    { zip: 1534, canton: "FR", commune: "Cheiry" },
    { zip: 1482, canton: "FR", commune: "Cugy (FR)" },
    { zip: 1483, canton: "FR", commune: "Cugy (FR)" },
    { zip: 1532, canton: "FR", commune: "Fétigny" },
    { zip: 1544, canton: "FR", commune: "Gletterens" },
    { zip: 1470, canton: "FR", commune: "Lully (FR)" },
    { zip: 1483, canton: "FR", commune: "Lully (FR)" },
    { zip: 1533, canton: "FR", commune: "Ménières" },
    { zip: 1562, canton: "FR", commune: "Montagny (FR)" },
    { zip: 1774, canton: "FR", commune: "Montagny (FR)" },
    { zip: 1775, canton: "FR", commune: "Montagny (FR)" },
    { zip: 1776, canton: "FR", commune: "Montagny (FR)" },
    { zip: 1485, canton: "FR", commune: "Nuvilly" },
    { zip: 1410, canton: "FR", commune: "Prévondavaux" },
    { zip: 1566, canton: "FR", commune: "Saint-Aubin (FR)" },
    { zip: 1541, canton: "FR", commune: "Sévaz" },
    { zip: 1525, canton: "FR", commune: "Surpierre" },
    { zip: 1527, canton: "FR", commune: "Surpierre" },
    { zip: 1528, canton: "FR", commune: "Surpierre" },
    { zip: 1565, canton: "FR", commune: "Vallon" },
    { zip: 1483, canton: "FR", commune: "Les Montets" },
    { zip: 1484, canton: "FR", commune: "Les Montets" },
    { zip: 1567, canton: "FR", commune: "Delley-Portalban" },
    { zip: 1568, canton: "FR", commune: "Delley-Portalban" },
    { zip: 1563, canton: "FR", commune: "Belmont-Broye" },
    { zip: 1564, canton: "FR", commune: "Belmont-Broye" },
    { zip: 1580, canton: "FR", commune: "Belmont-Broye" },
    { zip: 1773, canton: "FR", commune: "Belmont-Broye" },
    { zip: 1776, canton: "FR", commune: "Belmont-Broye" },
    { zip: 1470, canton: "FR", commune: "Estavayer" },
    { zip: 1473, canton: "FR", commune: "Estavayer" },
    { zip: 1475, canton: "FR", commune: "Estavayer" },
    { zip: 1486, canton: "FR", commune: "Estavayer" },
    { zip: 1489, canton: "FR", commune: "Estavayer" },
    { zip: 1530, canton: "FR", commune: "Estavayer" },
    { zip: 1541, canton: "FR", commune: "Estavayer" },
    { zip: 1542, canton: "FR", commune: "Estavayer" },
    { zip: 1468, canton: "FR", commune: "Cheyres-Châbles" },
    { zip: 1474, canton: "FR", commune: "Cheyres-Châbles" },
    { zip: 1673, canton: "FR", commune: "Auboranges" },
    { zip: 1681, canton: "FR", commune: "Billens-Hennens" },
    { zip: 1608, canton: "FR", commune: "Chapelle (Glâne)" },
    { zip: 1689, canton: "FR", commune: "Le Châtelard" },
    { zip: 1553, canton: "FR", commune: "Châtonnaye" },
    { zip: 1673, canton: "FR", commune: "Ecublens (FR)" },
    { zip: 1686, canton: "FR", commune: "Grangettes" },
    { zip: 1692, canton: "FR", commune: "Massonnens" },
    { zip: 1680, canton: "FR", commune: "Mézières (FR)" },
    { zip: 1684, canton: "FR", commune: "Mézières (FR)" },
    { zip: 1674, canton: "FR", commune: "Montet (Glâne)" },
    { zip: 1680, canton: "FR", commune: "Romont (FR)" },
    { zip: 1673, canton: "FR", commune: "Rue" },
    { zip: 1675, canton: "FR", commune: "Rue" },
    { zip: 1676, canton: "FR", commune: "Siviriez" },
    { zip: 1677, canton: "FR", commune: "Siviriez" },
    { zip: 1678, canton: "FR", commune: "Siviriez" },
    { zip: 1679, canton: "FR", commune: "Siviriez" },
    { zip: 1680, canton: "FR", commune: "Siviriez" },
    { zip: 1670, canton: "FR", commune: "Ursy" },
    { zip: 1674, canton: "FR", commune: "Ursy" },
    { zip: 1675, canton: "FR", commune: "Ursy" },
    { zip: 1690, canton: "FR", commune: "Villaz-Saint-Pierre" },
    { zip: 1685, canton: "FR", commune: "Vuisternens-dev-Romont" },
    { zip: 1686, canton: "FR", commune: "Vuisternens-dev-Romont" },
    { zip: 1687, canton: "FR", commune: "Vuisternens-dev-Romont" },
    { zip: 1688, canton: "FR", commune: "Vuisternens-dev-Romont" },
    { zip: 1697, canton: "FR", commune: "Vuisternens-dev-Romont" },
    { zip: 1690, canton: "FR", commune: "Villorsonnens" },
    { zip: 1694, canton: "FR", commune: "Villorsonnens" },
    { zip: 1748, canton: "FR", commune: "Torny" },
    { zip: 1749, canton: "FR", commune: "Torny" },
    { zip: 1680, canton: "FR", commune: "La Folliaz" },
    { zip: 1690, canton: "FR", commune: "La Folliaz" },
    { zip: 1691, canton: "FR", commune: "La Folliaz" },
    { zip: 1669, canton: "FR", commune: "Haut-Intyamon" },
    { zip: 1643, canton: "FR", commune: "Pont-en-Ogoz" },
    { zip: 1644, canton: "FR", commune: "Pont-en-Ogoz" },
    { zip: 1645, canton: "FR", commune: "Pont-en-Ogoz" },
    { zip: 1652, canton: "FR", commune: "Botterens" },
    { zip: 1636, canton: "FR", commune: "Broc" },
    { zip: 1630, canton: "FR", commune: "Bulle" },
    { zip: 1635, canton: "FR", commune: "Bulle" },
    { zip: 1653, canton: "FR", commune: "Châtel-sur-Montsalvens" },
    { zip: 1646, canton: "FR", commune: "Corbières" },
    { zip: 1647, canton: "FR", commune: "Corbières" },
    { zip: 1651, canton: "FR", commune: "Corbières" },
    { zip: 1653, canton: "FR", commune: "Crésuz" },
    { zip: 1646, canton: "FR", commune: "Echarlens" },
    { zip: 1666, canton: "FR", commune: "Grandvillard" },
    { zip: 1635, canton: "FR", commune: "Gruyères" },
    { zip: 1636, canton: "FR", commune: "Gruyères" },
    { zip: 1661, canton: "FR", commune: "Gruyères" },
    { zip: 1663, canton: "FR", commune: "Gruyères" },
    { zip: 1648, canton: "FR", commune: "Hauteville" },
    { zip: 1656, canton: "FR", commune: "Jaun" },
    { zip: 1716, canton: "FR", commune: "Jaun" },
    { zip: 1633, canton: "FR", commune: "Marsens" },
    { zip: 1638, canton: "FR", commune: "Morlon" },
    { zip: 1635, canton: "FR", commune: "Le Pâquier (FR)" },
    { zip: 1661, canton: "FR", commune: "Le Pâquier (FR)" },
    { zip: 1649, canton: "FR", commune: "Pont-la-Ville" },
    { zip: 1628, canton: "FR", commune: "Riaz" },
    { zip: 1632, canton: "FR", commune: "Riaz" },
    { zip: 1634, canton: "FR", commune: "La Roche" },
    { zip: 1733, canton: "FR", commune: "La Roche" },
    { zip: 1625, canton: "FR", commune: "Sâles" },
    { zip: 1626, canton: "FR", commune: "Sâles" },
    { zip: 1642, canton: "FR", commune: "Sorens" },
    { zip: 1627, canton: "FR", commune: "Vaulruz" },
    { zip: 1628, canton: "FR", commune: "Vuadens" },
    { zip: 1665, canton: "FR", commune: "Bas-Intyamon" },
    { zip: 1666, canton: "FR", commune: "Bas-Intyamon" },
    { zip: 1667, canton: "FR", commune: "Bas-Intyamon" },
    { zip: 1637, canton: "FR", commune: "Val-de-Charmey" },
    { zip: 1654, canton: "FR", commune: "Val-de-Charmey" },
    { zip: 1716, canton: "FR", commune: "Val-de-Charmey" },
    { zip: 1725, canton: "FR", commune: "Arconciel" },
    { zip: 1732, canton: "FR", commune: "Arconciel" },
    { zip: 1742, canton: "FR", commune: "Autigny" },
    { zip: 1745, canton: "FR", commune: "Autigny" },
    { zip: 1754, canton: "FR", commune: "Avry" },
    { zip: 1782, canton: "FR", commune: "Belfaux" },
    { zip: 1744, canton: "FR", commune: "Chénens" },
    { zip: 1720, canton: "FR", commune: "Corminboeuf" },
    { zip: 1753, canton: "FR", commune: "Corminboeuf" },
    { zip: 1747, canton: "FR", commune: "Corserey" },
    { zip: 1741, canton: "FR", commune: "Cottens (FR)" },
    { zip: 1731, canton: "FR", commune: "Ependes (FR)" },
    { zip: 1724, canton: "FR", commune: "Ferpicloz" },
    { zip: 1700, canton: "FR", commune: "Fribourg" },
    { zip: 1722, canton: "FR", commune: "Fribourg" },
    { zip: 1762, canton: "FR", commune: "Givisiez" },
    { zip: 1763, canton: "FR", commune: "Granges-Paccot" },
    { zip: 1772, canton: "FR", commune: "Grolley" },
    { zip: 1723, canton: "FR", commune: "Marly" },
    { zip: 1753, canton: "FR", commune: "Matran" },
    { zip: 1740, canton: "FR", commune: "Neyruz (FR)" },
    { zip: 1757, canton: "FR", commune: "Noréaz" },
    { zip: 1723, canton: "FR", commune: "Pierrafortscha" },
    { zip: 1772, canton: "FR", commune: "Ponthaux" },
    { zip: 1724, canton: "FR", commune: "Le Mouret" },
    { zip: 1746, canton: "FR", commune: "Prez-vers-Noréaz" },
    { zip: 1724, canton: "FR", commune: "Senèdes" },
    { zip: 1724, canton: "FR", commune: "Treyvaux" },
    { zip: 1733, canton: "FR", commune: "Treyvaux" },
    { zip: 1752, canton: "FR", commune: "Villars-sur-Glâne" },
    { zip: 1723, canton: "FR", commune: "Villarsel-sur-Marly" },
    { zip: 1725, canton: "FR", commune: "Hauterive (FR)" },
    { zip: 1730, canton: "FR", commune: "Hauterive (FR)" },
    { zip: 1745, canton: "FR", commune: "La Brillaz" },
    { zip: 1756, canton: "FR", commune: "La Brillaz" },
    { zip: 1782, canton: "FR", commune: "La Sonnaz" },
    { zip: 1695, canton: "FR", commune: "Gibloux" },
    { zip: 1696, canton: "FR", commune: "Gibloux" },
    { zip: 1726, canton: "FR", commune: "Gibloux" },
    { zip: 1727, canton: "FR", commune: "Gibloux" },
    { zip: 1728, canton: "FR", commune: "Gibloux" },
    { zip: 1796, canton: "FR", commune: "Courgevaux" },
    { zip: 3280, canton: "FR", commune: "Courgevaux" },
    { zip: 1583, canton: "FR", commune: "Courtepin" },
    { zip: 1783, canton: "FR", commune: "Courtepin" },
    { zip: 1784, canton: "FR", commune: "Courtepin" },
    { zip: 1791, canton: "FR", commune: "Courtepin" },
    { zip: 1785, canton: "FR", commune: "Cressier (FR)" },
    { zip: 3284, canton: "FR", commune: "Fräschels" },
    { zip: 3285, canton: "FR", commune: "Galmiz" },
    { zip: 3215, canton: "FR", commune: "Gempenach" },
    { zip: 3280, canton: "FR", commune: "Greng" },
    { zip: 1792, canton: "FR", commune: "Gurmels" },
    { zip: 3179, canton: "FR", commune: "Gurmels" },
    { zip: 3205, canton: "FR", commune: "Gurmels" },
    { zip: 3206, canton: "FR", commune: "Gurmels" },
    { zip: 3212, canton: "FR", commune: "Gurmels" },
    { zip: 3213, canton: "FR", commune: "Gurmels" },
    { zip: 3207, canton: "FR", commune: "Kerzers" },
    { zip: 3210, canton: "FR", commune: "Kerzers" },
    { zip: 3213, canton: "FR", commune: "Kleinbösingen" },
    { zip: 3280, canton: "FR", commune: "Meyriez" },
    { zip: 1721, canton: "FR", commune: "Misery-Courtion" },
    { zip: 3286, canton: "FR", commune: "Muntelier" },
    { zip: 1793, canton: "FR", commune: "Murten" },
    { zip: 1794, canton: "FR", commune: "Murten" },
    { zip: 1795, canton: "FR", commune: "Murten" },
    { zip: 3215, canton: "FR", commune: "Murten" },
    { zip: 3280, canton: "FR", commune: "Murten" },
    { zip: 3285, canton: "FR", commune: "Murten" },
    { zip: 3216, canton: "FR", commune: "Ried bei Kerzers" },
    { zip: 3214, canton: "FR", commune: "Ulmiz" },
    { zip: 1786, canton: "FR", commune: "Mont-Vully" },
    { zip: 1787, canton: "FR", commune: "Mont-Vully" },
    { zip: 1788, canton: "FR", commune: "Mont-Vully" },
    { zip: 1789, canton: "FR", commune: "Mont-Vully" },
    { zip: 1712, canton: "FR", commune: "Alterswil" },
    { zip: 1713, canton: "FR", commune: "Alterswil" },
    { zip: 1715, canton: "FR", commune: "Alterswil" },
    { zip: 1717, canton: "FR", commune: "Alterswil" },
    { zip: 1719, canton: "FR", commune: "Brünisried" },
    { zip: 1700, canton: "FR", commune: "Düdingen" },
    { zip: 3186, canton: "FR", commune: "Düdingen" },
    { zip: 1735, canton: "FR", commune: "Giffers" },
    { zip: 3178, canton: "FR", commune: "Bösingen" },
    { zip: 3184, canton: "FR", commune: "Bösingen" },
    { zip: 3185, canton: "FR", commune: "Bösingen" },
    { zip: 1714, canton: "FR", commune: "Heitenried" },
    { zip: 1716, canton: "FR", commune: "Plaffeien" },
    { zip: 1719, canton: "FR", commune: "Plaffeien" },
    { zip: 1738, canton: "FR", commune: "Plaffeien" },
    { zip: 1737, canton: "FR", commune: "Plasselb" },
    { zip: 1718, canton: "FR", commune: "Rechthalten" },
    { zip: 1735, canton: "FR", commune: "Rechthalten" },
    { zip: 1713, canton: "FR", commune: "St. Antoni" },
    { zip: 1714, canton: "FR", commune: "St. Antoni" },
    { zip: 1715, canton: "FR", commune: "St. Antoni" },
    { zip: 3182, canton: "FR", commune: "St. Antoni" },
    { zip: 3185, canton: "FR", commune: "St. Antoni" },
    { zip: 1724, canton: "FR", commune: "St. Silvester" },
    { zip: 1734, canton: "FR", commune: "St. Silvester" },
    { zip: 1736, canton: "FR", commune: "St. Silvester" },
    { zip: 1715, canton: "FR", commune: "St. Ursen" },
    { zip: 1717, canton: "FR", commune: "St. Ursen" },
    { zip: 1718, canton: "FR", commune: "St. Ursen" },
    { zip: 1712, canton: "FR", commune: "Schmitten (FR)" },
    { zip: 1713, canton: "FR", commune: "Schmitten (FR)" },
    { zip: 3182, canton: "FR", commune: "Schmitten (FR)" },
    { zip: 3185, canton: "FR", commune: "Schmitten (FR)" },
    { zip: 1700, canton: "FR", commune: "Tafers" },
    { zip: 1712, canton: "FR", commune: "Tafers" },
    { zip: 1713, canton: "FR", commune: "Tafers" },
    { zip: 1734, canton: "FR", commune: "Tentlingen" },
    { zip: 3182, canton: "FR", commune: "Ueberstorf" },
    { zip: 3175, canton: "FR", commune: "Wünnewil-Flamatt" },
    { zip: 3176, canton: "FR", commune: "Wünnewil-Flamatt" },
    { zip: 3184, canton: "FR", commune: "Wünnewil-Flamatt" },
    { zip: 3185, canton: "FR", commune: "Wünnewil-Flamatt" },
    { zip: 1612, canton: "FR", commune: "Attalens" },
    { zip: 1616, canton: "FR", commune: "Attalens" },
    { zip: 1617, canton: "FR", commune: "Attalens" },
    { zip: 1808, canton: "FR", commune: "Attalens" },
    { zip: 1615, canton: "FR", commune: "Bossonnens" },
    { zip: 1618, canton: "FR", commune: "Châtel-Saint-Denis" },
    { zip: 1619, canton: "FR", commune: "Châtel-Saint-Denis" },
    { zip: 1614, canton: "FR", commune: "Granges (Veveyse)" },
    { zip: 1617, canton: "FR", commune: "Remaufens" },
    { zip: 1618, canton: "FR", commune: "Remaufens" },
    { zip: 1609, canton: "FR", commune: "Saint-Martin (FR)" },
    { zip: 1623, canton: "FR", commune: "Semsales" },
    { zip: 1624, canton: "FR", commune: "Semsales" },
    { zip: 1627, canton: "FR", commune: "Semsales" },
    { zip: 1699, canton: "FR", commune: "Le Flon" },
    { zip: 1611, canton: "FR", commune: "La Verrerie" },
    { zip: 1624, canton: "FR", commune: "La Verrerie" },
    { zip: 4622, canton: "SO", commune: "Egerkingen" },
    { zip: 4624, canton: "SO", commune: "Härkingen" },
    { zip: 4703, canton: "SO", commune: "Kestenholz" },
    { zip: 4623, canton: "SO", commune: "Neuendorf" },
    { zip: 4626, canton: "SO", commune: "Niederbuchsiten" },
    { zip: 4625, canton: "SO", commune: "Oberbuchsiten" },
    { zip: 4718, canton: "SO", commune: "Oberbuchsiten" },
    { zip: 4702, canton: "SO", commune: "Oensingen" },
    { zip: 4710, canton: "SO", commune: "Oensingen" },
    { zip: 4628, canton: "SO", commune: "Wolfwil" },
    { zip: 2747, canton: "SO", commune: "Aedermannsdorf" },
    { zip: 4714, canton: "SO", commune: "Aedermannsdorf" },
    { zip: 4717, canton: "SO", commune: "Aedermannsdorf" },
    { zip: 4719, canton: "SO", commune: "Aedermannsdorf" },
    { zip: 4710, canton: "SO", commune: "Balsthal" },
    { zip: 4717, canton: "SO", commune: "Balsthal" },
    { zip: 4716, canton: "SO", commune: "Gänsbrunnen" },
    { zip: 4715, canton: "SO", commune: "Herbetswil" },
    { zip: 4438, canton: "SO", commune: "Holderbank (SO)" },
    { zip: 4718, canton: "SO", commune: "Holderbank (SO)" },
    { zip: 4712, canton: "SO", commune: "Laupersdorf" },
    { zip: 4717, canton: "SO", commune: "Laupersdorf" },
    { zip: 4713, canton: "SO", commune: "Matzendorf" },
    { zip: 4229, canton: "SO", commune: "Mümliswil-Ramiswil" },
    { zip: 4418, canton: "SO", commune: "Mümliswil-Ramiswil" },
    { zip: 4717, canton: "SO", commune: "Mümliswil-Ramiswil" },
    { zip: 4719, canton: "SO", commune: "Mümliswil-Ramiswil" },
    { zip: 4716, canton: "SO", commune: "Welschenrohr" },
    { zip: 4585, canton: "SO", commune: "Biezwil" },
    { zip: 4571, canton: "SO", commune: "Lüterkofen-Ichertswil" },
    { zip: 4584, canton: "SO", commune: "Lüterswil-Gächliwil" },
    { zip: 3254, canton: "SO", commune: "Messen" },
    { zip: 3307, canton: "SO", commune: "Messen" },
    { zip: 4588, canton: "SO", commune: "Messen" },
    { zip: 3253, canton: "SO", commune: "Schnottwil" },
    { zip: 4588, canton: "SO", commune: "Unterramsern" },
    { zip: 4574, canton: "SO", commune: "Lüsslingen-Nennigkofen" },
    { zip: 4576, canton: "SO", commune: "Buchegg" },
    { zip: 4577, canton: "SO", commune: "Buchegg" },
    { zip: 4578, canton: "SO", commune: "Buchegg" },
    { zip: 4579, canton: "SO", commune: "Buchegg" },
    { zip: 4581, canton: "SO", commune: "Buchegg" },
    { zip: 4582, canton: "SO", commune: "Buchegg" },
    { zip: 4583, canton: "SO", commune: "Buchegg" },
    { zip: 4586, canton: "SO", commune: "Buchegg" },
    { zip: 4587, canton: "SO", commune: "Buchegg" },
    { zip: 4588, canton: "SO", commune: "Buchegg" },
    { zip: 4112, canton: "SO", commune: "Bättwil" },
    { zip: 4413, canton: "SO", commune: "Büren (SO)" },
    { zip: 4143, canton: "SO", commune: "Dornach" },
    { zip: 4145, canton: "SO", commune: "Gempen" },
    { zip: 4146, canton: "SO", commune: "Hochwald" },
    { zip: 4112, canton: "SO", commune: "Hofstetten-Flüh" },
    { zip: 4114, canton: "SO", commune: "Hofstetten-Flüh" },
    { zip: 4115, canton: "SO", commune: "Hofstetten-Flüh" },
    { zip: 4115, canton: "SO", commune: "Metzerlen-Mariastein" },
    { zip: 4116, canton: "SO", commune: "Metzerlen-Mariastein" },
    { zip: 4412, canton: "SO", commune: "Nuglar-St. Pantaleon" },
    { zip: 4421, canton: "SO", commune: "Nuglar-St. Pantaleon" },
    { zip: 4118, canton: "SO", commune: "Rodersdorf" },
    { zip: 4206, canton: "SO", commune: "Seewen" },
    { zip: 4108, canton: "SO", commune: "Witterswil" },
    { zip: 4112, canton: "SO", commune: "Witterswil" },
    { zip: 4633, canton: "SO", commune: "Hauenstein-Ifenthal" },
    { zip: 4468, canton: "SO", commune: "Kienberg" },
    { zip: 4634, canton: "SO", commune: "Lostorf" },
    { zip: 4654, canton: "SO", commune: "Lostorf" },
    { zip: 5013, canton: "SO", commune: "Niedergösgen" },
    { zip: 4653, canton: "SO", commune: "Obergösgen" },
    { zip: 4655, canton: "SO", commune: "Rohr (SO)" },
    { zip: 4655, canton: "SO", commune: "Stüsslingen" },
    { zip: 4600, canton: "SO", commune: "Trimbach" },
    { zip: 4632, canton: "SO", commune: "Trimbach" },
    { zip: 4634, canton: "SO", commune: "Trimbach" },
    { zip: 4652, canton: "SO", commune: "Winznau" },
    { zip: 4654, canton: "SO", commune: "Winznau" },
    { zip: 4634, canton: "SO", commune: "Wisen (SO)" },
    { zip: 5015, canton: "SO", commune: "Erlinsbach (SO)" },
    { zip: 5017, canton: "SO", commune: "Erlinsbach (SO)" },
    { zip: 4556, canton: "SO", commune: "Aeschi (SO)" },
    { zip: 4500, canton: "SO", commune: "Biberist" },
    { zip: 4528, canton: "SO", commune: "Biberist" },
    { zip: 4562, canton: "SO", commune: "Biberist" },
    { zip: 4574, canton: "SO", commune: "Biberist" },
    { zip: 4556, canton: "SO", commune: "Bolken" },
    { zip: 4542, canton: "SO", commune: "Deitingen" },
    { zip: 4543, canton: "SO", commune: "Deitingen" },
    { zip: 4552, canton: "SO", commune: "Derendingen" },
    { zip: 4554, canton: "SO", commune: "Etziken" },
    { zip: 4563, canton: "SO", commune: "Gerlafingen" },
    { zip: 4566, canton: "SO", commune: "Halten" },
    { zip: 4557, canton: "SO", commune: "Horriwil" },
    { zip: 4554, canton: "SO", commune: "Hüniken" },
    { zip: 4563, canton: "SO", commune: "Kriegstetten" },
    { zip: 4566, canton: "SO", commune: "Kriegstetten" },
    { zip: 4573, canton: "SO", commune: "Lohn-Ammannsegg" },
    { zip: 4542, canton: "SO", commune: "Luterbach" },
    { zip: 4552, canton: "SO", commune: "Luterbach" },
    { zip: 4563, canton: "SO", commune: "Obergerlafingen" },
    { zip: 4564, canton: "SO", commune: "Obergerlafingen" },
    { zip: 4566, canton: "SO", commune: "Oekingen" },
    { zip: 4565, canton: "SO", commune: "Recherswil" },
    { zip: 4553, canton: "SO", commune: "Subingen" },
    { zip: 4528, canton: "SO", commune: "Zuchwil" },
    { zip: 4558, canton: "SO", commune: "Drei Höfe" },
    { zip: 4524, canton: "SO", commune: "Balm bei Günsberg" },
    { zip: 4525, canton: "SO", commune: "Balm bei Günsberg" },
    { zip: 4500, canton: "SO", commune: "Bellach" },
    { zip: 4512, canton: "SO", commune: "Bellach" },
    { zip: 2544, canton: "SO", commune: "Bettlach" },
    { zip: 4532, canton: "SO", commune: "Feldbrunnen-St. Niklaus" },
    { zip: 4534, canton: "SO", commune: "Flumenthal" },
    { zip: 4543, canton: "SO", commune: "Flumenthal" },
    { zip: 2540, canton: "SO", commune: "Grenchen" },
    { zip: 4524, canton: "SO", commune: "Günsberg" },
    { zip: 4535, canton: "SO", commune: "Hubersdorf" },
    { zip: 4535, canton: "SO", commune: "Kammersrohr" },
    { zip: 4500, canton: "SO", commune: "Langendorf" },
    { zip: 4513, canton: "SO", commune: "Langendorf" },
    { zip: 4512, canton: "SO", commune: "Lommiswil" },
    { zip: 4514, canton: "SO", commune: "Lommiswil" },
    { zip: 4515, canton: "SO", commune: "Oberdorf (SO)" },
    { zip: 4522, canton: "SO", commune: "Oberdorf (SO)" },
    { zip: 4523, canton: "SO", commune: "Riedholz" },
    { zip: 4533, canton: "SO", commune: "Riedholz" },
    { zip: 4500, canton: "SO", commune: "Rüttenen" },
    { zip: 4522, canton: "SO", commune: "Rüttenen" },
    { zip: 4532, canton: "SO", commune: "Rüttenen" },
    { zip: 2545, canton: "SO", commune: "Selzach" },
    { zip: 4574, canton: "SO", commune: "Selzach" },
    { zip: 4618, canton: "SO", commune: "Boningen" },
    { zip: 4658, canton: "SO", commune: "Däniken" },
    { zip: 4657, canton: "SO", commune: "Dulliken" },
    { zip: 5746, canton: "SO", commune: "Dulliken" },
    { zip: 5012, canton: "SO", commune: "Eppenberg-Wöschnau" },
    { zip: 4629, canton: "SO", commune: "Fulenbach" },
    { zip: 4658, canton: "SO", commune: "Gretzenbach" },
    { zip: 5014, canton: "SO", commune: "Gretzenbach" },
    { zip: 4614, canton: "SO", commune: "Gunzgen" },
    { zip: 4616, canton: "SO", commune: "Gunzgen" },
    { zip: 4617, canton: "SO", commune: "Gunzgen" },
    { zip: 4438, canton: "SO", commune: "Hägendorf" },
    { zip: 4614, canton: "SO", commune: "Hägendorf" },
    { zip: 4615, canton: "SO", commune: "Hägendorf" },
    { zip: 4616, canton: "SO", commune: "Kappel (SO)" },
    { zip: 4618, canton: "SO", commune: "Kappel (SO)" },
    { zip: 4600, canton: "SO", commune: "Olten" },
    { zip: 4613, canton: "SO", commune: "Rickenbach (SO)" },
    { zip: 5012, canton: "SO", commune: "Schönenwerd" },
    { zip: 4600, canton: "SO", commune: "Starrkirch-Wil" },
    { zip: 4656, canton: "SO", commune: "Starrkirch-Wil" },
    { zip: 4657, canton: "SO", commune: "Starrkirch-Wil" },
    { zip: 5746, canton: "SO", commune: "Walterswil (SO)" },
    { zip: 4612, canton: "SO", commune: "Wangen bei Olten" },
    { zip: 4632, canton: "SO", commune: "Wangen bei Olten" },
    { zip: 4500, canton: "SO", commune: "Solothurn" },
    { zip: 4252, canton: "SO", commune: "Bärschwil" },
    { zip: 4253, canton: "SO", commune: "Bärschwil" },
    { zip: 2827, canton: "SO", commune: "Beinwil (SO)" },
    { zip: 4229, canton: "SO", commune: "Beinwil (SO)" },
    { zip: 4226, canton: "SO", commune: "Breitenbach" },
    { zip: 4227, canton: "SO", commune: "Büsserach" },
    { zip: 4228, canton: "SO", commune: "Erschwil" },
    { zip: 4232, canton: "SO", commune: "Fehren" },
    { zip: 4247, canton: "SO", commune: "Grindel" },
    { zip: 4204, canton: "SO", commune: "Himmelried" },
    { zip: 2814, canton: "SO", commune: "Kleinlützel" },
    { zip: 4245, canton: "SO", commune: "Kleinlützel" },
    { zip: 4233, canton: "SO", commune: "Meltingen" },
    { zip: 4208, canton: "SO", commune: "Nunningen" },
    { zip: 4234, canton: "SO", commune: "Zullwil" },
    { zip: 4001, canton: "BS", commune: "Basel" },
    { zip: 4051, canton: "BS", commune: "Basel" },
    { zip: 4052, canton: "BS", commune: "Basel" },
    { zip: 4053, canton: "BS", commune: "Basel" },
    { zip: 4054, canton: "BS", commune: "Basel" },
    { zip: 4055, canton: "BS", commune: "Basel" },
    { zip: 4056, canton: "BS", commune: "Basel" },
    { zip: 4057, canton: "BS", commune: "Basel" },
    { zip: 4058, canton: "BS", commune: "Basel" },
    { zip: 4059, canton: "BS", commune: "Basel" },
    { zip: 4126, canton: "BS", commune: "Bettingen" },
    { zip: 4058, canton: "BS", commune: "Riehen" },
    { zip: 4125, canton: "BS", commune: "Riehen" },
    { zip: 4147, canton: "BL", commune: "Aesch (BL)" },
    { zip: 4153, canton: "BL", commune: "Aesch (BL)" },
    { zip: 4202, canton: "BL", commune: "Aesch (BL)" },
    { zip: 4123, canton: "BL", commune: "Allschwil" },
    { zip: 4144, canton: "BL", commune: "Arlesheim" },
    { zip: 4105, canton: "BL", commune: "Biel-Benken" },
    { zip: 4053, canton: "BL", commune: "Binningen" },
    { zip: 4101, canton: "BL", commune: "Binningen" },
    { zip: 4102, canton: "BL", commune: "Binningen" },
    { zip: 4127, canton: "BL", commune: "Birsfelden" },
    { zip: 4101, canton: "BL", commune: "Bottmingen" },
    { zip: 4102, canton: "BL", commune: "Bottmingen" },
    { zip: 4103, canton: "BL", commune: "Bottmingen" },
    { zip: 4107, canton: "BL", commune: "Ettingen" },
    { zip: 4052, canton: "BL", commune: "Münchenstein" },
    { zip: 4142, canton: "BL", commune: "Münchenstein" },
    { zip: 4153, canton: "BL", commune: "Münchenstein" },
    { zip: 4127, canton: "BL", commune: "Muttenz" },
    { zip: 4132, canton: "BL", commune: "Muttenz" },
    { zip: 4133, canton: "BL", commune: "Muttenz" },
    { zip: 4142, canton: "BL", commune: "Muttenz" },
    { zip: 4104, canton: "BL", commune: "Oberwil (BL)" },
    { zip: 4147, canton: "BL", commune: "Pfeffingen" },
    { zip: 4148, canton: "BL", commune: "Pfeffingen" },
    { zip: 4202, canton: "BL", commune: "Pfeffingen" },
    { zip: 4144, canton: "BL", commune: "Reinach (BL)" },
    { zip: 4153, canton: "BL", commune: "Reinach (BL)" },
    { zip: 4124, canton: "BL", commune: "Schönenbuch" },
    { zip: 4106, canton: "BL", commune: "Therwil" },
    { zip: 4153, canton: "BL", commune: "Therwil" },
    { zip: 4223, canton: "BL", commune: "Blauen" },
    { zip: 4225, canton: "BL", commune: "Brislach" },
    { zip: 4242, canton: "BL", commune: "Brislach" },
    { zip: 4117, canton: "BL", commune: "Burg im Leimental" },
    { zip: 4243, canton: "BL", commune: "Dittingen" },
    { zip: 4202, canton: "BL", commune: "Duggingen" },
    { zip: 4203, canton: "BL", commune: "Grellingen" },
    { zip: 4242, canton: "BL", commune: "Laufen" },
    { zip: 4246, canton: "BL", commune: "Laufen" },
    { zip: 4252, canton: "BL", commune: "Laufen" },
    { zip: 4253, canton: "BL", commune: "Liesberg" },
    { zip: 4254, canton: "BL", commune: "Liesberg" },
    { zip: 4224, canton: "BL", commune: "Nenzlingen" },
    { zip: 2814, canton: "BL", commune: "Roggenburg" },
    { zip: 4245, canton: "BL", commune: "Roggenburg" },
    { zip: 4244, canton: "BL", commune: "Röschenz" },
    { zip: 4246, canton: "BL", commune: "Wahlen" },
    { zip: 4222, canton: "BL", commune: "Zwingen" },
    { zip: 4242, canton: "BL", commune: "Zwingen" },
    { zip: 4305, canton: "BL", commune: "Arisdorf" },
    { zip: 4422, canton: "BL", commune: "Arisdorf" },
    { zip: 4133, canton: "BL", commune: "Augst" },
    { zip: 4302, canton: "BL", commune: "Augst" },
    { zip: 4303, canton: "BL", commune: "Augst" },
    { zip: 4410, canton: "BL", commune: "Bubendorf" },
    { zip: 4416, canton: "BL", commune: "Bubendorf" },
    { zip: 4133, canton: "BL", commune: "Frenkendorf" },
    { zip: 4402, canton: "BL", commune: "Frenkendorf" },
    { zip: 4414, canton: "BL", commune: "Füllinsdorf" },
    { zip: 4303, canton: "BL", commune: "Giebenach" },
    { zip: 4304, canton: "BL", commune: "Giebenach" },
    { zip: 4423, canton: "BL", commune: "Hersberg" },
    { zip: 4415, canton: "BL", commune: "Lausen" },
    { zip: 4452, canton: "BL", commune: "Lausen" },
    { zip: 4410, canton: "BL", commune: "Liestal" },
    { zip: 4415, canton: "BL", commune: "Liestal" },
    { zip: 4422, canton: "BL", commune: "Liestal" },
    { zip: 4419, canton: "BL", commune: "Lupsingen" },
    { zip: 4133, canton: "BL", commune: "Pratteln" },
    { zip: 4302, canton: "BL", commune: "Pratteln" },
    { zip: 4402, canton: "BL", commune: "Pratteln" },
    { zip: 4433, canton: "BL", commune: "Ramlinsburg" },
    { zip: 4411, canton: "BL", commune: "Seltisberg" },
    { zip: 4412, canton: "BL", commune: "Seltisberg" },
    { zip: 4417, canton: "BL", commune: "Ziefen" },
    { zip: 4469, canton: "BL", commune: "Anwil" },
    { zip: 4450, canton: "BL", commune: "Böckten" },
    { zip: 4461, canton: "BL", commune: "Böckten" },
    { zip: 4444, canton: "BL", commune: "Buckten" },
    { zip: 4445, canton: "BL", commune: "Buckten" },
    { zip: 4446, canton: "BL", commune: "Buckten" },
    { zip: 4447, canton: "BL", commune: "Buckten" },
    { zip: 4462, canton: "BL", commune: "Buus" },
    { zip: 4463, canton: "BL", commune: "Buus" },
    { zip: 4442, canton: "BL", commune: "Diepflingen" },
    { zip: 4444, canton: "BL", commune: "Gelterkinden" },
    { zip: 4460, canton: "BL", commune: "Gelterkinden" },
    { zip: 4445, canton: "BL", commune: "Häfelfingen" },
    { zip: 4448, canton: "BL", commune: "Häfelfingen" },
    { zip: 4465, canton: "BL", commune: "Hemmiken" },
    { zip: 4466, canton: "BL", commune: "Hemmiken" },
    { zip: 4450, canton: "BL", commune: "Itingen" },
    { zip: 4452, canton: "BL", commune: "Itingen" },
    { zip: 4447, canton: "BL", commune: "Känerkinden" },
    { zip: 4493, canton: "BL", commune: "Kilchberg (BL)" },
    { zip: 4496, canton: "BL", commune: "Kilchberg (BL)" },
    { zip: 4446, canton: "BL", commune: "Läufelfingen" },
    { zip: 4448, canton: "BL", commune: "Läufelfingen" },
    { zip: 4458, canton: "BL", commune: "Läufelfingen" },
    { zip: 4634, canton: "BL", commune: "Läufelfingen" },
    { zip: 4451, canton: "BL", commune: "Maisprach" },
    { zip: 4464, canton: "BL", commune: "Maisprach" },
    { zip: 4453, canton: "BL", commune: "Nusshof" },
    { zip: 4493, canton: "BL", commune: "Oltingen" },
    { zip: 4494, canton: "BL", commune: "Oltingen" },
    { zip: 4460, canton: "BL", commune: "Ormalingen" },
    { zip: 4465, canton: "BL", commune: "Ormalingen" },
    { zip: 4466, canton: "BL", commune: "Ormalingen" },
    { zip: 4462, canton: "BL", commune: "Rickenbach (BL)" },
    { zip: 4467, canton: "BL", commune: "Rothenfluh" },
    { zip: 4444, canton: "BL", commune: "Rümlingen" },
    { zip: 4497, canton: "BL", commune: "Rünenberg" },
    { zip: 4450, canton: "BL", commune: "Sissach" },
    { zip: 4492, canton: "BL", commune: "Tecknau" },
    { zip: 4443, canton: "BL", commune: "Tenniken" },
    { zip: 4456, canton: "BL", commune: "Tenniken" },
    { zip: 4441, canton: "BL", commune: "Thürnen" },
    { zip: 4450, canton: "BL", commune: "Thürnen" },
    { zip: 4492, canton: "BL", commune: "Wenslingen" },
    { zip: 4493, canton: "BL", commune: "Wenslingen" },
    { zip: 4495, canton: "BL", commune: "Wenslingen" },
    { zip: 4451, canton: "BL", commune: "Wintersingen" },
    { zip: 4442, canton: "BL", commune: "Wittinsburg" },
    { zip: 4443, canton: "BL", commune: "Wittinsburg" },
    { zip: 4444, canton: "BL", commune: "Wittinsburg" },
    { zip: 4495, canton: "BL", commune: "Zeglingen" },
    { zip: 4455, canton: "BL", commune: "Zunzgen" },
    { zip: 4424, canton: "BL", commune: "Arboldswil" },
    { zip: 4425, canton: "BL", commune: "Arboldswil" },
    { zip: 4431, canton: "BL", commune: "Bennwil" },
    { zip: 4434, canton: "BL", commune: "Bennwil" },
    { zip: 4457, canton: "BL", commune: "Bennwil" },
    { zip: 4207, canton: "BL", commune: "Bretzwil" },
    { zip: 4447, canton: "BL", commune: "Diegten" },
    { zip: 4448, canton: "BL", commune: "Diegten" },
    { zip: 4456, canton: "BL", commune: "Diegten" },
    { zip: 4457, canton: "BL", commune: "Diegten" },
    { zip: 4458, canton: "BL", commune: "Eptingen" },
    { zip: 4434, canton: "BL", commune: "Hölstein" },
    { zip: 4457, canton: "BL", commune: "Hölstein" },
    { zip: 4432, canton: "BL", commune: "Lampenberg" },
    { zip: 4438, canton: "BL", commune: "Langenbruck" },
    { zip: 4229, canton: "BL", commune: "Lauwil" },
    { zip: 4418, canton: "BL", commune: "Lauwil" },
    { zip: 4426, canton: "BL", commune: "Lauwil" },
    { zip: 4719, canton: "BL", commune: "Lauwil" },
    { zip: 4436, canton: "BL", commune: "Liedertswil" },
    { zip: 4424, canton: "BL", commune: "Niederdorf" },
    { zip: 4431, canton: "BL", commune: "Niederdorf" },
    { zip: 4435, canton: "BL", commune: "Niederdorf" },
    { zip: 4436, canton: "BL", commune: "Niederdorf" },
    { zip: 4435, canton: "BL", commune: "Oberdorf (BL)" },
    { zip: 4436, canton: "BL", commune: "Oberdorf (BL)" },
    { zip: 4437, canton: "BL", commune: "Oberdorf (BL)" },
    { zip: 4418, canton: "BL", commune: "Reigoldswil" },
    { zip: 4425, canton: "BL", commune: "Titterten" },
    { zip: 4418, canton: "BL", commune: "Waldenburg" },
    { zip: 4437, canton: "BL", commune: "Waldenburg" },
    { zip: 4438, canton: "BL", commune: "Waldenburg" },
    { zip: 8214, canton: "SH", commune: "Gächlingen" },
    { zip: 8225, canton: "SH", commune: "Gächlingen" },
    { zip: 8226, canton: "SH", commune: "Gächlingen" },
    { zip: 8224, canton: "SH", commune: "Löhningen" },
    { zip: 8213, canton: "SH", commune: "Neunkirch" },
    { zip: 8217, canton: "SH", commune: "Neunkirch" },
    { zip: 8223, canton: "SH", commune: "Neunkirch" },
    { zip: 8224, canton: "SH", commune: "Neunkirch" },
    { zip: 8236, canton: "SH", commune: "Büttenhardt" },
    { zip: 8239, canton: "SH", commune: "Dörflingen" },
    { zip: 8235, canton: "SH", commune: "Lohn (SH)" },
    { zip: 8234, canton: "SH", commune: "Stetten (SH)" },
    { zip: 8236, canton: "SH", commune: "Thayngen" },
    { zip: 8240, canton: "SH", commune: "Thayngen" },
    { zip: 8241, canton: "SH", commune: "Thayngen" },
    { zip: 8242, canton: "SH", commune: "Thayngen" },
    { zip: 8243, canton: "SH", commune: "Thayngen" },
    { zip: 8233, canton: "SH", commune: "Bargen (SH)" },
    { zip: 8222, canton: "SH", commune: "Beringen" },
    { zip: 8223, canton: "SH", commune: "Beringen" },
    { zip: 8454, canton: "SH", commune: "Buchberg" },
    { zip: 8232, canton: "SH", commune: "Merishausen" },
    { zip: 8200, canton: "SH", commune: "Neuhausen am Rheinfall" },
    { zip: 8212, canton: "SH", commune: "Neuhausen am Rheinfall" },
    { zip: 8455, canton: "SH", commune: "Rüdlingen" },
    { zip: 8200, canton: "SH", commune: "Schaffhausen" },
    { zip: 8203, canton: "SH", commune: "Schaffhausen" },
    { zip: 8207, canton: "SH", commune: "Schaffhausen" },
    { zip: 8208, canton: "SH", commune: "Schaffhausen" },
    { zip: 8212, canton: "SH", commune: "Schaffhausen" },
    { zip: 8222, canton: "SH", commune: "Schaffhausen" },
    { zip: 8231, canton: "SH", commune: "Schaffhausen" },
    { zip: 8226, canton: "SH", commune: "Beggingen" },
    { zip: 8228, canton: "SH", commune: "Beggingen" },
    { zip: 8226, canton: "SH", commune: "Schleitheim" },
    { zip: 8225, canton: "SH", commune: "Siblingen" },
    { zip: 8263, canton: "SH", commune: "Buch (SH)" },
    { zip: 8261, canton: "SH", commune: "Hemishofen" },
    { zip: 8262, canton: "SH", commune: "Ramsen" },
    { zip: 8260, canton: "SH", commune: "Stein am Rhein" },
    { zip: 8215, canton: "SH", commune: "Hallau" },
    { zip: 8216, canton: "SH", commune: "Oberhallau" },
    { zip: 8217, canton: "SH", commune: "Trasadingen" },
    { zip: 8219, canton: "SH", commune: "Trasadingen" },
    { zip: 8217, canton: "SH", commune: "Wilchingen" },
    { zip: 8218, canton: "SH", commune: "Wilchingen" },
    { zip: 9100, canton: "AR", commune: "Herisau" },
    { zip: 9112, canton: "AR", commune: "Herisau" },
    { zip: 9063, canton: "AR", commune: "Hundwil" },
    { zip: 9064, canton: "AR", commune: "Hundwil" },
    { zip: 9107, canton: "AR", commune: "Hundwil" },
    { zip: 9105, canton: "AR", commune: "Schönengrund" },
    { zip: 9107, canton: "AR", commune: "Schönengrund" },
    { zip: 9100, canton: "AR", commune: "Schwellbrunn" },
    { zip: 9103, canton: "AR", commune: "Schwellbrunn" },
    { zip: 9104, canton: "AR", commune: "Schwellbrunn" },
    { zip: 9105, canton: "AR", commune: "Schwellbrunn" },
    { zip: 9113, canton: "AR", commune: "Schwellbrunn" },
    { zip: 9014, canton: "AR", commune: "Stein (AR)" },
    { zip: 9063, canton: "AR", commune: "Stein (AR)" },
    { zip: 9103, canton: "AR", commune: "Urnäsch" },
    { zip: 9104, canton: "AR", commune: "Urnäsch" },
    { zip: 9107, canton: "AR", commune: "Urnäsch" },
    { zip: 9100, canton: "AR", commune: "Waldstatt" },
    { zip: 9103, canton: "AR", commune: "Waldstatt" },
    { zip: 9104, canton: "AR", commune: "Waldstatt" },
    { zip: 9043, canton: "AR", commune: "Bühler" },
    { zip: 9055, canton: "AR", commune: "Bühler" },
    { zip: 9043, canton: "AR", commune: "Gais" },
    { zip: 9055, canton: "AR", commune: "Gais" },
    { zip: 9056, canton: "AR", commune: "Gais" },
    { zip: 9450, canton: "AR", commune: "Gais" },
    { zip: 9037, canton: "AR", commune: "Speicher" },
    { zip: 9042, canton: "AR", commune: "Speicher" },
    { zip: 9012, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9042, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9052, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9053, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9055, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9062, canton: "AR", commune: "Teufen (AR)" },
    { zip: 9043, canton: "AR", commune: "Trogen" },
    { zip: 9035, canton: "AR", commune: "Grub (AR)" },
    { zip: 9038, canton: "AR", commune: "Grub (AR)" },
    { zip: 9036, canton: "AR", commune: "Heiden" },
    { zip: 9038, canton: "AR", commune: "Heiden" },
    { zip: 9405, canton: "AR", commune: "Heiden" },
    { zip: 9410, canton: "AR", commune: "Heiden" },
    { zip: 9413, canton: "AR", commune: "Heiden" },
    { zip: 9427, canton: "AR", commune: "Heiden" },
    { zip: 9405, canton: "AR", commune: "Lutzenberg" },
    { zip: 9426, canton: "AR", commune: "Lutzenberg" },
    { zip: 9427, canton: "AR", commune: "Lutzenberg" },
    { zip: 9034, canton: "AR", commune: "Rehetobel" },
    { zip: 9037, canton: "AR", commune: "Rehetobel" },
    { zip: 9038, canton: "AR", commune: "Rehetobel" },
    { zip: 9411, canton: "AR", commune: "Reute (AR)" },
    { zip: 9437, canton: "AR", commune: "Reute (AR)" },
    { zip: 9043, canton: "AR", commune: "Wald (AR)" },
    { zip: 9044, canton: "AR", commune: "Wald (AR)" },
    { zip: 9427, canton: "AR", commune: "Walzenhausen" },
    { zip: 9428, canton: "AR", commune: "Walzenhausen" },
    { zip: 9410, canton: "AR", commune: "Wolfhalden" },
    { zip: 9425, canton: "AR", commune: "Wolfhalden" },
    { zip: 9427, canton: "AR", commune: "Wolfhalden" },
    { zip: 9428, canton: "AR", commune: "Wolfhalden" },
    { zip: 9050, canton: "AI", commune: "Appenzell" },
    { zip: 9056, canton: "AI", commune: "Appenzell" },
    { zip: 9050, canton: "AI", commune: "Gonten" },
    { zip: 9108, canton: "AI", commune: "Gonten" },
    { zip: 9050, canton: "AI", commune: "Rüte" },
    { zip: 9057, canton: "AI", commune: "Rüte" },
    { zip: 9058, canton: "AI", commune: "Rüte" },
    { zip: 9467, canton: "AI", commune: "Rüte" },
    { zip: 9050, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9052, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9053, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9054, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9055, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9056, canton: "AI", commune: "Schlatt-Haslen" },
    { zip: 9050, canton: "AI", commune: "Schwende" },
    { zip: 9057, canton: "AI", commune: "Schwende" },
    { zip: 9058, canton: "AI", commune: "Schwende" },
    { zip: 9107, canton: "AI", commune: "Schwende" },
    { zip: 9108, canton: "AI", commune: "Schwende" },
    { zip: 9413, canton: "AI", commune: "Oberegg" },
    { zip: 9427, canton: "AI", commune: "Oberegg" },
    { zip: 9428, canton: "AI", commune: "Oberegg" },
    { zip: 9442, canton: "AI", commune: "Oberegg" },
    { zip: 9450, canton: "AI", commune: "Oberegg" },
    { zip: 9308, canton: "SG", commune: "Häggenschwil" },
    { zip: 9312, canton: "SG", commune: "Häggenschwil" },
    { zip: 9315, canton: "SG", commune: "Häggenschwil" },
    { zip: 8580, canton: "SG", commune: "Muolen" },
    { zip: 9220, canton: "SG", commune: "Muolen" },
    { zip: 9308, canton: "SG", commune: "Muolen" },
    { zip: 9313, canton: "SG", commune: "Muolen" },
    { zip: 9000, canton: "SG", commune: "St. Gallen" },
    { zip: 9008, canton: "SG", commune: "St. Gallen" },
    { zip: 9010, canton: "SG", commune: "St. Gallen" },
    { zip: 9011, canton: "SG", commune: "St. Gallen" },
    { zip: 9012, canton: "SG", commune: "St. Gallen" },
    { zip: 9014, canton: "SG", commune: "St. Gallen" },
    { zip: 9015, canton: "SG", commune: "St. Gallen" },
    { zip: 9016, canton: "SG", commune: "St. Gallen" },
    { zip: 9030, canton: "SG", commune: "St. Gallen" },
    { zip: 9037, canton: "SG", commune: "St. Gallen" },
    { zip: 9042, canton: "SG", commune: "St. Gallen" },
    { zip: 9300, canton: "SG", commune: "St. Gallen" },
    { zip: 9008, canton: "SG", commune: "Wittenbach" },
    { zip: 9300, canton: "SG", commune: "Wittenbach" },
    { zip: 9308, canton: "SG", commune: "Wittenbach" },
    { zip: 9300, canton: "SG", commune: "Berg (SG)" },
    { zip: 9305, canton: "SG", commune: "Berg (SG)" },
    { zip: 9306, canton: "SG", commune: "Berg (SG)" },
    { zip: 9034, canton: "SG", commune: "Eggersriet" },
    { zip: 9035, canton: "SG", commune: "Eggersriet" },
    { zip: 9036, canton: "SG", commune: "Eggersriet" },
    { zip: 9037, canton: "SG", commune: "Eggersriet" },
    { zip: 9405, canton: "SG", commune: "Eggersriet" },
    { zip: 9400, canton: "SG", commune: "Goldach" },
    { zip: 9402, canton: "SG", commune: "Goldach" },
    { zip: 9403, canton: "SG", commune: "Goldach" },
    { zip: 9327, canton: "SG", commune: "Mörschwil" },
    { zip: 9402, canton: "SG", commune: "Mörschwil" },
    { zip: 9400, canton: "SG", commune: "Rorschach" },
    { zip: 9404, canton: "SG", commune: "Rorschacherberg" },
    { zip: 9405, canton: "SG", commune: "Rorschacherberg" },
    { zip: 9422, canton: "SG", commune: "Rorschacherberg" },
    { zip: 9305, canton: "SG", commune: "Steinach" },
    { zip: 9323, canton: "SG", commune: "Steinach" },
    { zip: 9326, canton: "SG", commune: "Tübach" },
    { zip: 9327, canton: "SG", commune: "Tübach" },
    { zip: 9033, canton: "SG", commune: "Untereggen" },
    { zip: 9402, canton: "SG", commune: "Untereggen" },
    { zip: 9404, canton: "SG", commune: "Untereggen" },
    { zip: 9434, canton: "SG", commune: "Au (SG)" },
    { zip: 9435, canton: "SG", commune: "Au (SG)" },
    { zip: 9435, canton: "SG", commune: "Balgach" },
    { zip: 9436, canton: "SG", commune: "Balgach" },
    { zip: 9445, canton: "SG", commune: "Balgach" },
    { zip: 9411, canton: "SG", commune: "Berneck" },
    { zip: 9434, canton: "SG", commune: "Berneck" },
    { zip: 9435, canton: "SG", commune: "Berneck" },
    { zip: 9442, canton: "SG", commune: "Berneck" },
    { zip: 9436, canton: "SG", commune: "Diepoldsau" },
    { zip: 9443, canton: "SG", commune: "Diepoldsau" },
    { zip: 9444, canton: "SG", commune: "Diepoldsau" },
    { zip: 9424, canton: "SG", commune: "Rheineck" },
    { zip: 9425, canton: "SG", commune: "Rheineck" },
    { zip: 9426, canton: "SG", commune: "Rheineck" },
    { zip: 9424, canton: "SG", commune: "St. Margrethen" },
    { zip: 9428, canton: "SG", commune: "St. Margrethen" },
    { zip: 9430, canton: "SG", commune: "St. Margrethen" },
    { zip: 9404, canton: "SG", commune: "Thal" },
    { zip: 9422, canton: "SG", commune: "Thal" },
    { zip: 9423, canton: "SG", commune: "Thal" },
    { zip: 9425, canton: "SG", commune: "Thal" },
    { zip: 9427, canton: "SG", commune: "Thal" },
    { zip: 9435, canton: "SG", commune: "Widnau" },
    { zip: 9443, canton: "SG", commune: "Widnau" },
    { zip: 9058, canton: "SG", commune: "Altstätten" },
    { zip: 9450, canton: "SG", commune: "Altstätten" },
    { zip: 9452, canton: "SG", commune: "Altstätten" },
    { zip: 9453, canton: "SG", commune: "Altstätten" },
    { zip: 9463, canton: "SG", commune: "Altstätten" },
    { zip: 9464, canton: "SG", commune: "Altstätten" },
    { zip: 9452, canton: "SG", commune: "Eichberg" },
    { zip: 9453, canton: "SG", commune: "Eichberg" },
    { zip: 9437, canton: "SG", commune: "Marbach (SG)" },
    { zip: 9436, canton: "SG", commune: "Oberriet (SG)" },
    { zip: 9451, canton: "SG", commune: "Oberriet (SG)" },
    { zip: 9462, canton: "SG", commune: "Oberriet (SG)" },
    { zip: 9463, canton: "SG", commune: "Oberriet (SG)" },
    { zip: 9437, canton: "SG", commune: "Rebstein" },
    { zip: 9445, canton: "SG", commune: "Rebstein" },
    { zip: 9463, canton: "SG", commune: "Rüthi (SG)" },
    { zip: 9464, canton: "SG", commune: "Rüthi (SG)" },
    { zip: 9469, canton: "SG", commune: "Buchs (SG)" },
    { zip: 9470, canton: "SG", commune: "Buchs (SG)" },
    { zip: 9469, canton: "SG", commune: "Gams" },
    { zip: 9473, canton: "SG", commune: "Gams" },
    { zip: 9658, canton: "SG", commune: "Gams" },
    { zip: 9469, canton: "SG", commune: "Grabs" },
    { zip: 9470, canton: "SG", commune: "Grabs" },
    { zip: 9472, canton: "SG", commune: "Grabs" },
    { zip: 9658, canton: "SG", commune: "Grabs" },
    { zip: 9465, canton: "SG", commune: "Sennwald" },
    { zip: 9466, canton: "SG", commune: "Sennwald" },
    { zip: 9467, canton: "SG", commune: "Sennwald" },
    { zip: 9468, canton: "SG", commune: "Sennwald" },
    { zip: 9469, canton: "SG", commune: "Sennwald" },
    { zip: 9473, canton: "SG", commune: "Sennwald" },
    { zip: 9470, canton: "SG", commune: "Sevelen" },
    { zip: 9475, canton: "SG", commune: "Sevelen" },
    { zip: 9476, canton: "SG", commune: "Sevelen" },
    { zip: 9476, canton: "SG", commune: "Wartau" },
    { zip: 9477, canton: "SG", commune: "Wartau" },
    { zip: 9478, canton: "SG", commune: "Wartau" },
    { zip: 9479, canton: "SG", commune: "Wartau" },
    { zip: 7310, canton: "SG", commune: "Bad Ragaz" },
    { zip: 7317, canton: "SG", commune: "Bad Ragaz" },
    { zip: 8888, canton: "SG", commune: "Flums" },
    { zip: 8890, canton: "SG", commune: "Flums" },
    { zip: 8892, canton: "SG", commune: "Flums" },
    { zip: 8893, canton: "SG", commune: "Flums" },
    { zip: 8894, canton: "SG", commune: "Flums" },
    { zip: 8895, canton: "SG", commune: "Flums" },
    { zip: 8896, canton: "SG", commune: "Flums" },
    { zip: 8897, canton: "SG", commune: "Flums" },
    { zip: 8898, canton: "SG", commune: "Flums" },
    { zip: 7325, canton: "SG", commune: "Mels" },
    { zip: 7326, canton: "SG", commune: "Mels" },
    { zip: 8886, canton: "SG", commune: "Mels" },
    { zip: 8887, canton: "SG", commune: "Mels" },
    { zip: 8888, canton: "SG", commune: "Mels" },
    { zip: 8889, canton: "SG", commune: "Mels" },
    { zip: 7312, canton: "SG", commune: "Pfäfers" },
    { zip: 7313, canton: "SG", commune: "Pfäfers" },
    { zip: 7314, canton: "SG", commune: "Pfäfers" },
    { zip: 7315, canton: "SG", commune: "Pfäfers" },
    { zip: 7317, canton: "SG", commune: "Pfäfers" },
    { zip: 8877, canton: "SG", commune: "Quarten" },
    { zip: 8878, canton: "SG", commune: "Quarten" },
    { zip: 8882, canton: "SG", commune: "Quarten" },
    { zip: 8883, canton: "SG", commune: "Quarten" },
    { zip: 8884, canton: "SG", commune: "Quarten" },
    { zip: 8885, canton: "SG", commune: "Quarten" },
    { zip: 8896, canton: "SG", commune: "Quarten" },
    { zip: 8898, canton: "SG", commune: "Quarten" },
    { zip: 7320, canton: "SG", commune: "Sargans" },
    { zip: 8888, canton: "SG", commune: "Sargans" },
    { zip: 7323, canton: "SG", commune: "Vilters-Wangs" },
    { zip: 7324, canton: "SG", commune: "Vilters-Wangs" },
    { zip: 8880, canton: "SG", commune: "Walenstadt" },
    { zip: 8881, canton: "SG", commune: "Walenstadt" },
    { zip: 8890, canton: "SG", commune: "Walenstadt" },
    { zip: 8892, canton: "SG", commune: "Walenstadt" },
    { zip: 8893, canton: "SG", commune: "Walenstadt" },
    { zip: 8896, canton: "SG", commune: "Walenstadt" },
    { zip: 8872, canton: "SG", commune: "Amden" },
    { zip: 8873, canton: "SG", commune: "Amden" },
    { zip: 8717, canton: "SG", commune: "Benken (SG)" },
    { zip: 8722, canton: "SG", commune: "Kaltbrunn" },
    { zip: 8723, canton: "SG", commune: "Kaltbrunn" },
    { zip: 8737, canton: "SG", commune: "Kaltbrunn" },
    { zip: 8738, canton: "SG", commune: "Kaltbrunn" },
    { zip: 8739, canton: "SG", commune: "Kaltbrunn" },
    { zip: 8718, canton: "SG", commune: "Schänis" },
    { zip: 8722, canton: "SG", commune: "Schänis" },
    { zip: 8723, canton: "SG", commune: "Schänis" },
    { zip: 8866, canton: "SG", commune: "Schänis" },
    { zip: 8872, canton: "SG", commune: "Weesen" },
    { zip: 8716, canton: "SG", commune: "Schmerikon" },
    { zip: 8730, canton: "SG", commune: "Schmerikon" },
    { zip: 8730, canton: "SG", commune: "Uznach" },
    { zip: 8630, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8633, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8640, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8645, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8646, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8714, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8715, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8734, canton: "SG", commune: "Rapperswil-Jona" },
    { zip: 8725, canton: "SG", commune: "Gommiswald" },
    { zip: 8726, canton: "SG", commune: "Gommiswald" },
    { zip: 8730, canton: "SG", commune: "Gommiswald" },
    { zip: 8737, canton: "SG", commune: "Gommiswald" },
    { zip: 8738, canton: "SG", commune: "Gommiswald" },
    { zip: 8739, canton: "SG", commune: "Gommiswald" },
    { zip: 8636, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8637, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8638, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8725, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8727, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8732, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8733, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8734, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 8735, canton: "SG", commune: "Eschenbach (SG)" },
    { zip: 9633, canton: "SG", commune: "Ebnat-Kappel" },
    { zip: 9642, canton: "SG", commune: "Ebnat-Kappel" },
    { zip: 9643, canton: "SG", commune: "Ebnat-Kappel" },
    { zip: 9107, canton: "SG", commune: "Wildhaus-Alt St. Johann" },
    { zip: 9656, canton: "SG", commune: "Wildhaus-Alt St. Johann" },
    { zip: 9657, canton: "SG", commune: "Wildhaus-Alt St. Johann" },
    { zip: 9658, canton: "SG", commune: "Wildhaus-Alt St. Johann" },
    { zip: 9107, canton: "SG", commune: "Nesslau" },
    { zip: 9633, canton: "SG", commune: "Nesslau" },
    { zip: 9643, canton: "SG", commune: "Nesslau" },
    { zip: 9650, canton: "SG", commune: "Nesslau" },
    { zip: 9651, canton: "SG", commune: "Nesslau" },
    { zip: 9652, canton: "SG", commune: "Nesslau" },
    { zip: 9655, canton: "SG", commune: "Nesslau" },
    { zip: 9107, canton: "SG", commune: "Hemberg" },
    { zip: 9127, canton: "SG", commune: "Hemberg" },
    { zip: 9633, canton: "SG", commune: "Hemberg" },
    { zip: 9620, canton: "SG", commune: "Lichtensteig" },
    { zip: 9122, canton: "SG", commune: "Oberhelfenschwil" },
    { zip: 9125, canton: "SG", commune: "Oberhelfenschwil" },
    { zip: 9126, canton: "SG", commune: "Oberhelfenschwil" },
    { zip: 9620, canton: "SG", commune: "Oberhelfenschwil" },
    { zip: 9621, canton: "SG", commune: "Oberhelfenschwil" },
    { zip: 9103, canton: "SG", commune: "Neckertal" },
    { zip: 9105, canton: "SG", commune: "Neckertal" },
    { zip: 9113, canton: "SG", commune: "Neckertal" },
    { zip: 9114, canton: "SG", commune: "Neckertal" },
    { zip: 9115, canton: "SG", commune: "Neckertal" },
    { zip: 9116, canton: "SG", commune: "Neckertal" },
    { zip: 9122, canton: "SG", commune: "Neckertal" },
    { zip: 9123, canton: "SG", commune: "Neckertal" },
    { zip: 9125, canton: "SG", commune: "Neckertal" },
    { zip: 9126, canton: "SG", commune: "Neckertal" },
    { zip: 9127, canton: "SG", commune: "Neckertal" },
    { zip: 9620, canton: "SG", commune: "Neckertal" },
    { zip: 9630, canton: "SG", commune: "Neckertal" },
    { zip: 8726, canton: "SG", commune: "Wattwil" },
    { zip: 9615, canton: "SG", commune: "Wattwil" },
    { zip: 9620, canton: "SG", commune: "Wattwil" },
    { zip: 9622, canton: "SG", commune: "Wattwil" },
    { zip: 9630, canton: "SG", commune: "Wattwil" },
    { zip: 9631, canton: "SG", commune: "Wattwil" },
    { zip: 9633, canton: "SG", commune: "Wattwil" },
    { zip: 9642, canton: "SG", commune: "Wattwil" },
    { zip: 8376, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9500, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9532, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9533, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9534, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9601, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9602, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9613, canton: "SG", commune: "Kirchberg (SG)" },
    { zip: 9123, canton: "SG", commune: "Lütisburg" },
    { zip: 9243, canton: "SG", commune: "Lütisburg" },
    { zip: 9601, canton: "SG", commune: "Lütisburg" },
    { zip: 9602, canton: "SG", commune: "Lütisburg" },
    { zip: 9604, canton: "SG", commune: "Lütisburg" },
    { zip: 9608, canton: "SG", commune: "Lütisburg" },
    { zip: 8376, canton: "SG", commune: "Mosnang" },
    { zip: 8496, canton: "SG", commune: "Mosnang" },
    { zip: 9601, canton: "SG", commune: "Mosnang" },
    { zip: 9607, canton: "SG", commune: "Mosnang" },
    { zip: 9612, canton: "SG", commune: "Mosnang" },
    { zip: 9613, canton: "SG", commune: "Mosnang" },
    { zip: 9614, canton: "SG", commune: "Mosnang" },
    { zip: 9615, canton: "SG", commune: "Mosnang" },
    { zip: 9601, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9606, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9608, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9614, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9615, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9620, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9621, canton: "SG", commune: "Bütschwil-Ganterschwil" },
    { zip: 9113, canton: "SG", commune: "Degersheim" },
    { zip: 9116, canton: "SG", commune: "Degersheim" },
    { zip: 9230, canton: "SG", commune: "Degersheim" },
    { zip: 9113, canton: "SG", commune: "Flawil" },
    { zip: 9200, canton: "SG", commune: "Flawil" },
    { zip: 9230, canton: "SG", commune: "Flawil" },
    { zip: 9231, canton: "SG", commune: "Flawil" },
    { zip: 9242, canton: "SG", commune: "Jonschwil" },
    { zip: 9243, canton: "SG", commune: "Jonschwil" },
    { zip: 9532, canton: "SG", commune: "Jonschwil" },
    { zip: 9536, canton: "SG", commune: "Jonschwil" },
    { zip: 9604, canton: "SG", commune: "Jonschwil" },
    { zip: 9230, canton: "SG", commune: "Oberuzwil" },
    { zip: 9240, canton: "SG", commune: "Oberuzwil" },
    { zip: 9242, canton: "SG", commune: "Oberuzwil" },
    { zip: 9244, canton: "SG", commune: "Oberuzwil" },
    { zip: 9248, canton: "SG", commune: "Oberuzwil" },
    { zip: 9604, canton: "SG", commune: "Oberuzwil" },
    { zip: 9240, canton: "SG", commune: "Uzwil" },
    { zip: 9242, canton: "SG", commune: "Uzwil" },
    { zip: 9244, canton: "SG", commune: "Uzwil" },
    { zip: 9247, canton: "SG", commune: "Uzwil" },
    { zip: 9249, canton: "SG", commune: "Uzwil" },
    { zip: 9200, canton: "SG", commune: "Niederbüren" },
    { zip: 9203, canton: "SG", commune: "Niederbüren" },
    { zip: 9246, canton: "SG", commune: "Niederbüren" },
    { zip: 9223, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9245, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9524, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9525, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9526, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9527, canton: "SG", commune: "Niederhelfenschwil" },
    { zip: 9203, canton: "SG", commune: "Oberbüren" },
    { zip: 9230, canton: "SG", commune: "Oberbüren" },
    { zip: 9240, canton: "SG", commune: "Oberbüren" },
    { zip: 9245, canton: "SG", commune: "Oberbüren" },
    { zip: 9500, canton: "SG", commune: "Zuzwil (SG)" },
    { zip: 9515, canton: "SG", commune: "Zuzwil (SG)" },
    { zip: 9523, canton: "SG", commune: "Zuzwil (SG)" },
    { zip: 9524, canton: "SG", commune: "Zuzwil (SG)" },
    { zip: 9500, canton: "SG", commune: "Wil (SG)" },
    { zip: 9512, canton: "SG", commune: "Wil (SG)" },
    { zip: 9514, canton: "SG", commune: "Wil (SG)" },
    { zip: 9524, canton: "SG", commune: "Wil (SG)" },
    { zip: 9536, canton: "SG", commune: "Wil (SG)" },
    { zip: 9543, canton: "SG", commune: "Wil (SG)" },
    { zip: 9552, canton: "SG", commune: "Wil (SG)" },
    { zip: 9204, canton: "SG", commune: "Andwil (SG)" },
    { zip: 9212, canton: "SG", commune: "Andwil (SG)" },
    { zip: 9030, canton: "SG", commune: "Gaiserwald" },
    { zip: 9032, canton: "SG", commune: "Gaiserwald" },
    { zip: 9015, canton: "SG", commune: "Gossau (SG)" },
    { zip: 9100, canton: "SG", commune: "Gossau (SG)" },
    { zip: 9200, canton: "SG", commune: "Gossau (SG)" },
    { zip: 9204, canton: "SG", commune: "Gossau (SG)" },
    { zip: 9212, canton: "SG", commune: "Gossau (SG)" },
    { zip: 9032, canton: "SG", commune: "Waldkirch" },
    { zip: 9204, canton: "SG", commune: "Waldkirch" },
    { zip: 9205, canton: "SG", commune: "Waldkirch" },
    { zip: 9213, canton: "SG", commune: "Waldkirch" },
    { zip: 9246, canton: "SG", commune: "Waldkirch" },
    { zip: 9300, canton: "SG", commune: "Waldkirch" },
    { zip: 9304, canton: "SG", commune: "Waldkirch" },
    { zip: 7431, canton: "GR", commune: "Mutten" },
    { zip: 7076, canton: "GR", commune: "Vaz/Obervaz" },
    { zip: 7077, canton: "GR", commune: "Vaz/Obervaz" },
    { zip: 7078, canton: "GR", commune: "Vaz/Obervaz" },
    { zip: 7082, canton: "GR", commune: "Vaz/Obervaz" },
    { zip: 7450, canton: "GR", commune: "Vaz/Obervaz" },
    { zip: 7083, canton: "GR", commune: "Lantsch/Lenz" },
    { zip: 7493, canton: "GR", commune: "Schmitten (GR)" },
    { zip: 7482, canton: "GR", commune: "Bergün/Bravuogn" },
    { zip: 7484, canton: "GR", commune: "Bergün/Bravuogn" },
    { zip: 7477, canton: "GR", commune: "Filisur" },
    { zip: 7494, canton: "GR", commune: "Filisur" },
    { zip: 7084, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7450, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7451, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7458, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7459, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7472, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7473, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7492, canton: "GR", commune: "Albula/Alvra" },
    { zip: 7452, canton: "GR", commune: "Surses" },
    { zip: 7453, canton: "GR", commune: "Surses" },
    { zip: 7454, canton: "GR", commune: "Surses" },
    { zip: 7455, canton: "GR", commune: "Surses" },
    { zip: 7456, canton: "GR", commune: "Surses" },
    { zip: 7457, canton: "GR", commune: "Surses" },
    { zip: 7460, canton: "GR", commune: "Surses" },
    { zip: 7462, canton: "GR", commune: "Surses" },
    { zip: 7463, canton: "GR", commune: "Surses" },
    { zip: 7464, canton: "GR", commune: "Surses" },
    { zip: 7743, canton: "GR", commune: "Brusio" },
    { zip: 7744, canton: "GR", commune: "Brusio" },
    { zip: 7747, canton: "GR", commune: "Brusio" },
    { zip: 7748, canton: "GR", commune: "Brusio" },
    { zip: 7710, canton: "GR", commune: "Poschiavo" },
    { zip: 7741, canton: "GR", commune: "Poschiavo" },
    { zip: 7742, canton: "GR", commune: "Poschiavo" },
    { zip: 7743, canton: "GR", commune: "Poschiavo" },
    { zip: 7745, canton: "GR", commune: "Poschiavo" },
    { zip: 7746, canton: "GR", commune: "Poschiavo" },
    { zip: 7153, canton: "GR", commune: "Falera" },
    { zip: 7031, canton: "GR", commune: "Laax" },
    { zip: 7032, canton: "GR", commune: "Laax" },
    { zip: 7152, canton: "GR", commune: "Sagogn" },
    { zip: 7151, canton: "GR", commune: "Schluein" },
    { zip: 7116, canton: "GR", commune: "Vals" },
    { zip: 7132, canton: "GR", commune: "Vals" },
    { zip: 7159, canton: "GR", commune: "Andiast" },
    { zip: 7158, canton: "GR", commune: "Waltensburg/Vuorz" },
    { zip: 7110, canton: "GR", commune: "Lumnezia" },
    { zip: 7113, canton: "GR", commune: "Lumnezia" },
    { zip: 7114, canton: "GR", commune: "Lumnezia" },
    { zip: 7115, canton: "GR", commune: "Lumnezia" },
    { zip: 7116, canton: "GR", commune: "Lumnezia" },
    { zip: 7142, canton: "GR", commune: "Lumnezia" },
    { zip: 7143, canton: "GR", commune: "Lumnezia" },
    { zip: 7144, canton: "GR", commune: "Lumnezia" },
    { zip: 7145, canton: "GR", commune: "Lumnezia" },
    { zip: 7146, canton: "GR", commune: "Lumnezia" },
    { zip: 7147, canton: "GR", commune: "Lumnezia" },
    { zip: 7148, canton: "GR", commune: "Lumnezia" },
    { zip: 7149, canton: "GR", commune: "Lumnezia" },
    { zip: 7111, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7112, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7126, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7127, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7128, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7130, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7141, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7144, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7154, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7155, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7156, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7157, canton: "GR", commune: "Ilanz/Glion" },
    { zip: 7413, canton: "GR", commune: "Fürstenau" },
    { zip: 7414, canton: "GR", commune: "Fürstenau" },
    { zip: 7405, canton: "GR", commune: "Rothenbrunnen" },
    { zip: 7412, canton: "GR", commune: "Scharans" },
    { zip: 7411, canton: "GR", commune: "Sils im Domleschg" },
    { zip: 7405, canton: "GR", commune: "Cazis" },
    { zip: 7408, canton: "GR", commune: "Cazis" },
    { zip: 7415, canton: "GR", commune: "Cazis" },
    { zip: 7421, canton: "GR", commune: "Cazis" },
    { zip: 7422, canton: "GR", commune: "Cazis" },
    { zip: 7423, canton: "GR", commune: "Cazis" },
    { zip: 7424, canton: "GR", commune: "Cazis" },
    { zip: 7426, canton: "GR", commune: "Flerden" },
    { zip: 7421, canton: "GR", commune: "Masein" },
    { zip: 7425, canton: "GR", commune: "Masein" },
    { zip: 7430, canton: "GR", commune: "Thusis" },
    { zip: 7428, canton: "GR", commune: "Tschappina" },
    { zip: 7427, canton: "GR", commune: "Urmein" },
    { zip: 7104, canton: "GR", commune: "Safiental" },
    { zip: 7106, canton: "GR", commune: "Safiental" },
    { zip: 7107, canton: "GR", commune: "Safiental" },
    { zip: 7109, canton: "GR", commune: "Safiental" },
    { zip: 7122, canton: "GR", commune: "Safiental" },
    { zip: 7402, canton: "GR", commune: "Safiental" },
    { zip: 7404, canton: "GR", commune: "Domleschg" },
    { zip: 7407, canton: "GR", commune: "Domleschg" },
    { zip: 7415, canton: "GR", commune: "Domleschg" },
    { zip: 7416, canton: "GR", commune: "Domleschg" },
    { zip: 7417, canton: "GR", commune: "Domleschg" },
    { zip: 7418, canton: "GR", commune: "Domleschg" },
    { zip: 7419, canton: "GR", commune: "Domleschg" },
    { zip: 7446, canton: "GR", commune: "Avers" },
    { zip: 7447, canton: "GR", commune: "Avers" },
    { zip: 7448, canton: "GR", commune: "Avers" },
    { zip: 7438, canton: "GR", commune: "Hinterrhein" },
    { zip: 7437, canton: "GR", commune: "Nufenen" },
    { zip: 7435, canton: "GR", commune: "Splügen" },
    { zip: 7436, canton: "GR", commune: "Splügen" },
    { zip: 7434, canton: "GR", commune: "Sufers" },
    { zip: 7440, canton: "GR", commune: "Andeer" },
    { zip: 7442, canton: "GR", commune: "Andeer" },
    { zip: 7443, canton: "GR", commune: "Andeer" },
    { zip: 7433, canton: "GR", commune: "Casti-Wergenstein" },
    { zip: 7433, canton: "GR", commune: "Donat" },
    { zip: 7433, canton: "GR", commune: "Lohn (GR)" },
    { zip: 7433, canton: "GR", commune: "Mathon" },
    { zip: 7430, canton: "GR", commune: "Rongellen" },
    { zip: 7432, canton: "GR", commune: "Zillis-Reischen" },
    { zip: 7444, canton: "GR", commune: "Ferrera" },
    { zip: 7445, canton: "GR", commune: "Ferrera" },
    { zip: 7402, canton: "GR", commune: "Bonaduz" },
    { zip: 7012, canton: "GR", commune: "Domat/Ems" },
    { zip: 7013, canton: "GR", commune: "Domat/Ems" },
    { zip: 7015, canton: "GR", commune: "Domat/Ems" },
    { zip: 7403, canton: "GR", commune: "Rhäzüns" },
    { zip: 7012, canton: "GR", commune: "Felsberg" },
    { zip: 7017, canton: "GR", commune: "Flims" },
    { zip: 7018, canton: "GR", commune: "Flims" },
    { zip: 7019, canton: "GR", commune: "Flims" },
    { zip: 7015, canton: "GR", commune: "Tamins" },
    { zip: 7315, canton: "GR", commune: "Tamins" },
    { zip: 7014, canton: "GR", commune: "Trin" },
    { zip: 7016, canton: "GR", commune: "Trin" },
    { zip: 7527, canton: "GR", commune: "Zernez" },
    { zip: 7530, canton: "GR", commune: "Zernez" },
    { zip: 7542, canton: "GR", commune: "Zernez" },
    { zip: 7543, canton: "GR", commune: "Zernez" },
    { zip: 7562, canton: "GR", commune: "Samnaun" },
    { zip: 7563, canton: "GR", commune: "Samnaun" },
    { zip: 1347, canton: "GR", commune: "Scuol" },
    { zip: 3513, canton: "GR", commune: "Scuol" },
    { zip: 7545, canton: "GR", commune: "Scuol" },
    { zip: 7546, canton: "GR", commune: "Scuol" },
    { zip: 7550, canton: "GR", commune: "Scuol" },
    { zip: 7551, canton: "GR", commune: "Scuol" },
    { zip: 7552, canton: "GR", commune: "Scuol" },
    { zip: 7553, canton: "GR", commune: "Scuol" },
    { zip: 7554, canton: "GR", commune: "Scuol" },
    { zip: 7556, canton: "GR", commune: "Valsot" },
    { zip: 7557, canton: "GR", commune: "Valsot" },
    { zip: 7558, canton: "GR", commune: "Valsot" },
    { zip: 7559, canton: "GR", commune: "Valsot" },
    { zip: 7560, canton: "GR", commune: "Valsot" },
    { zip: 7502, canton: "GR", commune: "Bever" },
    { zip: 7500, canton: "GR", commune: "Celerina/Schlarigna" },
    { zip: 7504, canton: "GR", commune: "Celerina/Schlarigna" },
    { zip: 7505, canton: "GR", commune: "Celerina/Schlarigna" },
    { zip: 7523, canton: "GR", commune: "Madulain" },
    { zip: 7504, canton: "GR", commune: "Pontresina" },
    { zip: 7522, canton: "GR", commune: "La Punt-Chamues-ch" },
    { zip: 7503, canton: "GR", commune: "Samedan" },
    { zip: 7504, canton: "GR", commune: "Samedan" },
    { zip: 7500, canton: "GR", commune: "St. Moritz" },
    { zip: 7512, canton: "GR", commune: "St. Moritz" },
    { zip: 7525, canton: "GR", commune: "S-chanf" },
    { zip: 7526, canton: "GR", commune: "S-chanf" },
    { zip: 7514, canton: "GR", commune: "Sils im Engadin/Segl" },
    { zip: 7515, canton: "GR", commune: "Sils im Engadin/Segl" },
    { zip: 7517, canton: "GR", commune: "Sils im Engadin/Segl" },
    { zip: 7512, canton: "GR", commune: "Silvaplana" },
    { zip: 7513, canton: "GR", commune: "Silvaplana" },
    { zip: 7524, canton: "GR", commune: "Zuoz" },
    { zip: 7516, canton: "GR", commune: "Bregaglia" },
    { zip: 7602, canton: "GR", commune: "Bregaglia" },
    { zip: 7603, canton: "GR", commune: "Bregaglia" },
    { zip: 7604, canton: "GR", commune: "Bregaglia" },
    { zip: 7605, canton: "GR", commune: "Bregaglia" },
    { zip: 7606, canton: "GR", commune: "Bregaglia" },
    { zip: 7608, canton: "GR", commune: "Bregaglia" },
    { zip: 7610, canton: "GR", commune: "Bregaglia" },
    { zip: 6542, canton: "GR", commune: "Buseno" },
    { zip: 6537, canton: "GR", commune: "Castaneda" },
    { zip: 6540, canton: "GR", commune: "Castaneda" },
    { zip: 6546, canton: "GR", commune: "Rossa" },
    { zip: 6547, canton: "GR", commune: "Rossa" },
    { zip: 6548, canton: "GR", commune: "Rossa" },
    { zip: 6541, canton: "GR", commune: "Santa Maria in Calanca" },
    { zip: 6558, canton: "GR", commune: "Lostallo" },
    { zip: 6563, canton: "GR", commune: "Mesocco" },
    { zip: 6565, canton: "GR", commune: "Mesocco" },
    { zip: 6562, canton: "GR", commune: "Soazza" },
    { zip: 6557, canton: "GR", commune: "Cama" },
    { zip: 6537, canton: "GR", commune: "Grono" },
    { zip: 6538, canton: "GR", commune: "Grono" },
    { zip: 6556, canton: "GR", commune: "Grono" },
    { zip: 6557, canton: "GR", commune: "Grono" },
    { zip: 6535, canton: "GR", commune: "Roveredo (GR)" },
    { zip: 6549, canton: "GR", commune: "Roveredo (GR)" },
    { zip: 6534, canton: "GR", commune: "San Vittore" },
    { zip: 6543, canton: "GR", commune: "Calanca" },
    { zip: 6544, canton: "GR", commune: "Calanca" },
    { zip: 6545, canton: "GR", commune: "Calanca" },
    { zip: 6546, canton: "GR", commune: "Calanca" },
    { zip: 7532, canton: "GR", commune: "Val Müstair" },
    { zip: 7533, canton: "GR", commune: "Val Müstair" },
    { zip: 7534, canton: "GR", commune: "Val Müstair" },
    { zip: 7535, canton: "GR", commune: "Val Müstair" },
    { zip: 7536, canton: "GR", commune: "Val Müstair" },
    { zip: 7537, canton: "GR", commune: "Val Müstair" },
    { zip: 7260, canton: "GR", commune: "Davos" },
    { zip: 7265, canton: "GR", commune: "Davos" },
    { zip: 7270, canton: "GR", commune: "Davos" },
    { zip: 7272, canton: "GR", commune: "Davos" },
    { zip: 7276, canton: "GR", commune: "Davos" },
    { zip: 7277, canton: "GR", commune: "Davos" },
    { zip: 7278, canton: "GR", commune: "Davos" },
    { zip: 7494, canton: "GR", commune: "Davos" },
    { zip: 7235, canton: "GR", commune: "Fideris" },
    { zip: 7232, canton: "GR", commune: "Furna" },
    { zip: 7231, canton: "GR", commune: "Jenaz" },
    { zip: 7233, canton: "GR", commune: "Jenaz" },
    { zip: 7247, canton: "GR", commune: "Klosters-Serneus" },
    { zip: 7249, canton: "GR", commune: "Klosters-Serneus" },
    { zip: 7250, canton: "GR", commune: "Klosters-Serneus" },
    { zip: 7252, canton: "GR", commune: "Klosters-Serneus" },
    { zip: 7265, canton: "GR", commune: "Klosters-Serneus" },
    { zip: 7241, canton: "GR", commune: "Conters im Prättigau" },
    { zip: 7249, canton: "GR", commune: "Conters im Prättigau" },
    { zip: 7240, canton: "GR", commune: "Küblis" },
    { zip: 7222, canton: "GR", commune: "Luzein" },
    { zip: 7223, canton: "GR", commune: "Luzein" },
    { zip: 7224, canton: "GR", commune: "Luzein" },
    { zip: 7226, canton: "GR", commune: "Luzein" },
    { zip: 7240, canton: "GR", commune: "Luzein" },
    { zip: 7242, canton: "GR", commune: "Luzein" },
    { zip: 7243, canton: "GR", commune: "Luzein" },
    { zip: 7244, canton: "GR", commune: "Luzein" },
    { zip: 7245, canton: "GR", commune: "Luzein" },
    { zip: 7246, canton: "GR", commune: "Luzein" },
    { zip: 7000, canton: "GR", commune: "Chur" },
    { zip: 7062, canton: "GR", commune: "Chur" },
    { zip: 7000, canton: "GR", commune: "Churwalden" },
    { zip: 7062, canton: "GR", commune: "Churwalden" },
    { zip: 7074, canton: "GR", commune: "Churwalden" },
    { zip: 7075, canton: "GR", commune: "Churwalden" },
    { zip: 7076, canton: "GR", commune: "Churwalden" },
    { zip: 7027, canton: "GR", commune: "Arosa" },
    { zip: 7028, canton: "GR", commune: "Arosa" },
    { zip: 7029, canton: "GR", commune: "Arosa" },
    { zip: 7050, canton: "GR", commune: "Arosa" },
    { zip: 7056, canton: "GR", commune: "Arosa" },
    { zip: 7057, canton: "GR", commune: "Arosa" },
    { zip: 7058, canton: "GR", commune: "Arosa" },
    { zip: 7260, canton: "GR", commune: "Arosa" },
    { zip: 7026, canton: "GR", commune: "Maladers" },
    { zip: 7063, canton: "GR", commune: "Tschiertschen-Praden" },
    { zip: 7064, canton: "GR", commune: "Tschiertschen-Praden" },
    { zip: 7023, canton: "GR", commune: "Haldenstein" },
    { zip: 7000, canton: "GR", commune: "Trimmis" },
    { zip: 7202, canton: "GR", commune: "Trimmis" },
    { zip: 7203, canton: "GR", commune: "Trimmis" },
    { zip: 7204, canton: "GR", commune: "Untervaz" },
    { zip: 7205, canton: "GR", commune: "Zizers" },
    { zip: 7304, canton: "GR", commune: "Fläsch" },
    { zip: 7306, canton: "GR", commune: "Fläsch" },
    { zip: 7307, canton: "GR", commune: "Jenins" },
    { zip: 7302, canton: "GR", commune: "Maienfeld" },
    { zip: 7304, canton: "GR", commune: "Maienfeld" },
    { zip: 7208, canton: "GR", commune: "Malans" },
    { zip: 7204, canton: "GR", commune: "Landquart" },
    { zip: 7206, canton: "GR", commune: "Landquart" },
    { zip: 7302, canton: "GR", commune: "Landquart" },
    { zip: 7303, canton: "GR", commune: "Landquart" },
    { zip: 7313, canton: "GR", commune: "Landquart" },
    { zip: 7213, canton: "GR", commune: "Grüsch" },
    { zip: 7214, canton: "GR", commune: "Grüsch" },
    { zip: 7215, canton: "GR", commune: "Grüsch" },
    { zip: 7220, canton: "GR", commune: "Schiers" },
    { zip: 7222, canton: "GR", commune: "Schiers" },
    { zip: 7226, canton: "GR", commune: "Schiers" },
    { zip: 7228, canton: "GR", commune: "Schiers" },
    { zip: 7212, canton: "GR", commune: "Seewis im Prättigau" },
    { zip: 7215, canton: "GR", commune: "Seewis im Prättigau" },
    { zip: 7134, canton: "GR", commune: "Breil/Brigels" },
    { zip: 7162, canton: "GR", commune: "Breil/Brigels" },
    { zip: 7163, canton: "GR", commune: "Breil/Brigels" },
    { zip: 7164, canton: "GR", commune: "Breil/Brigels" },
    { zip: 7165, canton: "GR", commune: "Breil/Brigels" },
    { zip: 7180, canton: "GR", commune: "Disentis/Mustér" },
    { zip: 7182, canton: "GR", commune: "Disentis/Mustér" },
    { zip: 7183, canton: "GR", commune: "Disentis/Mustér" },
    { zip: 7186, canton: "GR", commune: "Disentis/Mustér" },
    { zip: 7184, canton: "GR", commune: "Medel (Lucmagn)" },
    { zip: 7185, canton: "GR", commune: "Medel (Lucmagn)" },
    { zip: 7172, canton: "GR", commune: "Sumvitg" },
    { zip: 7173, canton: "GR", commune: "Sumvitg" },
    { zip: 7174, canton: "GR", commune: "Sumvitg" },
    { zip: 7175, canton: "GR", commune: "Sumvitg" },
    { zip: 7176, canton: "GR", commune: "Sumvitg" },
    { zip: 7187, canton: "GR", commune: "Tujetsch" },
    { zip: 7188, canton: "GR", commune: "Tujetsch" },
    { zip: 7189, canton: "GR", commune: "Tujetsch" },
    { zip: 7166, canton: "GR", commune: "Trun" },
    { zip: 7167, canton: "GR", commune: "Trun" },
    { zip: 7168, canton: "GR", commune: "Trun" },
    { zip: 7172, canton: "GR", commune: "Trun" },
    { zip: 7134, canton: "GR", commune: "Obersaxen Mundaun" },
    { zip: 7137, canton: "GR", commune: "Obersaxen Mundaun" },
    { zip: 7138, canton: "GR", commune: "Obersaxen Mundaun" },
    { zip: 5000, canton: "AG", commune: "Aarau" },
    { zip: 5004, canton: "AG", commune: "Aarau" },
    { zip: 5032, canton: "AG", commune: "Aarau" },
    { zip: 5023, canton: "AG", commune: "Biberstein" },
    { zip: 5033, canton: "AG", commune: "Buchs (AG)" },
    { zip: 5025, canton: "AG", commune: "Densbüren" },
    { zip: 5026, canton: "AG", commune: "Densbüren" },
    { zip: 5017, canton: "AG", commune: "Erlinsbach (AG)" },
    { zip: 5018, canton: "AG", commune: "Erlinsbach (AG)" },
    { zip: 5722, canton: "AG", commune: "Gränichen" },
    { zip: 5723, canton: "AG", commune: "Gränichen" },
    { zip: 5042, canton: "AG", commune: "Hirschthal" },
    { zip: 5022, canton: "AG", commune: "Küttigen" },
    { zip: 5024, canton: "AG", commune: "Küttigen" },
    { zip: 5037, canton: "AG", commune: "Muhen" },
    { zip: 5036, canton: "AG", commune: "Oberentfelden" },
    { zip: 5000, canton: "AG", commune: "Suhr" },
    { zip: 5034, canton: "AG", commune: "Suhr" },
    { zip: 5035, canton: "AG", commune: "Unterentfelden" },
    { zip: 5400, canton: "AG", commune: "Baden" },
    { zip: 5404, canton: "AG", commune: "Baden" },
    { zip: 5405, canton: "AG", commune: "Baden" },
    { zip: 5406, canton: "AG", commune: "Baden" },
    { zip: 5454, canton: "AG", commune: "Bellikon" },
    { zip: 8967, canton: "AG", commune: "Bellikon" },
    { zip: 8962, canton: "AG", commune: "Bergdietikon" },
    { zip: 8967, canton: "AG", commune: "Bergdietikon" },
    { zip: 5406, canton: "AG", commune: "Birmenstorf (AG)" },
    { zip: 5413, canton: "AG", commune: "Birmenstorf (AG)" },
    { zip: 5408, canton: "AG", commune: "Ennetbaden" },
    { zip: 5405, canton: "AG", commune: "Fislisbach" },
    { zip: 5442, canton: "AG", commune: "Fislisbach" },
    { zip: 5423, canton: "AG", commune: "Freienwil" },
    { zip: 5412, canton: "AG", commune: "Gebenstorf" },
    { zip: 8956, canton: "AG", commune: "Killwangen" },
    { zip: 5444, canton: "AG", commune: "Künten" },
    { zip: 5506, canton: "AG", commune: "Mägenwil" },
    { zip: 5507, canton: "AG", commune: "Mellingen" },
    { zip: 5432, canton: "AG", commune: "Neuenhof" },
    { zip: 5443, canton: "AG", commune: "Niederrohrdorf" },
    { zip: 5452, canton: "AG", commune: "Oberrohrdorf" },
    { zip: 5415, canton: "AG", commune: "Obersiggenthal" },
    { zip: 5416, canton: "AG", commune: "Obersiggenthal" },
    { zip: 5453, canton: "AG", commune: "Remetschwil" },
    { zip: 8953, canton: "AG", commune: "Spreitenbach" },
    { zip: 8957, canton: "AG", commune: "Spreitenbach" },
    { zip: 5608, canton: "AG", commune: "Stetten (AG)" },
    { zip: 5300, canton: "AG", commune: "Turgi" },
    { zip: 5300, canton: "AG", commune: "Untersiggenthal" },
    { zip: 5301, canton: "AG", commune: "Untersiggenthal" },
    { zip: 5416, canton: "AG", commune: "Untersiggenthal" },
    { zip: 5417, canton: "AG", commune: "Untersiggenthal" },
    { zip: 5430, canton: "AG", commune: "Wettingen" },
    { zip: 5506, canton: "AG", commune: "Wohlenschwil" },
    { zip: 5512, canton: "AG", commune: "Wohlenschwil" },
    { zip: 5303, canton: "AG", commune: "Würenlingen" },
    { zip: 5430, canton: "AG", commune: "Würenlos" },
    { zip: 5436, canton: "AG", commune: "Würenlos" },
    { zip: 8109, canton: "AG", commune: "Würenlos" },
    { zip: 5420, canton: "AG", commune: "Ehrendingen" },
    { zip: 8905, canton: "AG", commune: "Arni (AG)" },
    { zip: 5621, canton: "AG", commune: "Berikon" },
    { zip: 8964, canton: "AG", commune: "Berikon" },
    { zip: 8965, canton: "AG", commune: "Berikon" },
    { zip: 5620, canton: "AG", commune: "Bremgarten (AG)" },
    { zip: 5626, canton: "AG", commune: "Bremgarten (AG)" },
    { zip: 5619, canton: "AG", commune: "Büttikon" },
    { zip: 5605, canton: "AG", commune: "Dottikon" },
    { zip: 5445, canton: "AG", commune: "Eggenwil" },
    { zip: 5525, canton: "AG", commune: "Fischbach-Göslikon" },
    { zip: 5522, canton: "AG", commune: "Hägglingen" },
    { zip: 5607, canton: "AG", commune: "Hägglingen" },
    { zip: 8916, canton: "AG", commune: "Jonen" },
    { zip: 5524, canton: "AG", commune: "Niederwil (AG)" },
    { zip: 8917, canton: "AG", commune: "Oberlunkhofen" },
    { zip: 8966, canton: "AG", commune: "Oberwil-Lieli" },
    { zip: 8964, canton: "AG", commune: "Rudolfstetten-Friedlisb." },
    { zip: 5614, canton: "AG", commune: "Sarmenstorf" },
    { zip: 5618, canton: "AG", commune: "Sarmenstorf" },
    { zip: 5522, canton: "AG", commune: "Tägerig" },
    { zip: 5619, canton: "AG", commune: "Uezwil" },
    { zip: 8918, canton: "AG", commune: "Unterlunkhofen" },
    { zip: 5605, canton: "AG", commune: "Villmergen" },
    { zip: 5610, canton: "AG", commune: "Villmergen" },
    { zip: 5611, canton: "AG", commune: "Villmergen" },
    { zip: 5612, canton: "AG", commune: "Villmergen" },
    { zip: 5613, canton: "AG", commune: "Villmergen" },
    { zip: 8967, canton: "AG", commune: "Widen" },
    { zip: 5610, canton: "AG", commune: "Wohlen (AG)" },
    { zip: 5611, canton: "AG", commune: "Wohlen (AG)" },
    { zip: 5621, canton: "AG", commune: "Zufikon" },
    { zip: 8905, canton: "AG", commune: "Islisberg" },
    { zip: 5105, canton: "AG", commune: "Auenstein" },
    { zip: 5242, canton: "AG", commune: "Birr" },
    { zip: 5244, canton: "AG", commune: "Birrhard" },
    { zip: 5076, canton: "AG", commune: "Bözen" },
    { zip: 5200, canton: "AG", commune: "Brugg" },
    { zip: 5210, canton: "AG", commune: "Brugg" },
    { zip: 5222, canton: "AG", commune: "Brugg" },
    { zip: 5078, canton: "AG", commune: "Effingen" },
    { zip: 5079, canton: "AG", commune: "Effingen" },
    { zip: 5077, canton: "AG", commune: "Elfingen" },
    { zip: 5245, canton: "AG", commune: "Habsburg" },
    { zip: 5210, canton: "AG", commune: "Hausen (AG)" },
    { zip: 5212, canton: "AG", commune: "Hausen (AG)" },
    { zip: 5242, canton: "AG", commune: "Lupfig" },
    { zip: 5318, canton: "AG", commune: "Mandach" },
    { zip: 5237, canton: "AG", commune: "Mönthal" },
    { zip: 5243, canton: "AG", commune: "Mülligen" },
    { zip: 5236, canton: "AG", commune: "Remigen" },
    { zip: 5223, canton: "AG", commune: "Riniken" },
    { zip: 5200, canton: "AG", commune: "Rüfenach" },
    { zip: 5235, canton: "AG", commune: "Rüfenach" },
    { zip: 5246, canton: "AG", commune: "Scherz" },
    { zip: 5116, canton: "AG", commune: "Schinznach-Bad" },
    { zip: 5112, canton: "AG", commune: "Thalheim (AG)" },
    { zip: 5106, canton: "AG", commune: "Veltheim (AG)" },
    { zip: 5233, canton: "AG", commune: "Villigen" },
    { zip: 5234, canton: "AG", commune: "Villigen" },
    { zip: 5213, canton: "AG", commune: "Villnachern" },
    { zip: 5222, canton: "AG", commune: "Villnachern" },
    { zip: 5210, canton: "AG", commune: "Windisch" },
    { zip: 5225, canton: "AG", commune: "Bözberg" },
    { zip: 5236, canton: "AG", commune: "Bözberg" },
    { zip: 5237, canton: "AG", commune: "Bözberg" },
    { zip: 5107, canton: "AG", commune: "Schinznach" },
    { zip: 5108, canton: "AG", commune: "Schinznach" },
    { zip: 5712, canton: "AG", commune: "Beinwil am See" },
    { zip: 5708, canton: "AG", commune: "Birrwil" },
    { zip: 5736, canton: "AG", commune: "Burg (AG)" },
    { zip: 5724, canton: "AG", commune: "Dürrenäsch" },
    { zip: 5726, canton: "AG", commune: "Dürrenäsch" },
    { zip: 5046, canton: "AG", commune: "Gontenschwil" },
    { zip: 5728, canton: "AG", commune: "Gontenschwil" },
    { zip: 5043, canton: "AG", commune: "Holziken" },
    { zip: 5733, canton: "AG", commune: "Leimbach (AG)" },
    { zip: 5725, canton: "AG", commune: "Leutwil" },
    { zip: 5737, canton: "AG", commune: "Menziken" },
    { zip: 5727, canton: "AG", commune: "Oberkulm" },
    { zip: 5734, canton: "AG", commune: "Reinach (AG)" },
    { zip: 5044, canton: "AG", commune: "Schlossrued" },
    { zip: 5046, canton: "AG", commune: "Schmiedrued" },
    { zip: 5040, canton: "AG", commune: "Schöftland" },
    { zip: 5723, canton: "AG", commune: "Teufenthal (AG)" },
    { zip: 5724, canton: "AG", commune: "Teufenthal (AG)" },
    { zip: 5722, canton: "AG", commune: "Unterkulm" },
    { zip: 5723, canton: "AG", commune: "Unterkulm" },
    { zip: 5726, canton: "AG", commune: "Unterkulm" },
    { zip: 5732, canton: "AG", commune: "Zetzwil" },
    { zip: 4334, canton: "AG", commune: "Eiken" },
    { zip: 5074, canton: "AG", commune: "Eiken" },
    { zip: 5070, canton: "AG", commune: "Frick" },
    { zip: 5272, canton: "AG", commune: "Gansingen" },
    { zip: 5073, canton: "AG", commune: "Gipf-Oberfrick" },
    { zip: 5027, canton: "AG", commune: "Herznach" },
    { zip: 5075, canton: "AG", commune: "Hornussen" },
    { zip: 5070, canton: "AG", commune: "Kaisten" },
    { zip: 5080, canton: "AG", commune: "Kaisten" },
    { zip: 5082, canton: "AG", commune: "Kaisten" },
    { zip: 5083, canton: "AG", commune: "Kaisten" },
    { zip: 5080, canton: "AG", commune: "Laufenburg" },
    { zip: 5084, canton: "AG", commune: "Laufenburg" },
    { zip: 5085, canton: "AG", commune: "Laufenburg" },
    { zip: 4333, canton: "AG", commune: "Münchwilen (AG)" },
    { zip: 5062, canton: "AG", commune: "Oberhof" },
    { zip: 5072, canton: "AG", commune: "Oeschgen" },
    { zip: 5326, canton: "AG", commune: "Schwaderloch" },
    { zip: 4334, canton: "AG", commune: "Sisseln" },
    { zip: 5028, canton: "AG", commune: "Ueken" },
    { zip: 5064, canton: "AG", commune: "Wittnau" },
    { zip: 5063, canton: "AG", commune: "Wölflinswil" },
    { zip: 5079, canton: "AG", commune: "Zeihen" },
    { zip: 5273, canton: "AG", commune: "Mettauertal" },
    { zip: 5274, canton: "AG", commune: "Mettauertal" },
    { zip: 5275, canton: "AG", commune: "Mettauertal" },
    { zip: 5276, canton: "AG", commune: "Mettauertal" },
    { zip: 5277, canton: "AG", commune: "Mettauertal" },
    { zip: 5326, canton: "AG", commune: "Mettauertal" },
    { zip: 5600, canton: "AG", commune: "Ammerswil" },
    { zip: 5706, canton: "AG", commune: "Boniswil" },
    { zip: 5708, canton: "AG", commune: "Boniswil" },
    { zip: 5505, canton: "AG", commune: "Brunegg" },
    { zip: 5606, canton: "AG", commune: "Dintikon" },
    { zip: 5703, canton: "AG", commune: "Egliswil" },
    { zip: 5704, canton: "AG", commune: "Egliswil" },
    { zip: 5615, canton: "AG", commune: "Fahrwangen" },
    { zip: 5705, canton: "AG", commune: "Hallwil" },
    { zip: 5604, canton: "AG", commune: "Hendschiken" },
    { zip: 5113, canton: "AG", commune: "Holderbank (AG)" },
    { zip: 5502, canton: "AG", commune: "Hunzenschwil" },
    { zip: 5600, canton: "AG", commune: "Lenzburg" },
    { zip: 5615, canton: "AG", commune: "Meisterschwanden" },
    { zip: 5616, canton: "AG", commune: "Meisterschwanden" },
    { zip: 5617, canton: "AG", commune: "Meisterschwanden" },
    { zip: 5103, canton: "AG", commune: "Möriken-Wildegg" },
    { zip: 5103, canton: "AG", commune: "Niederlenz" },
    { zip: 5702, canton: "AG", commune: "Niederlenz" },
    { zip: 5504, canton: "AG", commune: "Othmarsingen" },
    { zip: 5604, canton: "AG", commune: "Othmarsingen" },
    { zip: 5102, canton: "AG", commune: "Rupperswil" },
    { zip: 5103, canton: "AG", commune: "Rupperswil" },
    { zip: 5503, canton: "AG", commune: "Schafisheim" },
    { zip: 5707, canton: "AG", commune: "Seengen" },
    { zip: 5703, canton: "AG", commune: "Seon" },
    { zip: 5603, canton: "AG", commune: "Staufen" },
    { zip: 5646, canton: "AG", commune: "Abtwil" },
    { zip: 5628, canton: "AG", commune: "Aristau" },
    { zip: 5630, canton: "AG", commune: "Aristau" },
    { zip: 5637, canton: "AG", commune: "Auw" },
    { zip: 5642, canton: "AG", commune: "Auw" },
    { zip: 5643, canton: "AG", commune: "Auw" },
    { zip: 5644, canton: "AG", commune: "Auw" },
    { zip: 6277, canton: "AG", commune: "Auw" },
    { zip: 5637, canton: "AG", commune: "Beinwil (Freiamt)" },
    { zip: 5627, canton: "AG", commune: "Besenbüren" },
    { zip: 5618, canton: "AG", commune: "Bettwil" },
    { zip: 5632, canton: "AG", commune: "Bettwil" },
    { zip: 5623, canton: "AG", commune: "Boswil" },
    { zip: 5624, canton: "AG", commune: "Boswil" },
    { zip: 5630, canton: "AG", commune: "Boswil" },
    { zip: 5632, canton: "AG", commune: "Boswil" },
    { zip: 5624, canton: "AG", commune: "Bünzen" },
    { zip: 5632, canton: "AG", commune: "Buttwil" },
    { zip: 6034, canton: "AG", commune: "Dietwil" },
    { zip: 6042, canton: "AG", commune: "Dietwil" },
    { zip: 5637, canton: "AG", commune: "Geltwil" },
    { zip: 5625, canton: "AG", commune: "Kallern" },
    { zip: 5634, canton: "AG", commune: "Merenschwand" },
    { zip: 5636, canton: "AG", commune: "Merenschwand" },
    { zip: 5642, canton: "AG", commune: "Mühlau" },
    { zip: 5630, canton: "AG", commune: "Muri (AG)" },
    { zip: 5647, canton: "AG", commune: "Oberrüti" },
    { zip: 8919, canton: "AG", commune: "Rottenschwil" },
    { zip: 5643, canton: "AG", commune: "Sins" },
    { zip: 5644, canton: "AG", commune: "Sins" },
    { zip: 5645, canton: "AG", commune: "Sins" },
    { zip: 6034, canton: "AG", commune: "Sins" },
    { zip: 6275, canton: "AG", commune: "Sins" },
    { zip: 5622, canton: "AG", commune: "Waltenschwil" },
    { zip: 4316, canton: "AG", commune: "Hellikon" },
    { zip: 4465, canton: "AG", commune: "Hellikon" },
    { zip: 4303, canton: "AG", commune: "Kaiseraugst" },
    { zip: 4305, canton: "AG", commune: "Magden" },
    { zip: 4312, canton: "AG", commune: "Magden" },
    { zip: 4313, canton: "AG", commune: "Möhlin" },
    { zip: 4322, canton: "AG", commune: "Mumpf" },
    { zip: 4324, canton: "AG", commune: "Obermumpf" },
    { zip: 4305, canton: "AG", commune: "Olsberg" },
    { zip: 4310, canton: "AG", commune: "Rheinfelden" },
    { zip: 4313, canton: "AG", commune: "Rheinfelden" },
    { zip: 4325, canton: "AG", commune: "Schupfart" },
    { zip: 4332, canton: "AG", commune: "Stein (AG)" },
    { zip: 4323, canton: "AG", commune: "Wallbach" },
    { zip: 4317, canton: "AG", commune: "Wegenstetten" },
    { zip: 4314, canton: "AG", commune: "Zeiningen" },
    { zip: 4315, canton: "AG", commune: "Zeiningen" },
    { zip: 4323, canton: "AG", commune: "Zeiningen" },
    { zip: 4315, canton: "AG", commune: "Zuzgen" },
    { zip: 4663, canton: "AG", commune: "Aarburg" },
    { zip: 5056, canton: "AG", commune: "Attelwil" },
    { zip: 4813, canton: "AG", commune: "Bottenwil" },
    { zip: 4814, canton: "AG", commune: "Bottenwil" },
    { zip: 4803, canton: "AG", commune: "Brittnau" },
    { zip: 4805, canton: "AG", commune: "Brittnau" },
    { zip: 6264, canton: "AG", commune: "Brittnau" },
    { zip: 5054, canton: "AG", commune: "Kirchleerau" },
    { zip: 4813, canton: "AG", commune: "Kölliken" },
    { zip: 5742, canton: "AG", commune: "Kölliken" },
    { zip: 5054, canton: "AG", commune: "Moosleerau" },
    { zip: 4853, canton: "AG", commune: "Murgenthal" },
    { zip: 4856, canton: "AG", commune: "Murgenthal" },
    { zip: 4914, canton: "AG", commune: "Murgenthal" },
    { zip: 4915, canton: "AG", commune: "Murgenthal" },
    { zip: 4656, canton: "AG", commune: "Oftringen" },
    { zip: 4665, canton: "AG", commune: "Oftringen" },
    { zip: 4800, canton: "AG", commune: "Oftringen" },
    { zip: 5057, canton: "AG", commune: "Reitnau" },
    { zip: 4802, canton: "AG", commune: "Rothrist" },
    { zip: 4852, canton: "AG", commune: "Rothrist" },
    { zip: 5745, canton: "AG", commune: "Safenwil" },
    { zip: 5053, canton: "AG", commune: "Staffelbach" },
    { zip: 4802, canton: "AG", commune: "Strengelbach" },
    { zip: 4812, canton: "AG", commune: "Uerkheim" },
    { zip: 4813, canton: "AG", commune: "Uerkheim" },
    { zip: 4803, canton: "AG", commune: "Vordemwald" },
    { zip: 4852, canton: "AG", commune: "Vordemwald" },
    { zip: 5058, canton: "AG", commune: "Wiliberg" },
    { zip: 4800, canton: "AG", commune: "Zofingen" },
    { zip: 4812, canton: "AG", commune: "Zofingen" },
    { zip: 4814, canton: "AG", commune: "Zofingen" },
    { zip: 5333, canton: "AG", commune: "Baldingen" },
    { zip: 5334, canton: "AG", commune: "Böbikon" },
    { zip: 5314, canton: "AG", commune: "Böttstein" },
    { zip: 5315, canton: "AG", commune: "Böttstein" },
    { zip: 5312, canton: "AG", commune: "Döttingen" },
    { zip: 5304, canton: "AG", commune: "Endingen" },
    { zip: 5305, canton: "AG", commune: "Endingen" },
    { zip: 5467, canton: "AG", commune: "Fisibach" },
    { zip: 5324, canton: "AG", commune: "Full-Reuenthal" },
    { zip: 5466, canton: "AG", commune: "Kaiserstuhl" },
    { zip: 5313, canton: "AG", commune: "Klingnau" },
    { zip: 5322, canton: "AG", commune: "Klingnau" },
    { zip: 5322, canton: "AG", commune: "Koblenz" },
    { zip: 5325, canton: "AG", commune: "Leibstadt" },
    { zip: 5426, canton: "AG", commune: "Lengnau (AG)" },
    { zip: 5316, canton: "AG", commune: "Leuggern" },
    { zip: 5317, canton: "AG", commune: "Leuggern" },
    { zip: 5465, canton: "AG", commune: "Mellikon" },
    { zip: 5332, canton: "AG", commune: "Rekingen (AG)" },
    { zip: 5323, canton: "AG", commune: "Rietheim" },
    { zip: 5464, canton: "AG", commune: "Rümikon" },
    { zip: 5425, canton: "AG", commune: "Schneisingen" },
    { zip: 5462, canton: "AG", commune: "Siglistorf" },
    { zip: 5306, canton: "AG", commune: "Tegerfelden" },
    { zip: 5463, canton: "AG", commune: "Wislikofen" },
    { zip: 5330, canton: "AG", commune: "Bad Zurzach" },
    { zip: 9320, canton: "TG", commune: "Arbon" },
    { zip: 8582, canton: "TG", commune: "Dozwil" },
    { zip: 9314, canton: "TG", commune: "Egnach" },
    { zip: 9315, canton: "TG", commune: "Egnach" },
    { zip: 9322, canton: "TG", commune: "Egnach" },
    { zip: 8580, canton: "TG", commune: "Hefenhofen" },
    { zip: 8582, canton: "TG", commune: "Hefenhofen" },
    { zip: 9326, canton: "TG", commune: "Horn" },
    { zip: 8593, canton: "TG", commune: "Kesswil" },
    { zip: 9306, canton: "TG", commune: "Roggwil (TG)" },
    { zip: 9308, canton: "TG", commune: "Roggwil (TG)" },
    { zip: 9315, canton: "TG", commune: "Roggwil (TG)" },
    { zip: 9320, canton: "TG", commune: "Roggwil (TG)" },
    { zip: 9325, canton: "TG", commune: "Roggwil (TG)" },
    { zip: 8590, canton: "TG", commune: "Romanshorn" },
    { zip: 8580, canton: "TG", commune: "Salmsach" },
    { zip: 8599, canton: "TG", commune: "Salmsach" },
    { zip: 9322, canton: "TG", commune: "Salmsach" },
    { zip: 8580, canton: "TG", commune: "Sommeri" },
    { zip: 8590, canton: "TG", commune: "Uttwil" },
    { zip: 8592, canton: "TG", commune: "Uttwil" },
    { zip: 8580, canton: "TG", commune: "Amriswil" },
    { zip: 8581, canton: "TG", commune: "Amriswil" },
    { zip: 8587, canton: "TG", commune: "Amriswil" },
    { zip: 9220, canton: "TG", commune: "Bischofszell" },
    { zip: 9223, canton: "TG", commune: "Bischofszell" },
    { zip: 8586, canton: "TG", commune: "Erlen" },
    { zip: 9216, canton: "TG", commune: "Erlen" },
    { zip: 9213, canton: "TG", commune: "Hauptwil-Gottshaus" },
    { zip: 9220, canton: "TG", commune: "Hauptwil-Gottshaus" },
    { zip: 9225, canton: "TG", commune: "Hauptwil-Gottshaus" },
    { zip: 9216, canton: "TG", commune: "Hohentannen" },
    { zip: 8577, canton: "TG", commune: "Kradolf-Schönenberg" },
    { zip: 9214, canton: "TG", commune: "Kradolf-Schönenberg" },
    { zip: 9215, canton: "TG", commune: "Kradolf-Schönenberg" },
    { zip: 9217, canton: "TG", commune: "Kradolf-Schönenberg" },
    { zip: 8583, canton: "TG", commune: "Sulgen" },
    { zip: 9214, canton: "TG", commune: "Sulgen" },
    { zip: 8588, canton: "TG", commune: "Zihlschlacht-Sitterdorf" },
    { zip: 8589, canton: "TG", commune: "Zihlschlacht-Sitterdorf" },
    { zip: 9220, canton: "TG", commune: "Zihlschlacht-Sitterdorf" },
    { zip: 9313, canton: "TG", commune: "Zihlschlacht-Sitterdorf" },
    { zip: 8254, canton: "TG", commune: "Basadingen-Schlattingen" },
    { zip: 8255, canton: "TG", commune: "Basadingen-Schlattingen" },
    { zip: 8476, canton: "TG", commune: "Basadingen-Schlattingen" },
    { zip: 8252, canton: "TG", commune: "Diessenhofen" },
    { zip: 8253, canton: "TG", commune: "Diessenhofen" },
    { zip: 8252, canton: "TG", commune: "Schlatt (TG)" },
    { zip: 8355, canton: "TG", commune: "Aadorf" },
    { zip: 8356, canton: "TG", commune: "Aadorf" },
    { zip: 8357, canton: "TG", commune: "Aadorf" },
    { zip: 8522, canton: "TG", commune: "Aadorf" },
    { zip: 9547, canton: "TG", commune: "Aadorf" },
    { zip: 8500, canton: "TG", commune: "Felben-Wellhausen" },
    { zip: 8552, canton: "TG", commune: "Felben-Wellhausen" },
    { zip: 8500, canton: "TG", commune: "Frauenfeld" },
    { zip: 8552, canton: "TG", commune: "Frauenfeld" },
    { zip: 9548, canton: "TG", commune: "Frauenfeld" },
    { zip: 8500, canton: "TG", commune: "Gachnang" },
    { zip: 8546, canton: "TG", commune: "Gachnang" },
    { zip: 8547, canton: "TG", commune: "Gachnang" },
    { zip: 8553, canton: "TG", commune: "Hüttlingen" },
    { zip: 8500, canton: "TG", commune: "Matzingen" },
    { zip: 9548, canton: "TG", commune: "Matzingen" },
    { zip: 8525, canton: "TG", commune: "Neunforn" },
    { zip: 8526, canton: "TG", commune: "Neunforn" },
    { zip: 9507, canton: "TG", commune: "Stettfurt" },
    { zip: 9548, canton: "TG", commune: "Stettfurt" },
    { zip: 8500, canton: "TG", commune: "Thundorf" },
    { zip: 8512, canton: "TG", commune: "Thundorf" },
    { zip: 8524, canton: "TG", commune: "Uesslingen-Buch" },
    { zip: 8532, canton: "TG", commune: "Warth-Weiningen" },
    { zip: 8536, canton: "TG", commune: "Warth-Weiningen" },
    { zip: 8595, canton: "TG", commune: "Altnau" },
    { zip: 8280, canton: "TG", commune: "Bottighofen" },
    { zip: 8598, canton: "TG", commune: "Bottighofen" },
    { zip: 8272, canton: "TG", commune: "Ermatingen" },
    { zip: 8273, canton: "TG", commune: "Ermatingen" },
    { zip: 8274, canton: "TG", commune: "Gottlieben" },
    { zip: 8594, canton: "TG", commune: "Güttingen" },
    { zip: 8565, canton: "TG", commune: "Kemmental" },
    { zip: 8566, canton: "TG", commune: "Kemmental" },
    { zip: 8573, canton: "TG", commune: "Kemmental" },
    { zip: 8280, canton: "TG", commune: "Kreuzlingen" },
    { zip: 8598, canton: "TG", commune: "Kreuzlingen" },
    { zip: 8585, canton: "TG", commune: "Langrickenbach" },
    { zip: 8586, canton: "TG", commune: "Langrickenbach" },
    { zip: 8574, canton: "TG", commune: "Lengwil" },
    { zip: 8596, canton: "TG", commune: "Münsterlingen" },
    { zip: 8597, canton: "TG", commune: "Münsterlingen" },
    { zip: 8274, canton: "TG", commune: "Tägerwilen" },
    { zip: 8280, canton: "TG", commune: "Tägerwilen" },
    { zip: 8558, canton: "TG", commune: "Wäldi" },
    { zip: 8564, canton: "TG", commune: "Wäldi" },
    { zip: 8514, canton: "TG", commune: "Affeltrangen" },
    { zip: 9555, canton: "TG", commune: "Affeltrangen" },
    { zip: 9556, canton: "TG", commune: "Affeltrangen" },
    { zip: 9562, canton: "TG", commune: "Affeltrangen" },
    { zip: 9553, canton: "TG", commune: "Bettwiesen" },
    { zip: 8362, canton: "TG", commune: "Bichelsee-Balterswil" },
    { zip: 8363, canton: "TG", commune: "Bichelsee-Balterswil" },
    { zip: 9502, canton: "TG", commune: "Braunau" },
    { zip: 8360, canton: "TG", commune: "Eschlikon" },
    { zip: 8370, canton: "TG", commune: "Eschlikon" },
    { zip: 8372, canton: "TG", commune: "Fischingen" },
    { zip: 8374, canton: "TG", commune: "Fischingen" },
    { zip: 8376, canton: "TG", commune: "Fischingen" },
    { zip: 8495, canton: "TG", commune: "Fischingen" },
    { zip: 8499, canton: "TG", commune: "Fischingen" },
    { zip: 9506, canton: "TG", commune: "Lommis" },
    { zip: 9508, canton: "TG", commune: "Lommis" },
    { zip: 8360, canton: "TG", commune: "Münchwilen (TG)" },
    { zip: 9542, canton: "TG", commune: "Münchwilen (TG)" },
    { zip: 9543, canton: "TG", commune: "Münchwilen (TG)" },
    { zip: 9552, canton: "TG", commune: "Münchwilen (TG)" },
    { zip: 9532, canton: "TG", commune: "Rickenbach (TG)" },
    { zip: 9535, canton: "TG", commune: "Rickenbach (TG)" },
    { zip: 9536, canton: "TG", commune: "Rickenbach (TG)" },
    { zip: 8577, canton: "TG", commune: "Schönholzerswilen" },
    { zip: 8370, canton: "TG", commune: "Sirnach" },
    { zip: 8371, canton: "TG", commune: "Sirnach" },
    { zip: 8372, canton: "TG", commune: "Sirnach" },
    { zip: 9573, canton: "TG", commune: "Sirnach" },
    { zip: 9554, canton: "TG", commune: "Tobel-Tägerschen" },
    { zip: 9555, canton: "TG", commune: "Tobel-Tägerschen" },
    { zip: 9545, canton: "TG", commune: "Wängi" },
    { zip: 9546, canton: "TG", commune: "Wängi" },
    { zip: 9535, canton: "TG", commune: "Wilen (TG)" },
    { zip: 9514, canton: "TG", commune: "Wuppenau" },
    { zip: 9515, canton: "TG", commune: "Wuppenau" },
    { zip: 8267, canton: "TG", commune: "Berlingen" },
    { zip: 8264, canton: "TG", commune: "Eschenz" },
    { zip: 8506, canton: "TG", commune: "Herdern" },
    { zip: 8532, canton: "TG", commune: "Herdern" },
    { zip: 8535, canton: "TG", commune: "Herdern" },
    { zip: 8536, canton: "TG", commune: "Herdern" },
    { zip: 8507, canton: "TG", commune: "Homburg" },
    { zip: 8508, canton: "TG", commune: "Homburg" },
    { zip: 8535, canton: "TG", commune: "Hüttwilen" },
    { zip: 8536, canton: "TG", commune: "Hüttwilen" },
    { zip: 8537, canton: "TG", commune: "Hüttwilen" },
    { zip: 8264, canton: "TG", commune: "Mammern" },
    { zip: 8265, canton: "TG", commune: "Mammern" },
    { zip: 8507, canton: "TG", commune: "Mammern" },
    { zip: 8555, canton: "TG", commune: "Müllheim" },
    { zip: 8505, canton: "TG", commune: "Pfyn" },
    { zip: 8508, canton: "TG", commune: "Pfyn" },
    { zip: 8558, canton: "TG", commune: "Raperswilen" },
    { zip: 8268, canton: "TG", commune: "Salenstein" },
    { zip: 8269, canton: "TG", commune: "Salenstein" },
    { zip: 8266, canton: "TG", commune: "Steckborn" },
    { zip: 8259, canton: "TG", commune: "Wagenhausen" },
    { zip: 8514, canton: "TG", commune: "Amlikon-Bissegg" },
    { zip: 8554, canton: "TG", commune: "Amlikon-Bissegg" },
    { zip: 8570, canton: "TG", commune: "Berg (TG)" },
    { zip: 8572, canton: "TG", commune: "Berg (TG)" },
    { zip: 8576, canton: "TG", commune: "Berg (TG)" },
    { zip: 8584, canton: "TG", commune: "Berg (TG)" },
    { zip: 8585, canton: "TG", commune: "Birwinken" },
    { zip: 8586, canton: "TG", commune: "Birwinken" },
    { zip: 8575, canton: "TG", commune: "Bürglen (TG)" },
    { zip: 8584, canton: "TG", commune: "Bürglen (TG)" },
    { zip: 8575, canton: "TG", commune: "Bussnang" },
    { zip: 9503, canton: "TG", commune: "Bussnang" },
    { zip: 9504, canton: "TG", commune: "Bussnang" },
    { zip: 9517, canton: "TG", commune: "Bussnang" },
    { zip: 9562, canton: "TG", commune: "Bussnang" },
    { zip: 9565, canton: "TG", commune: "Bussnang" },
    { zip: 8560, canton: "TG", commune: "Märstetten" },
    { zip: 8561, canton: "TG", commune: "Märstetten" },
    { zip: 8570, canton: "TG", commune: "Weinfelden" },
    { zip: 8575, canton: "TG", commune: "Weinfelden" },
    { zip: 8554, canton: "TG", commune: "Wigoltingen" },
    { zip: 8556, canton: "TG", commune: "Wigoltingen" },
    { zip: 8560, canton: "TG", commune: "Wigoltingen" },
    { zip: 8564, canton: "TG", commune: "Wigoltingen" },
    { zip: 6517, canton: "TI", commune: "Arbedo-Castione" },
    { zip: 6532, canton: "TI", commune: "Arbedo-Castione" },
    { zip: 6500, canton: "TI", commune: "Bellinzona" },
    { zip: 6503, canton: "TI", commune: "Bellinzona" },
    { zip: 6512, canton: "TI", commune: "Bellinzona" },
    { zip: 6513, canton: "TI", commune: "Bellinzona" },
    { zip: 6514, canton: "TI", commune: "Bellinzona" },
    { zip: 6515, canton: "TI", commune: "Bellinzona" },
    { zip: 6517, canton: "TI", commune: "Bellinzona" },
    { zip: 6518, canton: "TI", commune: "Bellinzona" },
    { zip: 6523, canton: "TI", commune: "Bellinzona" },
    { zip: 6524, canton: "TI", commune: "Bellinzona" },
    { zip: 6525, canton: "TI", commune: "Bellinzona" },
    { zip: 6528, canton: "TI", commune: "Bellinzona" },
    { zip: 6532, canton: "TI", commune: "Bellinzona" },
    { zip: 6582, canton: "TI", commune: "Bellinzona" },
    { zip: 6583, canton: "TI", commune: "Bellinzona" },
    { zip: 6584, canton: "TI", commune: "Bellinzona" },
    { zip: 6592, canton: "TI", commune: "Bellinzona" },
    { zip: 6702, canton: "TI", commune: "Bellinzona" },
    { zip: 6592, canton: "TI", commune: "Cadenazzo" },
    { zip: 6593, canton: "TI", commune: "Cadenazzo" },
    { zip: 6599, canton: "TI", commune: "Cadenazzo" },
    { zip: 6810, canton: "TI", commune: "Isone" },
    { zip: 6532, canton: "TI", commune: "Lumino" },
    { zip: 6533, canton: "TI", commune: "Lumino" },
    { zip: 6515, canton: "TI", commune: "Sant'Antonino" },
    { zip: 6528, canton: "TI", commune: "Sant'Antonino" },
    { zip: 6592, canton: "TI", commune: "Sant'Antonino" },
    { zip: 6593, canton: "TI", commune: "Sant'Antonino" },
    { zip: 6715, canton: "TI", commune: "Acquarossa" },
    { zip: 6716, canton: "TI", commune: "Acquarossa" },
    { zip: 6719, canton: "TI", commune: "Acquarossa" },
    { zip: 6721, canton: "TI", commune: "Acquarossa" },
    { zip: 6722, canton: "TI", commune: "Acquarossa" },
    { zip: 6723, canton: "TI", commune: "Acquarossa" },
    { zip: 6724, canton: "TI", commune: "Acquarossa" },
    { zip: 6716, canton: "TI", commune: "Blenio" },
    { zip: 6717, canton: "TI", commune: "Blenio" },
    { zip: 6718, canton: "TI", commune: "Blenio" },
    { zip: 6719, canton: "TI", commune: "Blenio" },
    { zip: 6720, canton: "TI", commune: "Blenio" },
    { zip: 6724, canton: "TI", commune: "Blenio" },
    { zip: 6713, canton: "TI", commune: "Serravalle" },
    { zip: 6714, canton: "TI", commune: "Serravalle" },
    { zip: 6721, canton: "TI", commune: "Serravalle" },
    { zip: 6776, canton: "TI", commune: "Airolo" },
    { zip: 6780, canton: "TI", commune: "Airolo" },
    { zip: 6781, canton: "TI", commune: "Bedretto" },
    { zip: 6743, canton: "TI", commune: "Bodio" },
    { zip: 6774, canton: "TI", commune: "Dalpe" },
    { zip: 6746, canton: "TI", commune: "Faido" },
    { zip: 6747, canton: "TI", commune: "Faido" },
    { zip: 6748, canton: "TI", commune: "Faido" },
    { zip: 6749, canton: "TI", commune: "Faido" },
    { zip: 6760, canton: "TI", commune: "Faido" },
    { zip: 6763, canton: "TI", commune: "Faido" },
    { zip: 6764, canton: "TI", commune: "Faido" },
    { zip: 6745, canton: "TI", commune: "Giornico" },
    { zip: 6744, canton: "TI", commune: "Personico" },
    { zip: 6742, canton: "TI", commune: "Pollegio" },
    { zip: 6772, canton: "TI", commune: "Prato (Leventina)" },
    { zip: 6773, canton: "TI", commune: "Prato (Leventina)" },
    { zip: 6775, canton: "TI", commune: "Quinto" },
    { zip: 6776, canton: "TI", commune: "Quinto" },
    { zip: 6777, canton: "TI", commune: "Quinto" },
    { zip: 6612, canton: "TI", commune: "Ascona" },
    { zip: 6618, canton: "TI", commune: "Ascona" },
    { zip: 6634, canton: "TI", commune: "Brione (Verzasca)" },
    { zip: 6645, canton: "TI", commune: "Brione sopra Minusio" },
    { zip: 6646, canton: "TI", commune: "Brione sopra Minusio" },
    { zip: 6614, canton: "TI", commune: "Brissago" },
    { zip: 6631, canton: "TI", commune: "Corippo" },
    { zip: 6636, canton: "TI", commune: "Frasco" },
    { zip: 6596, canton: "TI", commune: "Gordola" },
    { zip: 6595, canton: "TI", commune: "Lavertezzo" },
    { zip: 6633, canton: "TI", commune: "Lavertezzo" },
    { zip: 6516, canton: "TI", commune: "Locarno" },
    { zip: 6572, canton: "TI", commune: "Locarno" },
    { zip: 6594, canton: "TI", commune: "Locarno" },
    { zip: 6595, canton: "TI", commune: "Locarno" },
    { zip: 6596, canton: "TI", commune: "Locarno" },
    { zip: 6600, canton: "TI", commune: "Locarno" },
    { zip: 6605, canton: "TI", commune: "Locarno" },
    { zip: 6612, canton: "TI", commune: "Locarno" },
    { zip: 6644, canton: "TI", commune: "Locarno" },
    { zip: 6652, canton: "TI", commune: "Locarno" },
    { zip: 6616, canton: "TI", commune: "Losone" },
    { zip: 6618, canton: "TI", commune: "Losone" },
    { zip: 6647, canton: "TI", commune: "Mergoscia" },
    { zip: 6598, canton: "TI", commune: "Minusio" },
    { zip: 6600, canton: "TI", commune: "Minusio" },
    { zip: 6645, canton: "TI", commune: "Minusio" },
    { zip: 6646, canton: "TI", commune: "Minusio" },
    { zip: 6648, canton: "TI", commune: "Minusio" },
    { zip: 6600, canton: "TI", commune: "Muralto" },
    { zip: 6600, canton: "TI", commune: "Orselina" },
    { zip: 6605, canton: "TI", commune: "Orselina" },
    { zip: 6644, canton: "TI", commune: "Orselina" },
    { zip: 6613, canton: "TI", commune: "Ronco sopra Ascona" },
    { zip: 6622, canton: "TI", commune: "Ronco sopra Ascona" },
    { zip: 6637, canton: "TI", commune: "Sonogno" },
    { zip: 6598, canton: "TI", commune: "Tenero-Contra" },
    { zip: 6646, canton: "TI", commune: "Tenero-Contra" },
    { zip: 6632, canton: "TI", commune: "Vogorno" },
    { zip: 6611, canton: "TI", commune: "Onsernone" },
    { zip: 6655, canton: "TI", commune: "Onsernone" },
    { zip: 6661, canton: "TI", commune: "Onsernone" },
    { zip: 6662, canton: "TI", commune: "Onsernone" },
    { zip: 6663, canton: "TI", commune: "Onsernone" },
    { zip: 6664, canton: "TI", commune: "Onsernone" },
    { zip: 6516, canton: "TI", commune: "Cugnasco-Gerra" },
    { zip: 6594, canton: "TI", commune: "Cugnasco-Gerra" },
    { zip: 6595, canton: "TI", commune: "Cugnasco-Gerra" },
    { zip: 6597, canton: "TI", commune: "Cugnasco-Gerra" },
    { zip: 6635, canton: "TI", commune: "Cugnasco-Gerra" },
    { zip: 6934, canton: "TI", commune: "Agno" },
    { zip: 6982, canton: "TI", commune: "Agno" },
    { zip: 6990, canton: "TI", commune: "Agno" },
    { zip: 6994, canton: "TI", commune: "Aranno" },
    { zip: 6822, canton: "TI", commune: "Arogno" },
    { zip: 6823, canton: "TI", commune: "Arogno" },
    { zip: 6999, canton: "TI", commune: "Astano" },
    { zip: 6930, canton: "TI", commune: "Bedano" },
    { zip: 6981, canton: "TI", commune: "Bedigliora" },
    { zip: 6934, canton: "TI", commune: "Bioggio" },
    { zip: 6935, canton: "TI", commune: "Bioggio" },
    { zip: 6982, canton: "TI", commune: "Bioggio" },
    { zip: 6992, canton: "TI", commune: "Bioggio" },
    { zip: 6993, canton: "TI", commune: "Bioggio" },
    { zip: 6816, canton: "TI", commune: "Bissone" },
    { zip: 6827, canton: "TI", commune: "Brusino Arsizio" },
    { zip: 6867, canton: "TI", commune: "Brusino Arsizio" },
    { zip: 6936, canton: "TI", commune: "Cademario" },
    { zip: 6992, canton: "TI", commune: "Cademario" },
    { zip: 6814, canton: "TI", commune: "Cadempino" },
    { zip: 6952, canton: "TI", commune: "Canobbio" },
    { zip: 6987, canton: "TI", commune: "Caslano" },
    { zip: 6944, canton: "TI", commune: "Comano" },
    { zip: 6948, canton: "TI", commune: "Comano" },
    { zip: 6949, canton: "TI", commune: "Comano" },
    { zip: 6952, canton: "TI", commune: "Comano" },
    { zip: 6980, canton: "TI", commune: "Croglio" },
    { zip: 6981, canton: "TI", commune: "Croglio" },
    { zip: 6989, canton: "TI", commune: "Croglio" },
    { zip: 6995, canton: "TI", commune: "Croglio" },
    { zip: 6944, canton: "TI", commune: "Cureglia" },
    { zip: 6981, canton: "TI", commune: "Curio" },
    { zip: 6986, canton: "TI", commune: "Curio" },
    { zip: 6916, canton: "TI", commune: "Grancia" },
    { zip: 6929, canton: "TI", commune: "Gravesano" },
    { zip: 6807, canton: "TI", commune: "Lamone" },
    { zip: 6814, canton: "TI", commune: "Lamone" },
    { zip: 6823, canton: "TI", commune: "Lugano" },
    { zip: 6900, canton: "TI", commune: "Lugano" },
    { zip: 6912, canton: "TI", commune: "Lugano" },
    { zip: 6913, canton: "TI", commune: "Lugano" },
    { zip: 6914, canton: "TI", commune: "Lugano" },
    { zip: 6915, canton: "TI", commune: "Lugano" },
    { zip: 6916, canton: "TI", commune: "Lugano" },
    { zip: 6917, canton: "TI", commune: "Lugano" },
    { zip: 6918, canton: "TI", commune: "Lugano" },
    { zip: 6924, canton: "TI", commune: "Lugano" },
    { zip: 6925, canton: "TI", commune: "Lugano" },
    { zip: 6932, canton: "TI", commune: "Lugano" },
    { zip: 6933, canton: "TI", commune: "Lugano" },
    { zip: 6951, canton: "TI", commune: "Lugano" },
    { zip: 6959, canton: "TI", commune: "Lugano" },
    { zip: 6962, canton: "TI", commune: "Lugano" },
    { zip: 6963, canton: "TI", commune: "Lugano" },
    { zip: 6964, canton: "TI", commune: "Lugano" },
    { zip: 6965, canton: "TI", commune: "Lugano" },
    { zip: 6966, canton: "TI", commune: "Lugano" },
    { zip: 6967, canton: "TI", commune: "Lugano" },
    { zip: 6968, canton: "TI", commune: "Lugano" },
    { zip: 6974, canton: "TI", commune: "Lugano" },
    { zip: 6976, canton: "TI", commune: "Lugano" },
    { zip: 6977, canton: "TI", commune: "Lugano" },
    { zip: 6978, canton: "TI", commune: "Lugano" },
    { zip: 6979, canton: "TI", commune: "Lugano" },
    { zip: 6983, canton: "TI", commune: "Magliaso" },
    { zip: 6928, canton: "TI", commune: "Manno" },
    { zip: 6934, canton: "TI", commune: "Manno" },
    { zip: 6817, canton: "TI", commune: "Maroggia" },
    { zip: 6900, canton: "TI", commune: "Massagno" },
    { zip: 6818, canton: "TI", commune: "Melano" },
    { zip: 6815, canton: "TI", commune: "Melide" },
    { zip: 6805, canton: "TI", commune: "Mezzovico-Vira" },
    { zip: 6986, canton: "TI", commune: "Miglieglia" },
    { zip: 6995, canton: "TI", commune: "Monteggio" },
    { zip: 6996, canton: "TI", commune: "Monteggio" },
    { zip: 6997, canton: "TI", commune: "Monteggio" },
    { zip: 6998, canton: "TI", commune: "Monteggio" },
    { zip: 6918, canton: "TI", commune: "Morcote" },
    { zip: 6922, canton: "TI", commune: "Morcote" },
    { zip: 6933, canton: "TI", commune: "Muzzano" },
    { zip: 6983, canton: "TI", commune: "Neggio" },
    { zip: 6991, canton: "TI", commune: "Neggio" },
    { zip: 6986, canton: "TI", commune: "Novaggio" },
    { zip: 6945, canton: "TI", commune: "Origlio" },
    { zip: 6900, canton: "TI", commune: "Paradiso" },
    { zip: 6945, canton: "TI", commune: "Ponte Capriasca" },
    { zip: 6946, canton: "TI", commune: "Ponte Capriasca" },
    { zip: 6988, canton: "TI", commune: "Ponte Tresa" },
    { zip: 6942, canton: "TI", commune: "Porza" },
    { zip: 6948, canton: "TI", commune: "Porza" },
    { zip: 6952, canton: "TI", commune: "Porza" },
    { zip: 6984, canton: "TI", commune: "Pura" },
    { zip: 6821, canton: "TI", commune: "Rovio" },
    { zip: 6942, canton: "TI", commune: "Savosa" },
    { zip: 6948, canton: "TI", commune: "Savosa" },
    { zip: 6997, canton: "TI", commune: "Sessa" },
    { zip: 6924, canton: "TI", commune: "Sorengo" },
    { zip: 6807, canton: "TI", commune: "Capriasca" },
    { zip: 6947, canton: "TI", commune: "Capriasca" },
    { zip: 6950, canton: "TI", commune: "Capriasca" },
    { zip: 6953, canton: "TI", commune: "Capriasca" },
    { zip: 6954, canton: "TI", commune: "Capriasca" },
    { zip: 6955, canton: "TI", commune: "Capriasca" },
    { zip: 6956, canton: "TI", commune: "Capriasca" },
    { zip: 6957, canton: "TI", commune: "Capriasca" },
    { zip: 6958, canton: "TI", commune: "Capriasca" },
    { zip: 6960, canton: "TI", commune: "Capriasca" },
    { zip: 6807, canton: "TI", commune: "Torricella-Taverne" },
    { zip: 6808, canton: "TI", commune: "Torricella-Taverne" },
    { zip: 6990, canton: "TI", commune: "Vernate" },
    { zip: 6992, canton: "TI", commune: "Vernate" },
    { zip: 6993, canton: "TI", commune: "Vernate" },
    { zip: 6943, canton: "TI", commune: "Vezia" },
    { zip: 6921, canton: "TI", commune: "Vico Morcote" },
    { zip: 6916, canton: "TI", commune: "Collina d'Oro" },
    { zip: 6919, canton: "TI", commune: "Collina d'Oro" },
    { zip: 6925, canton: "TI", commune: "Collina d'Oro" },
    { zip: 6926, canton: "TI", commune: "Collina d'Oro" },
    { zip: 6927, canton: "TI", commune: "Collina d'Oro" },
    { zip: 6937, canton: "TI", commune: "Alto Malcantone" },
    { zip: 6938, canton: "TI", commune: "Alto Malcantone" },
    { zip: 6939, canton: "TI", commune: "Alto Malcantone" },
    { zip: 6802, canton: "TI", commune: "Monteceneri" },
    { zip: 6803, canton: "TI", commune: "Monteceneri" },
    { zip: 6804, canton: "TI", commune: "Monteceneri" },
    { zip: 6806, canton: "TI", commune: "Monteceneri" },
    { zip: 6809, canton: "TI", commune: "Monteceneri" },
    { zip: 6960, canton: "TI", commune: "Monteceneri" },
    { zip: 6828, canton: "TI", commune: "Balerna" },
    { zip: 6830, canton: "TI", commune: "Balerna" },
    { zip: 6850, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6872, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6873, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6874, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6875, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6877, canton: "TI", commune: "Castel San Pietro" },
    { zip: 6830, canton: "TI", commune: "Chiasso" },
    { zip: 6832, canton: "TI", commune: "Chiasso" },
    { zip: 6828, canton: "TI", commune: "Coldrerio" },
    { zip: 6877, canton: "TI", commune: "Coldrerio" },
    { zip: 6825, canton: "TI", commune: "Mendrisio" },
    { zip: 6826, canton: "TI", commune: "Mendrisio" },
    { zip: 6850, canton: "TI", commune: "Mendrisio" },
    { zip: 6852, canton: "TI", commune: "Mendrisio" },
    { zip: 6853, canton: "TI", commune: "Mendrisio" },
    { zip: 6862, canton: "TI", commune: "Mendrisio" },
    { zip: 6863, canton: "TI", commune: "Mendrisio" },
    { zip: 6864, canton: "TI", commune: "Mendrisio" },
    { zip: 6865, canton: "TI", commune: "Mendrisio" },
    { zip: 6866, canton: "TI", commune: "Mendrisio" },
    { zip: 6872, canton: "TI", commune: "Mendrisio" },
    { zip: 6833, canton: "TI", commune: "Morbio Inferiore" },
    { zip: 6834, canton: "TI", commune: "Morbio Inferiore" },
    { zip: 6883, canton: "TI", commune: "Novazzano" },
    { zip: 6826, canton: "TI", commune: "Riva San Vitale" },
    { zip: 6853, canton: "TI", commune: "Stabio" },
    { zip: 6854, canton: "TI", commune: "Stabio" },
    { zip: 6855, canton: "TI", commune: "Stabio" },
    { zip: 6833, canton: "TI", commune: "Vacallo" },
    { zip: 6835, canton: "TI", commune: "Breggia" },
    { zip: 6837, canton: "TI", commune: "Breggia" },
    { zip: 6838, canton: "TI", commune: "Breggia" },
    { zip: 6839, canton: "TI", commune: "Breggia" },
    { zip: 6710, canton: "TI", commune: "Biasca" },
    { zip: 6526, canton: "TI", commune: "Riviera" },
    { zip: 6527, canton: "TI", commune: "Riviera" },
    { zip: 6703, canton: "TI", commune: "Riviera" },
    { zip: 6705, canton: "TI", commune: "Riviera" },
    { zip: 6707, canton: "TI", commune: "Riviera" },
    { zip: 6685, canton: "TI", commune: "Bosco/Gurin" },
    { zip: 6683, canton: "TI", commune: "Campo (Vallemaggia)" },
    { zip: 6684, canton: "TI", commune: "Campo (Vallemaggia)" },
    { zip: 6683, canton: "TI", commune: "Cerentino" },
    { zip: 6675, canton: "TI", commune: "Cevio" },
    { zip: 6676, canton: "TI", commune: "Cevio" },
    { zip: 6690, canton: "TI", commune: "Cevio" },
    { zip: 6682, canton: "TI", commune: "Linescio" },
    { zip: 6670, canton: "TI", commune: "Maggia" },
    { zip: 6673, canton: "TI", commune: "Maggia" },
    { zip: 6674, canton: "TI", commune: "Maggia" },
    { zip: 6677, canton: "TI", commune: "Maggia" },
    { zip: 6678, canton: "TI", commune: "Maggia" },
    { zip: 6692, canton: "TI", commune: "Lavizzara" },
    { zip: 6693, canton: "TI", commune: "Lavizzara" },
    { zip: 6694, canton: "TI", commune: "Lavizzara" },
    { zip: 6695, canton: "TI", commune: "Lavizzara" },
    { zip: 6696, canton: "TI", commune: "Lavizzara" },
    { zip: 6670, canton: "TI", commune: "Avegno Gordevio" },
    { zip: 6672, canton: "TI", commune: "Avegno Gordevio" },
    { zip: 6652, canton: "TI", commune: "Terre di Pedemonte" },
    { zip: 6653, canton: "TI", commune: "Terre di Pedemonte" },
    { zip: 6654, canton: "TI", commune: "Terre di Pedemonte" },
    { zip: 6655, canton: "TI", commune: "Centovalli" },
    { zip: 6656, canton: "TI", commune: "Centovalli" },
    { zip: 6657, canton: "TI", commune: "Centovalli" },
    { zip: 6658, canton: "TI", commune: "Centovalli" },
    { zip: 6659, canton: "TI", commune: "Centovalli" },
    { zip: 6663, canton: "TI", commune: "Centovalli" },
    { zip: 6571, canton: "TI", commune: "Gambarogno" },
    { zip: 6572, canton: "TI", commune: "Gambarogno" },
    { zip: 6573, canton: "TI", commune: "Gambarogno" },
    { zip: 6574, canton: "TI", commune: "Gambarogno" },
    { zip: 6575, canton: "TI", commune: "Gambarogno" },
    { zip: 6576, canton: "TI", commune: "Gambarogno" },
    { zip: 6577, canton: "TI", commune: "Gambarogno" },
    { zip: 6578, canton: "TI", commune: "Gambarogno" },
    { zip: 6579, canton: "TI", commune: "Gambarogno" },
    { zip: 6593, canton: "TI", commune: "Gambarogno" },
    { zip: 6594, canton: "TI", commune: "Gambarogno" },
    { zip: 1860, canton: "VD", commune: "Aigle" },
    { zip: 1863, canton: "VD", commune: "Aigle" },
    { zip: 1880, canton: "VD", commune: "Bex" },
    { zip: 1882, canton: "VD", commune: "Bex" },
    { zip: 1846, canton: "VD", commune: "Chessel" },
    { zip: 1856, canton: "VD", commune: "Corbeyrier" },
    { zip: 1880, canton: "VD", commune: "Gryon" },
    { zip: 1882, canton: "VD", commune: "Gryon" },
    { zip: 1892, canton: "VD", commune: "Lavey-Morcles" },
    { zip: 1854, canton: "VD", commune: "Leysin" },
    { zip: 1845, canton: "VD", commune: "Noville" },
    { zip: 1860, canton: "VD", commune: "Ollon" },
    { zip: 1866, canton: "VD", commune: "Ollon" },
    { zip: 1867, canton: "VD", commune: "Ollon" },
    { zip: 1884, canton: "VD", commune: "Ollon" },
    { zip: 1885, canton: "VD", commune: "Ollon" },
    { zip: 1862, canton: "VD", commune: "Ormont-Dessous" },
    { zip: 1863, canton: "VD", commune: "Ormont-Dessous" },
    { zip: 1866, canton: "VD", commune: "Ormont-Dessous" },
    { zip: 1864, canton: "VD", commune: "Ormont-Dessus" },
    { zip: 1865, canton: "VD", commune: "Ormont-Dessus" },
    { zip: 1866, canton: "VD", commune: "Ormont-Dessus" },
    { zip: 1847, canton: "VD", commune: "Rennaz" },
    { zip: 1852, canton: "VD", commune: "Roche (VD)" },
    { zip: 1844, canton: "VD", commune: "Villeneuve (VD)" },
    { zip: 1846, canton: "VD", commune: "Yvorne" },
    { zip: 1852, canton: "VD", commune: "Yvorne" },
    { zip: 1853, canton: "VD", commune: "Yvorne" },
    { zip: 1128, canton: "VD", commune: "Apples" },
    { zip: 1143, canton: "VD", commune: "Apples" },
    { zip: 1170, canton: "VD", commune: "Aubonne" },
    { zip: 1172, canton: "VD", commune: "Aubonne" },
    { zip: 1174, canton: "VD", commune: "Aubonne" },
    { zip: 1144, canton: "VD", commune: "Ballens" },
    { zip: 1149, canton: "VD", commune: "Berolle" },
    { zip: 1145, canton: "VD", commune: "Bière" },
    { zip: 1149, canton: "VD", commune: "Bière" },
    { zip: 1172, canton: "VD", commune: "Bougy-Villars" },
    { zip: 1166, canton: "VD", commune: "Féchy" },
    { zip: 1173, canton: "VD", commune: "Féchy" },
    { zip: 1188, canton: "VD", commune: "Gimel" },
    { zip: 1261, canton: "VD", commune: "Longirod" },
    { zip: 1261, canton: "VD", commune: "Marchissy" },
    { zip: 1146, canton: "VD", commune: "Mollens (VD)" },
    { zip: 1170, canton: "VD", commune: "Montherod" },
    { zip: 1174, canton: "VD", commune: "Montherod" },
    { zip: 1188, canton: "VD", commune: "Saint-George" },
    { zip: 1145, canton: "VD", commune: "Saint-Livres" },
    { zip: 1170, canton: "VD", commune: "Saint-Livres" },
    { zip: 1176, canton: "VD", commune: "Saint-Livres" },
    { zip: 1187, canton: "VD", commune: "Saint-Oyens" },
    { zip: 1189, canton: "VD", commune: "Saubraz" },
    { zip: 1580, canton: "VD", commune: "Avenches" },
    { zip: 1721, canton: "VD", commune: "Avenches" },
    { zip: 1588, canton: "VD", commune: "Cudrefin" },
    { zip: 1595, canton: "VD", commune: "Faoug" },
    { zip: 1584, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1585, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1586, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1587, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1589, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1787, canton: "VD", commune: "Vully-les-Lacs" },
    { zip: 1042, canton: "VD", commune: "Bettens" },
    { zip: 1306, canton: "VD", commune: "Bettens" },
    { zip: 1035, canton: "VD", commune: "Bournens" },
    { zip: 1034, canton: "VD", commune: "Boussens" },
    { zip: 1148, canton: "VD", commune: "La Chaux (Cossonay)" },
    { zip: 1308, canton: "VD", commune: "La Chaux (Cossonay)" },
    { zip: 1316, canton: "VD", commune: "La Chaux (Cossonay)" },
    { zip: 1148, canton: "VD", commune: "Chavannes-le-Veyron" },
    { zip: 1316, canton: "VD", commune: "Chevilly" },
    { zip: 1304, canton: "VD", commune: "Cossonay" },
    { zip: 1116, canton: "VD", commune: "Cottens (VD)" },
    { zip: 1148, canton: "VD", commune: "Cuarnens" },
    { zip: 1306, canton: "VD", commune: "Daillens" },
    { zip: 1304, canton: "VD", commune: "Dizy" },
    { zip: 1312, canton: "VD", commune: "Eclépens" },
    { zip: 1313, canton: "VD", commune: "Ferreyres" },
    { zip: 1124, canton: "VD", commune: "Gollion" },
    { zip: 1117, canton: "VD", commune: "Grancy" },
    { zip: 1148, canton: "VD", commune: "L'Isle" },
    { zip: 1307, canton: "VD", commune: "Lussery-Villars" },
    { zip: 1148, canton: "VD", commune: "Mauraz" },
    { zip: 1031, canton: "VD", commune: "Mex (VD)" },
    { zip: 1148, canton: "VD", commune: "Moiry" },
    { zip: 1148, canton: "VD", commune: "Mont-la-Ville" },
    { zip: 1325, canton: "VD", commune: "Mont-la-Ville" },
    { zip: 1147, canton: "VD", commune: "Montricher" },
    { zip: 1317, canton: "VD", commune: "Orny" },
    { zip: 1372, canton: "VD", commune: "Orny" },
    { zip: 1142, canton: "VD", commune: "Pampigny" },
    { zip: 1305, canton: "VD", commune: "Penthalaz" },
    { zip: 1303, canton: "VD", commune: "Penthaz" },
    { zip: 1318, canton: "VD", commune: "Pompaples" },
    { zip: 1315, canton: "VD", commune: "La Sarraz" },
    { zip: 1304, canton: "VD", commune: "Senarclens" },
    { zip: 1141, canton: "VD", commune: "Sévery" },
    { zip: 1143, canton: "VD", commune: "Sévery" },
    { zip: 1036, canton: "VD", commune: "Sullens" },
    { zip: 1302, canton: "VD", commune: "Vufflens-la-Ville" },
    { zip: 1042, canton: "VD", commune: "Assens" },
    { zip: 1038, canton: "VD", commune: "Bercher" },
    { zip: 1042, canton: "VD", commune: "Bioley-Orjulaz" },
    { zip: 1041, canton: "VD", commune: "Bottens" },
    { zip: 1053, canton: "VD", commune: "Bretigny-sur-Morrens" },
    { zip: 1053, canton: "VD", commune: "Cugy (VD)" },
    { zip: 1040, canton: "VD", commune: "Echallens" },
    { zip: 1417, canton: "VD", commune: "Essertines-sur-Yverdon" },
    { zip: 1037, canton: "VD", commune: "Etagnières" },
    { zip: 1044, canton: "VD", commune: "Fey" },
    { zip: 1055, canton: "VD", commune: "Froideville" },
    { zip: 1054, canton: "VD", commune: "Morrens (VD)" },
    { zip: 1377, canton: "VD", commune: "Oulens-sous-Echallens" },
    { zip: 1416, canton: "VD", commune: "Pailly" },
    { zip: 1375, canton: "VD", commune: "Penthéréaz" },
    { zip: 1041, canton: "VD", commune: "Poliez-Pittet" },
    { zip: 1046, canton: "VD", commune: "Rueyres" },
    { zip: 1047, canton: "VD", commune: "Rueyres" },
    { zip: 1040, canton: "VD", commune: "Saint-Barthélemy (VD)" },
    { zip: 1040, canton: "VD", commune: "Villars-le-Terroir" },
    { zip: 1418, canton: "VD", commune: "Vuarrens" },
    { zip: 1041, canton: "VD", commune: "Montilliez" },
    { zip: 1043, canton: "VD", commune: "Montilliez" },
    { zip: 1376, canton: "VD", commune: "Goumoëns" },
    { zip: 1423, canton: "VD", commune: "Bonvillars" },
    { zip: 1427, canton: "VD", commune: "Bonvillars" },
    { zip: 1452, canton: "VD", commune: "Bullet" },
    { zip: 1453, canton: "VD", commune: "Bullet" },
    { zip: 1424, canton: "VD", commune: "Champagne" },
    { zip: 1426, canton: "VD", commune: "Concise" },
    { zip: 1428, canton: "VD", commune: "Concise" },
    { zip: 2028, canton: "VD", commune: "Concise" },
    { zip: 1426, canton: "VD", commune: "Corcelles-près-Concise" },
    { zip: 1420, canton: "VD", commune: "Fiez" },
    { zip: 1453, canton: "VD", commune: "Fiez" },
    { zip: 1421, canton: "VD", commune: "Fontaines-sur-Grandson" },
    { zip: 1453, canton: "VD", commune: "Fontaines-sur-Grandson" },
    { zip: 1429, canton: "VD", commune: "Giez" },
    { zip: 1421, canton: "VD", commune: "Grandevent" },
    { zip: 1422, canton: "VD", commune: "Grandson" },
    { zip: 1453, canton: "VD", commune: "Mauborget" },
    { zip: 1428, canton: "VD", commune: "Mutrux" },
    { zip: 1431, canton: "VD", commune: "Novalles" },
    { zip: 1425, canton: "VD", commune: "Onnens (VD)" },
    { zip: 1428, canton: "VD", commune: "Provence" },
    { zip: 2108, canton: "VD", commune: "Provence" },
    { zip: 1445, canton: "VD", commune: "Sainte-Croix" },
    { zip: 1450, canton: "VD", commune: "Sainte-Croix" },
    { zip: 1452, canton: "VD", commune: "Sainte-Croix" },
    { zip: 1454, canton: "VD", commune: "Sainte-Croix" },
    { zip: 1423, canton: "VD", commune: "Tévenon" },
    { zip: 1453, canton: "VD", commune: "Tévenon" },
    { zip: 1092, canton: "VD", commune: "Belmont-sur-Lausanne" },
    { zip: 1033, canton: "VD", commune: "Cheseaux-sur-Lausanne" },
    { zip: 1023, canton: "VD", commune: "Crissier" },
    { zip: 1033, canton: "VD", commune: "Crissier" },
    { zip: 1066, canton: "VD", commune: "Epalinges" },
    { zip: 1008, canton: "VD", commune: "Jouxtens-Mézery" },
    { zip: 1000, canton: "VD", commune: "Lausanne" },
    { zip: 1003, canton: "VD", commune: "Lausanne" },
    { zip: 1004, canton: "VD", commune: "Lausanne" },
    { zip: 1005, canton: "VD", commune: "Lausanne" },
    { zip: 1006, canton: "VD", commune: "Lausanne" },
    { zip: 1007, canton: "VD", commune: "Lausanne" },
    { zip: 1010, canton: "VD", commune: "Lausanne" },
    { zip: 1011, canton: "VD", commune: "Lausanne" },
    { zip: 1012, canton: "VD", commune: "Lausanne" },
    { zip: 1018, canton: "VD", commune: "Lausanne" },
    { zip: 1023, canton: "VD", commune: "Lausanne" },
    { zip: 1032, canton: "VD", commune: "Lausanne" },
    { zip: 1033, canton: "VD", commune: "Lausanne" },
    { zip: 1052, canton: "VD", commune: "Lausanne" },
    { zip: 1053, canton: "VD", commune: "Lausanne" },
    { zip: 1066, canton: "VD", commune: "Lausanne" },
    { zip: 1052, canton: "VD", commune: "Le Mont-sur-Lausanne" },
    { zip: 1094, canton: "VD", commune: "Paudex" },
    { zip: 1008, canton: "VD", commune: "Prilly" },
    { zip: 1009, canton: "VD", commune: "Pully" },
    { zip: 1068, canton: "VD", commune: "Pully" },
    { zip: 1008, canton: "VD", commune: "Renens (VD)" },
    { zip: 1020, canton: "VD", commune: "Renens (VD)" },
    { zip: 1032, canton: "VD", commune: "Romanel-sur-Lausanne" },
    { zip: 1071, canton: "VD", commune: "Chexbres" },
    { zip: 1072, canton: "VD", commune: "Forel (Lavaux)" },
    { zip: 1073, canton: "VD", commune: "Forel (Lavaux)" },
    { zip: 1080, canton: "VD", commune: "Forel (Lavaux)" },
    { zip: 1091, canton: "VD", commune: "Forel (Lavaux)" },
    { zip: 1090, canton: "VD", commune: "Lutry" },
    { zip: 1092, canton: "VD", commune: "Lutry" },
    { zip: 1093, canton: "VD", commune: "Lutry" },
    { zip: 1095, canton: "VD", commune: "Lutry" },
    { zip: 1070, canton: "VD", commune: "Puidoux" },
    { zip: 1071, canton: "VD", commune: "Puidoux" },
    { zip: 1096, canton: "VD", commune: "Puidoux" },
    { zip: 1098, canton: "VD", commune: "Puidoux" },
    { zip: 1607, canton: "VD", commune: "Puidoux" },
    { zip: 1071, canton: "VD", commune: "Rivaz" },
    { zip: 1071, canton: "VD", commune: "Saint-Saphorin (Lavaux)" },
    { zip: 1073, canton: "VD", commune: "Savigny" },
    { zip: 1090, canton: "VD", commune: "Savigny" },
    { zip: 1091, canton: "VD", commune: "Savigny" },
    { zip: 1070, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1091, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1095, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1096, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1097, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1098, canton: "VD", commune: "Bourg-en-Lavaux" },
    { zip: 1123, canton: "VD", commune: "Aclens" },
    { zip: 1121, canton: "VD", commune: "Bremblens" },
    { zip: 1164, canton: "VD", commune: "Buchillon" },
    { zip: 1030, canton: "VD", commune: "Bussigny" },
    { zip: 1136, canton: "VD", commune: "Bussy-Chardonney" },
    { zip: 1015, canton: "VD", commune: "Chavannes-près-Renens" },
    { zip: 1022, canton: "VD", commune: "Chavannes-près-Renens" },
    { zip: 1134, canton: "VD", commune: "Chigny" },
    { zip: 1127, canton: "VD", commune: "Clarmont" },
    { zip: 1135, canton: "VD", commune: "Denens" },
    { zip: 1026, canton: "VD", commune: "Denges" },
    { zip: 1026, canton: "VD", commune: "Echandens" },
    { zip: 1112, canton: "VD", commune: "Echichens" },
    { zip: 1113, canton: "VD", commune: "Echichens" },
    { zip: 1114, canton: "VD", commune: "Echichens" },
    { zip: 1125, canton: "VD", commune: "Echichens" },
    { zip: 1015, canton: "VD", commune: "Ecublens (VD)" },
    { zip: 1024, canton: "VD", commune: "Ecublens (VD)" },
    { zip: 1163, canton: "VD", commune: "Etoy" },
    { zip: 1170, canton: "VD", commune: "Lavigny" },
    { zip: 1175, canton: "VD", commune: "Lavigny" },
    { zip: 1027, canton: "VD", commune: "Lonay" },
    { zip: 1132, canton: "VD", commune: "Lully (VD)" },
    { zip: 1167, canton: "VD", commune: "Lussy-sur-Morges" },
    { zip: 1110, canton: "VD", commune: "Morges" },
    { zip: 1028, canton: "VD", commune: "Préverenges" },
    { zip: 1128, canton: "VD", commune: "Reverolle" },
    { zip: 1122, canton: "VD", commune: "Romanel-sur-Morges" },
    { zip: 1162, canton: "VD", commune: "Saint-Prex" },
    { zip: 1015, canton: "VD", commune: "Saint-Sulpice (VD)" },
    { zip: 1024, canton: "VD", commune: "Saint-Sulpice (VD)" },
    { zip: 1025, canton: "VD", commune: "Saint-Sulpice (VD)" },
    { zip: 1131, canton: "VD", commune: "Tolochenaz" },
    { zip: 1126, canton: "VD", commune: "Vaux-sur-Morges" },
    { zip: 1029, canton: "VD", commune: "Villars-Sainte-Croix" },
    { zip: 1168, canton: "VD", commune: "Villars-sous-Yens" },
    { zip: 1134, canton: "VD", commune: "Vufflens-le-Château" },
    { zip: 1115, canton: "VD", commune: "Vullierens" },
    { zip: 1169, canton: "VD", commune: "Yens" },
    { zip: 1038, canton: "VD", commune: "Boulens" },
    { zip: 1063, canton: "VD", commune: "Boulens" },
    { zip: 1514, canton: "VD", commune: "Bussy-sur-Moudon" },
    { zip: 1512, canton: "VD", commune: "Chavannes-sur-Moudon" },
    { zip: 1521, canton: "VD", commune: "Curtilles" },
    { zip: 1682, canton: "VD", commune: "Dompierre (VD)" },
    { zip: 1059, canton: "VD", commune: "Hermenches" },
    { zip: 1513, canton: "VD", commune: "Hermenches" },
    { zip: 1682, canton: "VD", commune: "Lovatens" },
    { zip: 1522, canton: "VD", commune: "Lucens" },
    { zip: 1526, canton: "VD", commune: "Lucens" },
    { zip: 1683, canton: "VD", commune: "Lucens" },
    { zip: 1510, canton: "VD", commune: "Moudon" },
    { zip: 1045, canton: "VD", commune: "Ogens" },
    { zip: 1682, canton: "VD", commune: "Prévonloup" },
    { zip: 1513, canton: "VD", commune: "Rossenges" },
    { zip: 1510, canton: "VD", commune: "Syens" },
    { zip: 1515, canton: "VD", commune: "Villars-le-Comte" },
    { zip: 1509, canton: "VD", commune: "Vucherens" },
    { zip: 1038, canton: "VD", commune: "Montanaire" },
    { zip: 1063, canton: "VD", commune: "Montanaire" },
    { zip: 1409, canton: "VD", commune: "Montanaire" },
    { zip: 1410, canton: "VD", commune: "Montanaire" },
    { zip: 1515, canton: "VD", commune: "Montanaire" },
    { zip: 1277, canton: "VD", commune: "Arnex-sur-Nyon" },
    { zip: 1264, canton: "VD", commune: "Arzier-Le Muids" },
    { zip: 1273, canton: "VD", commune: "Arzier-Le Muids" },
    { zip: 1269, canton: "VD", commune: "Bassins" },
    { zip: 1268, canton: "VD", commune: "Begnins" },
    { zip: 1279, canton: "VD", commune: "Bogis-Bossey" },
    { zip: 1277, canton: "VD", commune: "Borex" },
    { zip: 1279, canton: "VD", commune: "Chavannes-de-Bogis" },
    { zip: 1290, canton: "VD", commune: "Chavannes-des-Bois" },
    { zip: 1275, canton: "VD", commune: "Chéserex" },
    { zip: 1276, canton: "VD", commune: "Chéserex" },
    { zip: 1196, canton: "VD", commune: "Coinsins" },
    { zip: 1267, canton: "VD", commune: "Coinsins" },
    { zip: 1291, canton: "VD", commune: "Commugny" },
    { zip: 1297, canton: "VD", commune: "Commugny" },
    { zip: 1296, canton: "VD", commune: "Coppet" },
    { zip: 1297, canton: "VD", commune: "Coppet" },
    { zip: 1299, canton: "VD", commune: "Crans-près-Céligny" },
    { zip: 1263, canton: "VD", commune: "Crassier" },
    { zip: 1266, canton: "VD", commune: "Duillier" },
    { zip: 1262, canton: "VD", commune: "Eysins" },
    { zip: 1297, canton: "VD", commune: "Founex" },
    { zip: 1272, canton: "VD", commune: "Genolier" },
    { zip: 1276, canton: "VD", commune: "Gingins" },
    { zip: 1271, canton: "VD", commune: "Givrins" },
    { zip: 1272, canton: "VD", commune: "Givrins" },
    { zip: 1196, canton: "VD", commune: "Gland" },
    { zip: 1274, canton: "VD", commune: "Grens" },
    { zip: 1290, canton: "VD", commune: "Mies" },
    { zip: 1295, canton: "VD", commune: "Mies" },
    { zip: 1260, canton: "VD", commune: "Nyon" },
    { zip: 1196, canton: "VD", commune: "Prangins" },
    { zip: 1197, canton: "VD", commune: "Prangins" },
    { zip: 1260, canton: "VD", commune: "Prangins" },
    { zip: 1275, canton: "VD", commune: "La Rippe" },
    { zip: 1278, canton: "VD", commune: "La Rippe" },
    { zip: 1264, canton: "VD", commune: "Saint-Cergue" },
    { zip: 1265, canton: "VD", commune: "Saint-Cergue" },
    { zip: 1276, canton: "VD", commune: "Saint-Cergue" },
    { zip: 1274, canton: "VD", commune: "Signy-Avenex" },
    { zip: 1295, canton: "VD", commune: "Tannay" },
    { zip: 1270, canton: "VD", commune: "Trélex" },
    { zip: 1274, canton: "VD", commune: "Trélex" },
    { zip: 1261, canton: "VD", commune: "Le Vaud" },
    { zip: 1267, canton: "VD", commune: "Vich" },
    { zip: 1355, canton: "VD", commune: "L'Abergement" },
    { zip: 1352, canton: "VD", commune: "Agiez" },
    { zip: 1321, canton: "VD", commune: "Arnex-sur-Orbe" },
    { zip: 1338, canton: "VD", commune: "Ballaigues" },
    { zip: 1446, canton: "VD", commune: "Baulmes" },
    { zip: 1372, canton: "VD", commune: "Bavois" },
    { zip: 1353, canton: "VD", commune: "Bofflens" },
    { zip: 1329, canton: "VD", commune: "Bretonnières" },
    { zip: 1373, canton: "VD", commune: "Chavornay" },
    { zip: 1374, canton: "VD", commune: "Chavornay" },
    { zip: 1435, canton: "VD", commune: "Chavornay" },
    { zip: 1356, canton: "VD", commune: "Les Clées" },
    { zip: 1322, canton: "VD", commune: "Croy" },
    { zip: 1326, canton: "VD", commune: "Juriens" },
    { zip: 1357, canton: "VD", commune: "Lignerolle" },
    { zip: 1354, canton: "VD", commune: "Montcherand" },
    { zip: 1350, canton: "VD", commune: "Orbe" },
    { zip: 1148, canton: "VD", commune: "La Praz" },
    { zip: 1324, canton: "VD", commune: "Premier" },
    { zip: 1439, canton: "VD", commune: "Rances" },
    { zip: 1323, canton: "VD", commune: "Romainmôtier-Envy" },
    { zip: 1355, canton: "VD", commune: "Sergey" },
    { zip: 1358, canton: "VD", commune: "Valeyres-sous-Rances" },
    { zip: 1337, canton: "VD", commune: "Vallorbe" },
    { zip: 1325, canton: "VD", commune: "Vaulion" },
    { zip: 1445, canton: "VD", commune: "Vuiteboeuf" },
    { zip: 1082, canton: "VD", commune: "Corcelles-le-Jorat" },
    { zip: 1513, canton: "VD", commune: "Corcelles-le-Jorat" },
    { zip: 1078, canton: "VD", commune: "Essertes" },
    { zip: 1613, canton: "VD", commune: "Maracon" },
    { zip: 1081, canton: "VD", commune: "Montpreveyres" },
    { zip: 1088, canton: "VD", commune: "Ropraz" },
    { zip: 1513, canton: "VD", commune: "Ropraz" },
    { zip: 1077, canton: "VD", commune: "Servion" },
    { zip: 1080, canton: "VD", commune: "Servion" },
    { zip: 1084, canton: "VD", commune: "Vulliens" },
    { zip: 1085, canton: "VD", commune: "Vulliens" },
    { zip: 1041, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1058, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1059, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1061, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1062, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1063, canton: "VD", commune: "Jorat-Menthue" },
    { zip: 1607, canton: "VD", commune: "Oron" },
    { zip: 1608, canton: "VD", commune: "Oron" },
    { zip: 1610, canton: "VD", commune: "Oron" },
    { zip: 1612, canton: "VD", commune: "Oron" },
    { zip: 1076, canton: "VD", commune: "Jorat-Mézières" },
    { zip: 1083, canton: "VD", commune: "Jorat-Mézières" },
    { zip: 1084, canton: "VD", commune: "Jorat-Mézières" },
    { zip: 1537, canton: "VD", commune: "Champtauroz" },
    { zip: 1545, canton: "VD", commune: "Chevroux" },
    { zip: 1530, canton: "VD", commune: "Corcelles-près-Payerne" },
    { zip: 1562, canton: "VD", commune: "Corcelles-près-Payerne" },
    { zip: 1543, canton: "VD", commune: "Grandcour" },
    { zip: 1525, canton: "VD", commune: "Henniez" },
    { zip: 1565, canton: "VD", commune: "Missy" },
    { zip: 1530, canton: "VD", commune: "Payerne" },
    { zip: 1551, canton: "VD", commune: "Payerne" },
    { zip: 1562, canton: "VD", commune: "Payerne" },
    { zip: 1552, canton: "VD", commune: "Trey" },
    { zip: 1538, canton: "VD", commune: "Treytorrens (Payerne)" },
    { zip: 1554, canton: "VD", commune: "Villarzel" },
    { zip: 1555, canton: "VD", commune: "Villarzel" },
    { zip: 1485, canton: "VD", commune: "Valbroye" },
    { zip: 1522, canton: "VD", commune: "Valbroye" },
    { zip: 1523, canton: "VD", commune: "Valbroye" },
    { zip: 1524, canton: "VD", commune: "Valbroye" },
    { zip: 1525, canton: "VD", commune: "Valbroye" },
    { zip: 1534, canton: "VD", commune: "Valbroye" },
    { zip: 1535, canton: "VD", commune: "Valbroye" },
    { zip: 1536, canton: "VD", commune: "Valbroye" },
    { zip: 1682, canton: "VD", commune: "Valbroye" },
    { zip: 1659, canton: "VD", commune: "Château-d'Oex" },
    { zip: 1660, canton: "VD", commune: "Château-d'Oex" },
    { zip: 1658, canton: "VD", commune: "Rossinière" },
    { zip: 1659, canton: "VD", commune: "Rougemont" },
    { zip: 1165, canton: "VD", commune: "Allaman" },
    { zip: 1195, canton: "VD", commune: "Bursinel" },
    { zip: 1183, canton: "VD", commune: "Bursins" },
    { zip: 1268, canton: "VD", commune: "Bursins" },
    { zip: 1268, canton: "VD", commune: "Burtigny" },
    { zip: 1195, canton: "VD", commune: "Dully" },
    { zip: 1180, canton: "VD", commune: "Essertines-sur-Rolle" },
    { zip: 1185, canton: "VD", commune: "Essertines-sur-Rolle" },
    { zip: 1186, canton: "VD", commune: "Essertines-sur-Rolle" },
    { zip: 1180, canton: "VD", commune: "Gilly" },
    { zip: 1182, canton: "VD", commune: "Gilly" },
    { zip: 1183, canton: "VD", commune: "Gilly" },
    { zip: 1186, canton: "VD", commune: "Gilly" },
    { zip: 1195, canton: "VD", commune: "Gilly" },
    { zip: 1184, canton: "VD", commune: "Luins" },
    { zip: 1185, canton: "VD", commune: "Mont-sur-Rolle" },
    { zip: 1166, canton: "VD", commune: "Perroy" },
    { zip: 1180, canton: "VD", commune: "Rolle" },
    { zip: 1180, canton: "VD", commune: "Tartegnin" },
    { zip: 1184, canton: "VD", commune: "Vinzel" },
    { zip: 1268, canton: "VD", commune: "Vinzel" },
    { zip: 1342, canton: "VD", commune: "L'Abbaye" },
    { zip: 1344, canton: "VD", commune: "L'Abbaye" },
    { zip: 1346, canton: "VD", commune: "L'Abbaye" },
    { zip: 1341, canton: "VD", commune: "Le Chenit" },
    { zip: 1347, canton: "VD", commune: "Le Chenit" },
    { zip: 1348, canton: "VD", commune: "Le Chenit" },
    { zip: 1343, canton: "VD", commune: "Le Lieu" },
    { zip: 1345, canton: "VD", commune: "Le Lieu" },
    { zip: 1807, canton: "VD", commune: "Blonay" },
    { zip: 1816, canton: "VD", commune: "Blonay" },
    { zip: 1070, canton: "VD", commune: "Chardonne" },
    { zip: 1071, canton: "VD", commune: "Chardonne" },
    { zip: 1614, canton: "VD", commune: "Chardonne" },
    { zip: 1801, canton: "VD", commune: "Chardonne" },
    { zip: 1802, canton: "VD", commune: "Chardonne" },
    { zip: 1803, canton: "VD", commune: "Chardonne" },
    { zip: 1805, canton: "VD", commune: "Chardonne" },
    { zip: 1802, canton: "VD", commune: "Corseaux" },
    { zip: 1804, canton: "VD", commune: "Corsier-sur-Vevey" },
    { zip: 1805, canton: "VD", commune: "Corsier-sur-Vevey" },
    { zip: 1808, canton: "VD", commune: "Corsier-sur-Vevey" },
    { zip: 1809, canton: "VD", commune: "Corsier-sur-Vevey" },
    { zip: 1803, canton: "VD", commune: "Jongny" },
    { zip: 1804, canton: "VD", commune: "Jongny" },
    { zip: 1805, canton: "VD", commune: "Jongny" },
    { zip: 1807, canton: "VD", commune: "Montreux" },
    { zip: 1815, canton: "VD", commune: "Montreux" },
    { zip: 1816, canton: "VD", commune: "Montreux" },
    { zip: 1817, canton: "VD", commune: "Montreux" },
    { zip: 1820, canton: "VD", commune: "Montreux" },
    { zip: 1822, canton: "VD", commune: "Montreux" },
    { zip: 1823, canton: "VD", commune: "Montreux" },
    { zip: 1824, canton: "VD", commune: "Montreux" },
    { zip: 1832, canton: "VD", commune: "Montreux" },
    { zip: 1833, canton: "VD", commune: "Montreux" },
    { zip: 1806, canton: "VD", commune: "Saint-Légier-La Chiésaz" },
    { zip: 1814, canton: "VD", commune: "La Tour-de-Peilz" },
    { zip: 1800, canton: "VD", commune: "Vevey" },
    { zip: 1820, canton: "VD", commune: "Veytaux" },
    { zip: 1824, canton: "VD", commune: "Veytaux" },
    { zip: 1432, canton: "VD", commune: "Belmont-sur-Yverdon" },
    { zip: 1045, canton: "VD", commune: "Bioley-Magnoux" },
    { zip: 1407, canton: "VD", commune: "Bioley-Magnoux" },
    { zip: 1436, canton: "VD", commune: "Chamblon" },
    { zip: 1443, canton: "VD", commune: "Champvent" },
    { zip: 1464, canton: "VD", commune: "Chavannes-le-Chêne" },
    { zip: 1464, canton: "VD", commune: "Chêne-Pâquier" },
    { zip: 1400, canton: "VD", commune: "Cheseaux-Noréaz" },
    { zip: 1462, canton: "VD", commune: "Cheseaux-Noréaz" },
    { zip: 1406, canton: "VD", commune: "Cronay" },
    { zip: 1400, canton: "VD", commune: "Cuarny" },
    { zip: 1404, canton: "VD", commune: "Cuarny" },
    { zip: 1415, canton: "VD", commune: "Démoret" },
    { zip: 1407, canton: "VD", commune: "Donneloye" },
    { zip: 1408, canton: "VD", commune: "Donneloye" },
    { zip: 1434, canton: "VD", commune: "Ependes (VD)" },
    { zip: 1438, canton: "VD", commune: "Mathod" },
    { zip: 1415, canton: "VD", commune: "Molondin" },
    { zip: 1442, canton: "VD", commune: "Montagny-près-Yverdon" },
    { zip: 1047, canton: "VD", commune: "Oppens" },
    { zip: 1430, canton: "VD", commune: "Orges" },
    { zip: 1413, canton: "VD", commune: "Orzens" },
    { zip: 1405, canton: "VD", commune: "Pomy" },
    { zip: 1463, canton: "VD", commune: "Rovray" },
    { zip: 1433, canton: "VD", commune: "Suchy" },
    { zip: 1437, canton: "VD", commune: "Suscévaz" },
    { zip: 1436, canton: "VD", commune: "Treycovagnes" },
    { zip: 1412, canton: "VD", commune: "Ursins" },
    { zip: 1441, canton: "VD", commune: "Valeyres-sous-Montagny" },
    { zip: 1412, canton: "VD", commune: "Valeyres-sous-Ursins" },
    { zip: 1432, canton: "VD", commune: "Valeyres-sous-Ursins" },
    { zip: 1404, canton: "VD", commune: "Villars-Epeney" },
    { zip: 1431, canton: "VD", commune: "Vugelles-La Mothe" },
    { zip: 1400, canton: "VD", commune: "Yverdon-les-Bains" },
    { zip: 1432, canton: "VD", commune: "Yverdon-les-Bains" },
    { zip: 1462, canton: "VD", commune: "Yvonand" },
    { zip: 3900, canton: "VS", commune: "Brig-Glis" },
    { zip: 3902, canton: "VS", commune: "Brig-Glis" },
    { zip: 3939, canton: "VS", commune: "Eggerberg" },
    { zip: 3903, canton: "VS", commune: "Naters" },
    { zip: 3904, canton: "VS", commune: "Naters" },
    { zip: 3914, canton: "VS", commune: "Naters" },
    { zip: 3900, canton: "VS", commune: "Ried-Brig" },
    { zip: 3901, canton: "VS", commune: "Ried-Brig" },
    { zip: 3911, canton: "VS", commune: "Ried-Brig" },
    { zip: 3907, canton: "VS", commune: "Simplon" },
    { zip: 3900, canton: "VS", commune: "Termen" },
    { zip: 3912, canton: "VS", commune: "Termen" },
    { zip: 3913, canton: "VS", commune: "Termen" },
    { zip: 3982, canton: "VS", commune: "Termen" },
    { zip: 3907, canton: "VS", commune: "Zwischbergen" },
    { zip: 1957, canton: "VS", commune: "Ardon" },
    { zip: 1911, canton: "VS", commune: "Chamoson" },
    { zip: 1955, canton: "VS", commune: "Chamoson" },
    { zip: 1964, canton: "VS", commune: "Conthey" },
    { zip: 1975, canton: "VS", commune: "Conthey" },
    { zip: 1976, canton: "VS", commune: "Conthey" },
    { zip: 1993, canton: "VS", commune: "Nendaz" },
    { zip: 1994, canton: "VS", commune: "Nendaz" },
    { zip: 1996, canton: "VS", commune: "Nendaz" },
    { zip: 1997, canton: "VS", commune: "Nendaz" },
    { zip: 1963, canton: "VS", commune: "Vétroz" },
    { zip: 1934, canton: "VS", commune: "Bagnes" },
    { zip: 1936, canton: "VS", commune: "Bagnes" },
    { zip: 1947, canton: "VS", commune: "Bagnes" },
    { zip: 1948, canton: "VS", commune: "Bagnes" },
    { zip: 1946, canton: "VS", commune: "Bourg-Saint-Pierre" },
    { zip: 1945, canton: "VS", commune: "Liddes" },
    { zip: 1937, canton: "VS", commune: "Orsières" },
    { zip: 1938, canton: "VS", commune: "Orsières" },
    { zip: 1943, canton: "VS", commune: "Orsières" },
    { zip: 1944, canton: "VS", commune: "Orsières" },
    { zip: 1933, canton: "VS", commune: "Sembrancher" },
    { zip: 1927, canton: "VS", commune: "Vollèges" },
    { zip: 1933, canton: "VS", commune: "Vollèges" },
    { zip: 1941, canton: "VS", commune: "Vollèges" },
    { zip: 1942, canton: "VS", commune: "Vollèges" },
    { zip: 3997, canton: "VS", commune: "Bellwald" },
    { zip: 3996, canton: "VS", commune: "Binn" },
    { zip: 3995, canton: "VS", commune: "Ernen" },
    { zip: 3984, canton: "VS", commune: "Fiesch" },
    { zip: 3801, canton: "VS", commune: "Fieschertal" },
    { zip: 3984, canton: "VS", commune: "Fieschertal" },
    { zip: 3994, canton: "VS", commune: "Lax" },
    { zip: 3988, canton: "VS", commune: "Obergoms" },
    { zip: 3999, canton: "VS", commune: "Obergoms" },
    { zip: 3985, canton: "VS", commune: "Goms" },
    { zip: 3989, canton: "VS", commune: "Goms" },
    { zip: 3998, canton: "VS", commune: "Goms" },
    { zip: 1958, canton: "VS", commune: "Ayent" },
    { zip: 1966, canton: "VS", commune: "Ayent" },
    { zip: 1972, canton: "VS", commune: "Ayent" },
    { zip: 1983, canton: "VS", commune: "Evolène" },
    { zip: 1984, canton: "VS", commune: "Evolène" },
    { zip: 1985, canton: "VS", commune: "Evolène" },
    { zip: 1986, canton: "VS", commune: "Evolène" },
    { zip: 1982, canton: "VS", commune: "Hérémence" },
    { zip: 1987, canton: "VS", commune: "Hérémence" },
    { zip: 1969, canton: "VS", commune: "Saint-Martin (VS)" },
    { zip: 1982, canton: "VS", commune: "Saint-Martin (VS)" },
    { zip: 1981, canton: "VS", commune: "Vex" },
    { zip: 1988, canton: "VS", commune: "Vex" },
    { zip: 1992, canton: "VS", commune: "Vex" },
    { zip: 1961, canton: "VS", commune: "Mont-Noble" },
    { zip: 1968, canton: "VS", commune: "Mont-Noble" },
    { zip: 1973, canton: "VS", commune: "Mont-Noble" },
    { zip: 3951, canton: "VS", commune: "Agarn" },
    { zip: 3955, canton: "VS", commune: "Albinen" },
    { zip: 3956, canton: "VS", commune: "Albinen" },
    { zip: 3946, canton: "VS", commune: "Ergisch" },
    { zip: 3947, canton: "VS", commune: "Ergisch" },
    { zip: 3953, canton: "VS", commune: "Inden" },
    { zip: 3945, canton: "VS", commune: "Leuk" },
    { zip: 3952, canton: "VS", commune: "Leuk" },
    { zip: 3953, canton: "VS", commune: "Leuk" },
    { zip: 3957, canton: "VS", commune: "Leuk" },
    { zip: 3970, canton: "VS", commune: "Leuk" },
    { zip: 3954, canton: "VS", commune: "Leukerbad" },
    { zip: 3948, canton: "VS", commune: "Oberems" },
    { zip: 3970, canton: "VS", commune: "Salgesch" },
    { zip: 3953, canton: "VS", commune: "Varen" },
    { zip: 3956, canton: "VS", commune: "Guttet-Feschel" },
    { zip: 3945, canton: "VS", commune: "Gampel-Bratsch" },
    { zip: 3957, canton: "VS", commune: "Gampel-Bratsch" },
    { zip: 3945, canton: "VS", commune: "Turtmann-Unterems" },
    { zip: 3946, canton: "VS", commune: "Turtmann-Unterems" },
    { zip: 3948, canton: "VS", commune: "Turtmann-Unterems" },
    { zip: 1927, canton: "VS", commune: "Bovernier" },
    { zip: 1932, canton: "VS", commune: "Bovernier" },
    { zip: 1906, canton: "VS", commune: "Charrat" },
    { zip: 1926, canton: "VS", commune: "Fully" },
    { zip: 1914, canton: "VS", commune: "Isérables" },
    { zip: 1911, canton: "VS", commune: "Leytron" },
    { zip: 1912, canton: "VS", commune: "Leytron" },
    { zip: 1904, canton: "VS", commune: "Martigny" },
    { zip: 1906, canton: "VS", commune: "Martigny" },
    { zip: 1920, canton: "VS", commune: "Martigny" },
    { zip: 1927, canton: "VS", commune: "Martigny" },
    { zip: 1921, canton: "VS", commune: "Martigny-Combe" },
    { zip: 1928, canton: "VS", commune: "Martigny-Combe" },
    { zip: 1932, canton: "VS", commune: "Martigny-Combe" },
    { zip: 1908, canton: "VS", commune: "Riddes" },
    { zip: 1914, canton: "VS", commune: "Riddes" },
    { zip: 1918, canton: "VS", commune: "Riddes" },
    { zip: 1913, canton: "VS", commune: "Saillon" },
    { zip: 1907, canton: "VS", commune: "Saxon" },
    { zip: 1929, canton: "VS", commune: "Trient" },
    { zip: 1874, canton: "VS", commune: "Champéry" },
    { zip: 1868, canton: "VS", commune: "Collombey-Muraz" },
    { zip: 1872, canton: "VS", commune: "Collombey-Muraz" },
    { zip: 1893, canton: "VS", commune: "Collombey-Muraz" },
    { zip: 1870, canton: "VS", commune: "Monthey" },
    { zip: 1871, canton: "VS", commune: "Monthey" },
    { zip: 1897, canton: "VS", commune: "Port-Valais" },
    { zip: 1898, canton: "VS", commune: "Saint-Gingolph" },
    { zip: 1872, canton: "VS", commune: "Troistorrents" },
    { zip: 1875, canton: "VS", commune: "Troistorrents" },
    { zip: 1873, canton: "VS", commune: "Val-d'Illiez" },
    { zip: 1895, canton: "VS", commune: "Vionnaz" },
    { zip: 1899, canton: "VS", commune: "Vionnaz" },
    { zip: 1896, canton: "VS", commune: "Vouvry" },
    { zip: 3983, canton: "VS", commune: "Bister" },
    { zip: 3982, canton: "VS", commune: "Bitsch" },
    { zip: 3993, canton: "VS", commune: "Grengiols" },
    { zip: 3982, canton: "VS", commune: "Riederalp" },
    { zip: 3983, canton: "VS", commune: "Riederalp" },
    { zip: 3986, canton: "VS", commune: "Riederalp" },
    { zip: 3987, canton: "VS", commune: "Riederalp" },
    { zip: 3938, canton: "VS", commune: "Ausserberg" },
    { zip: 3919, canton: "VS", commune: "Blatten" },
    { zip: 3935, canton: "VS", commune: "Bürchen" },
    { zip: 3943, canton: "VS", commune: "Eischoll" },
    { zip: 3916, canton: "VS", commune: "Ferden" },
    { zip: 3917, canton: "VS", commune: "Ferden" },
    { zip: 3917, canton: "VS", commune: "Kippel" },
    { zip: 3942, canton: "VS", commune: "Niedergesteln" },
    { zip: 3942, canton: "VS", commune: "Raron" },
    { zip: 3944, canton: "VS", commune: "Unterbäch" },
    { zip: 3918, canton: "VS", commune: "Wiler (Lötschen)" },
    { zip: 3983, canton: "VS", commune: "Mörel-Filet" },
    { zip: 3940, canton: "VS", commune: "Steg-Hohtenn" },
    { zip: 3949, canton: "VS", commune: "Steg-Hohtenn" },
    { zip: 3983, canton: "VS", commune: "Bettmeralp" },
    { zip: 3991, canton: "VS", commune: "Bettmeralp" },
    { zip: 3992, canton: "VS", commune: "Bettmeralp" },
    { zip: 3994, canton: "VS", commune: "Bettmeralp" },
    { zip: 1903, canton: "VS", commune: "Collonges" },
    { zip: 1905, canton: "VS", commune: "Dorénaz" },
    { zip: 1902, canton: "VS", commune: "Evionnaz" },
    { zip: 1925, canton: "VS", commune: "Finhaut" },
    { zip: 1869, canton: "VS", commune: "Massongex" },
    { zip: 1871, canton: "VS", commune: "Massongex" },
    { zip: 1891, canton: "VS", commune: "Massongex" },
    { zip: 1890, canton: "VS", commune: "Saint-Maurice" },
    { zip: 1902, canton: "VS", commune: "Saint-Maurice" },
    { zip: 1922, canton: "VS", commune: "Salvan" },
    { zip: 1923, canton: "VS", commune: "Salvan" },
    { zip: 1904, canton: "VS", commune: "Vernayaz" },
    { zip: 1920, canton: "VS", commune: "Vernayaz" },
    { zip: 1891, canton: "VS", commune: "Vérossaz" },
    { zip: 3966, canton: "VS", commune: "Chalais" },
    { zip: 3967, canton: "VS", commune: "Chalais" },
    { zip: 3965, canton: "VS", commune: "Chippis" },
    { zip: 3979, canton: "VS", commune: "Grône" },
    { zip: 1977, canton: "VS", commune: "Icogne" },
    { zip: 1978, canton: "VS", commune: "Icogne" },
    { zip: 3963, canton: "VS", commune: "Icogne" },
    { zip: 1978, canton: "VS", commune: "Lens" },
    { zip: 3963, canton: "VS", commune: "Lens" },
    { zip: 3971, canton: "VS", commune: "Lens" },
    { zip: 3978, canton: "VS", commune: "Lens" },
    { zip: 3972, canton: "VS", commune: "Miège" },
    { zip: 1958, canton: "VS", commune: "Saint-Léonard" },
    { zip: 1958, canton: "VS", commune: "Sierre" },
    { zip: 3960, canton: "VS", commune: "Sierre" },
    { zip: 3965, canton: "VS", commune: "Sierre" },
    { zip: 3966, canton: "VS", commune: "Sierre" },
    { zip: 3976, canton: "VS", commune: "Sierre" },
    { zip: 3977, canton: "VS", commune: "Sierre" },
    { zip: 3973, canton: "VS", commune: "Venthône" },
    { zip: 3968, canton: "VS", commune: "Veyras" },
    { zip: 3960, canton: "VS", commune: "Anniviers" },
    { zip: 3961, canton: "VS", commune: "Anniviers" },
    { zip: 3960, canton: "VS", commune: "Crans-Montana" },
    { zip: 3963, canton: "VS", commune: "Crans-Montana" },
    { zip: 3971, canton: "VS", commune: "Crans-Montana" },
    { zip: 3972, canton: "VS", commune: "Crans-Montana" },
    { zip: 3973, canton: "VS", commune: "Crans-Montana" },
    { zip: 3974, canton: "VS", commune: "Crans-Montana" },
    { zip: 3975, canton: "VS", commune: "Crans-Montana" },
    { zip: 3976, canton: "VS", commune: "Crans-Montana" },
    { zip: 1972, canton: "VS", commune: "Arbaz" },
    { zip: 1974, canton: "VS", commune: "Arbaz" },
    { zip: 1950, canton: "VS", commune: "Grimisuat" },
    { zip: 1971, canton: "VS", commune: "Grimisuat" },
    { zip: 1950, canton: "VS", commune: "Savièse" },
    { zip: 1962, canton: "VS", commune: "Savièse" },
    { zip: 1965, canton: "VS", commune: "Savièse" },
    { zip: 1950, canton: "VS", commune: "Sion" },
    { zip: 1958, canton: "VS", commune: "Sion" },
    { zip: 1962, canton: "VS", commune: "Sion" },
    { zip: 1965, canton: "VS", commune: "Sion" },
    { zip: 1967, canton: "VS", commune: "Sion" },
    { zip: 1971, canton: "VS", commune: "Sion" },
    { zip: 1991, canton: "VS", commune: "Sion" },
    { zip: 1992, canton: "VS", commune: "Sion" },
    { zip: 1993, canton: "VS", commune: "Sion" },
    { zip: 1994, canton: "VS", commune: "Sion" },
    { zip: 1991, canton: "VS", commune: "Veysonnaz" },
    { zip: 1993, canton: "VS", commune: "Veysonnaz" },
    { zip: 3937, canton: "VS", commune: "Baltschieder" },
    { zip: 3922, canton: "VS", commune: "Eisten" },
    { zip: 3922, canton: "VS", commune: "Embd" },
    { zip: 3926, canton: "VS", commune: "Embd" },
    { zip: 3925, canton: "VS", commune: "Grächen" },
    { zip: 3931, canton: "VS", commune: "Lalden" },
    { zip: 3928, canton: "VS", commune: "Randa" },
    { zip: 3905, canton: "VS", commune: "Saas-Almagell" },
    { zip: 3908, canton: "VS", commune: "Saas-Balen" },
    { zip: 3906, canton: "VS", commune: "Saas-Fee" },
    { zip: 3910, canton: "VS", commune: "Saas-Fee" },
    { zip: 3910, canton: "VS", commune: "Saas-Grund" },
    { zip: 3924, canton: "VS", commune: "St. Niklaus" },
    { zip: 3927, canton: "VS", commune: "St. Niklaus" },
    { zip: 3922, canton: "VS", commune: "Stalden (VS)" },
    { zip: 3933, canton: "VS", commune: "Staldenried" },
    { zip: 3929, canton: "VS", commune: "Täsch" },
    { zip: 3923, canton: "VS", commune: "Törbel" },
    { zip: 3930, canton: "VS", commune: "Visp" },
    { zip: 3922, canton: "VS", commune: "Visperterminen" },
    { zip: 3930, canton: "VS", commune: "Visperterminen" },
    { zip: 3932, canton: "VS", commune: "Visperterminen" },
    { zip: 3934, canton: "VS", commune: "Zeneggen" },
    { zip: 3920, canton: "VS", commune: "Zermatt" },
    { zip: 2022, canton: "NE", commune: "Bevaix" },
    { zip: 2013, canton: "NE", commune: "Boudry" },
    { zip: 2014, canton: "NE", commune: "Boudry" },
    { zip: 2015, canton: "NE", commune: "Boudry" },
    { zip: 2017, canton: "NE", commune: "Boudry" },
    { zip: 2019, canton: "NE", commune: "Boudry" },
    { zip: 2149, canton: "NE", commune: "Boudry" },
    { zip: 2035, canton: "NE", commune: "Corcelles-Cormondrèche" },
    { zip: 2036, canton: "NE", commune: "Corcelles-Cormondrèche" },
    { zip: 2037, canton: "NE", commune: "Corcelles-Cormondrèche" },
    { zip: 2016, canton: "NE", commune: "Cortaillod" },
    { zip: 2027, canton: "NE", commune: "Fresens" },
    { zip: 2023, canton: "NE", commune: "Gorgier" },
    { zip: 2025, canton: "NE", commune: "Gorgier" },
    { zip: 2103, canton: "NE", commune: "Gorgier" },
    { zip: 2027, canton: "NE", commune: "Montalchez" },
    { zip: 2034, canton: "NE", commune: "Peseux" },
    { zip: 2019, canton: "NE", commune: "Rochefort" },
    { zip: 2035, canton: "NE", commune: "Rochefort" },
    { zip: 2037, canton: "NE", commune: "Rochefort" },
    { zip: 2103, canton: "NE", commune: "Rochefort" },
    { zip: 2149, canton: "NE", commune: "Rochefort" },
    { zip: 2318, canton: "NE", commune: "Rochefort" },
    { zip: 2024, canton: "NE", commune: "Saint-Aubin-Sauges" },
    { zip: 2027, canton: "NE", commune: "Saint-Aubin-Sauges" },
    { zip: 2028, canton: "NE", commune: "Saint-Aubin-Sauges" },
    { zip: 2028, canton: "NE", commune: "Vaumarcus" },
    { zip: 2000, canton: "NE", commune: "Milvignes" },
    { zip: 2012, canton: "NE", commune: "Milvignes" },
    { zip: 2013, canton: "NE", commune: "Milvignes" },
    { zip: 2014, canton: "NE", commune: "Milvignes" },
    { zip: 2035, canton: "NE", commune: "Milvignes" },
    { zip: 2036, canton: "NE", commune: "Milvignes" },
    { zip: 2300, canton: "NE", commune: "La Chaux-de-Fonds" },
    { zip: 2314, canton: "NE", commune: "La Chaux-de-Fonds" },
    { zip: 2322, canton: "NE", commune: "La Chaux-de-Fonds" },
    { zip: 2325, canton: "NE", commune: "Les Planchettes" },
    { zip: 2314, canton: "NE", commune: "La Sagne" },
    { zip: 2400, canton: "NE", commune: "Les Brenets" },
    { zip: 2416, canton: "NE", commune: "Les Brenets" },
    { zip: 2124, canton: "NE", commune: "La Brévine" },
    { zip: 2406, canton: "NE", commune: "La Brévine" },
    { zip: 2318, canton: "NE", commune: "Brot-Plamboz" },
    { zip: 2400, canton: "NE", commune: "Le Cerneux-Péquignot" },
    { zip: 2405, canton: "NE", commune: "Le Cerneux-Péquignot" },
    { zip: 2406, canton: "NE", commune: "Le Cerneux-Péquignot" },
    { zip: 2414, canton: "NE", commune: "Le Cerneux-Péquignot" },
    { zip: 2400, canton: "NE", commune: "La Chaux-du-Milieu" },
    { zip: 2405, canton: "NE", commune: "La Chaux-du-Milieu" },
    { zip: 2406, canton: "NE", commune: "La Chaux-du-Milieu" },
    { zip: 2322, canton: "NE", commune: "Le Locle" },
    { zip: 2400, canton: "NE", commune: "Le Locle" },
    { zip: 2316, canton: "NE", commune: "Les Ponts-de-Martel" },
    { zip: 2072, canton: "NE", commune: "Cornaux" },
    { zip: 2075, canton: "NE", commune: "Cornaux" },
    { zip: 2087, canton: "NE", commune: "Cornaux" },
    { zip: 2072, canton: "NE", commune: "Cressier (NE)" },
    { zip: 2087, canton: "NE", commune: "Cressier (NE)" },
    { zip: 2088, canton: "NE", commune: "Cressier (NE)" },
    { zip: 2067, canton: "NE", commune: "Enges" },
    { zip: 2073, canton: "NE", commune: "Enges" },
    { zip: 2068, canton: "NE", commune: "Hauterive (NE)" },
    { zip: 2073, canton: "NE", commune: "Le Landeron" },
    { zip: 2520, canton: "NE", commune: "Le Landeron" },
    { zip: 2523, canton: "NE", commune: "Le Landeron" },
    { zip: 2525, canton: "NE", commune: "Le Landeron" },
    { zip: 2523, canton: "NE", commune: "Lignières" },
    { zip: 2000, canton: "NE", commune: "Neuchâtel" },
    { zip: 2067, canton: "NE", commune: "Neuchâtel" },
    { zip: 2072, canton: "NE", commune: "Saint-Blaise" },
    { zip: 2074, canton: "NE", commune: "La Tène" },
    { zip: 2075, canton: "NE", commune: "La Tène" },
    { zip: 2042, canton: "NE", commune: "Valangin" },
    { zip: 2037, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2042, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2043, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2046, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2052, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2053, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2054, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2056, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2057, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2058, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2063, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2065, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2067, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2206, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2207, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2208, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2518, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2523, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2616, canton: "NE", commune: "Val-de-Ruz" },
    { zip: 2117, canton: "NE", commune: "La Côte-aux-Fées" },
    { zip: 2126, canton: "NE", commune: "Les Verrières" },
    { zip: 2406, canton: "NE", commune: "Les Verrières" },
    { zip: 2103, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2105, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2108, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2112, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2113, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2114, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2115, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2116, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2123, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2124, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2126, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2127, canton: "NE", commune: "Val-de-Travers" },
    { zip: 2406, canton: "NE", commune: "Val-de-Travers" },
    { zip: 1288, canton: "GE", commune: "Aire-la-Ville" },
    { zip: 1247, canton: "GE", commune: "Anières" },
    { zip: 1248, canton: "GE", commune: "Anières" },
    { zip: 1251, canton: "GE", commune: "Anières" },
    { zip: 1237, canton: "GE", commune: "Avully" },
    { zip: 1236, canton: "GE", commune: "Avusy" },
    { zip: 1285, canton: "GE", commune: "Avusy" },
    { zip: 1257, canton: "GE", commune: "Bardonnex" },
    { zip: 1258, canton: "GE", commune: "Bardonnex" },
    { zip: 1293, canton: "GE", commune: "Bellevue" },
    { zip: 1294, canton: "GE", commune: "Bellevue" },
    { zip: 1232, canton: "GE", commune: "Bernex" },
    { zip: 1233, canton: "GE", commune: "Bernex" },
    { zip: 1236, canton: "GE", commune: "Bernex" },
    { zip: 1286, canton: "GE", commune: "Bernex" },
    { zip: 1212, canton: "GE", commune: "Carouge (GE)" },
    { zip: 1227, canton: "GE", commune: "Carouge (GE)" },
    { zip: 1236, canton: "GE", commune: "Cartigny" },
    { zip: 1298, canton: "GE", commune: "Céligny" },
    { zip: 1237, canton: "GE", commune: "Chancy" },
    { zip: 1284, canton: "GE", commune: "Chancy" },
    { zip: 1285, canton: "GE", commune: "Chancy" },
    { zip: 1224, canton: "GE", commune: "Chêne-Bougeries" },
    { zip: 1231, canton: "GE", commune: "Chêne-Bougeries" },
    { zip: 1253, canton: "GE", commune: "Chêne-Bougeries" },
    { zip: 1225, canton: "GE", commune: "Chêne-Bourg" },
    { zip: 1244, canton: "GE", commune: "Choulex" },
    { zip: 1239, canton: "GE", commune: "Collex-Bossy" },
    { zip: 1290, canton: "GE", commune: "Collex-Bossy" },
    { zip: 1222, canton: "GE", commune: "Collonge-Bellerive" },
    { zip: 1245, canton: "GE", commune: "Collonge-Bellerive" },
    { zip: 1246, canton: "GE", commune: "Collonge-Bellerive" },
    { zip: 1207, canton: "GE", commune: "Cologny" },
    { zip: 1222, canton: "GE", commune: "Cologny" },
    { zip: 1223, canton: "GE", commune: "Cologny" },
    { zip: 1253, canton: "GE", commune: "Cologny" },
    { zip: 1228, canton: "GE", commune: "Confignon" },
    { zip: 1232, canton: "GE", commune: "Confignon" },
    { zip: 1222, canton: "GE", commune: "Corsier (GE)" },
    { zip: 1246, canton: "GE", commune: "Corsier (GE)" },
    { zip: 1251, canton: "GE", commune: "Corsier (GE)" },
    { zip: 1283, canton: "GE", commune: "Dardagny" },
    { zip: 1201, canton: "GE", commune: "Genève" },
    { zip: 1202, canton: "GE", commune: "Genève" },
    { zip: 1203, canton: "GE", commune: "Genève" },
    { zip: 1204, canton: "GE", commune: "Genève" },
    { zip: 1205, canton: "GE", commune: "Genève" },
    { zip: 1206, canton: "GE", commune: "Genève" },
    { zip: 1207, canton: "GE", commune: "Genève" },
    { zip: 1208, canton: "GE", commune: "Genève" },
    { zip: 1209, canton: "GE", commune: "Genève" },
    { zip: 1213, canton: "GE", commune: "Genève" },
    { zip: 1218, canton: "GE", commune: "Genève" },
    { zip: 1227, canton: "GE", commune: "Genève" },
    { zip: 1231, canton: "GE", commune: "Genève" },
    { zip: 1292, canton: "GE", commune: "Genève" },
    { zip: 1290, canton: "GE", commune: "Genthod" },
    { zip: 1293, canton: "GE", commune: "Genthod" },
    { zip: 1294, canton: "GE", commune: "Genthod" },
    { zip: 1202, canton: "GE", commune: "Le Grand-Saconnex" },
    { zip: 1209, canton: "GE", commune: "Le Grand-Saconnex" },
    { zip: 1215, canton: "GE", commune: "Le Grand-Saconnex" },
    { zip: 1216, canton: "GE", commune: "Le Grand-Saconnex" },
    { zip: 1218, canton: "GE", commune: "Le Grand-Saconnex" },
    { zip: 1251, canton: "GE", commune: "Gy" },
    { zip: 1254, canton: "GE", commune: "Gy" },
    { zip: 1248, canton: "GE", commune: "Hermance" },
    { zip: 1254, canton: "GE", commune: "Jussy" },
    { zip: 1236, canton: "GE", commune: "Laconnex" },
    { zip: 1287, canton: "GE", commune: "Laconnex" },
    { zip: 1212, canton: "GE", commune: "Lancy" },
    { zip: 1213, canton: "GE", commune: "Lancy" },
    { zip: 1227, canton: "GE", commune: "Lancy" },
    { zip: 1228, canton: "GE", commune: "Lancy" },
    { zip: 1256, canton: "GE", commune: "Lancy" },
    { zip: 1222, canton: "GE", commune: "Meinier" },
    { zip: 1244, canton: "GE", commune: "Meinier" },
    { zip: 1251, canton: "GE", commune: "Meinier" },
    { zip: 1252, canton: "GE", commune: "Meinier" },
    { zip: 1254, canton: "GE", commune: "Meinier" },
    { zip: 1214, canton: "GE", commune: "Meyrin" },
    { zip: 1215, canton: "GE", commune: "Meyrin" },
    { zip: 1216, canton: "GE", commune: "Meyrin" },
    { zip: 1217, canton: "GE", commune: "Meyrin" },
    { zip: 1212, canton: "GE", commune: "Onex" },
    { zip: 1213, canton: "GE", commune: "Onex" },
    { zip: 1258, canton: "GE", commune: "Perly-Certoux" },
    { zip: 1212, canton: "GE", commune: "Plan-les-Ouates" },
    { zip: 1228, canton: "GE", commune: "Plan-les-Ouates" },
    { zip: 1256, canton: "GE", commune: "Plan-les-Ouates" },
    { zip: 1257, canton: "GE", commune: "Plan-les-Ouates" },
    { zip: 1202, canton: "GE", commune: "Pregny-Chambésy" },
    { zip: 1292, canton: "GE", commune: "Pregny-Chambésy" },
    { zip: 1241, canton: "GE", commune: "Presinge" },
    { zip: 1243, canton: "GE", commune: "Presinge" },
    { zip: 1244, canton: "GE", commune: "Presinge" },
    { zip: 1254, canton: "GE", commune: "Presinge" },
    { zip: 1241, canton: "GE", commune: "Puplinge" },
    { zip: 1281, canton: "GE", commune: "Russin" },
    { zip: 1214, canton: "GE", commune: "Satigny" },
    { zip: 1217, canton: "GE", commune: "Satigny" },
    { zip: 1242, canton: "GE", commune: "Satigny" },
    { zip: 1281, canton: "GE", commune: "Satigny" },
    { zip: 1286, canton: "GE", commune: "Soral" },
    { zip: 1224, canton: "GE", commune: "Thônex" },
    { zip: 1225, canton: "GE", commune: "Thônex" },
    { zip: 1226, canton: "GE", commune: "Thônex" },
    { zip: 1231, canton: "GE", commune: "Thônex" },
    { zip: 1255, canton: "GE", commune: "Troinex" },
    { zip: 1256, canton: "GE", commune: "Troinex" },
    { zip: 1257, canton: "GE", commune: "Troinex" },
    { zip: 1253, canton: "GE", commune: "Vandoeuvres" },
    { zip: 1209, canton: "GE", commune: "Vernier" },
    { zip: 1214, canton: "GE", commune: "Vernier" },
    { zip: 1216, canton: "GE", commune: "Vernier" },
    { zip: 1219, canton: "GE", commune: "Vernier" },
    { zip: 1220, canton: "GE", commune: "Vernier" },
    { zip: 1290, canton: "GE", commune: "Versoix" },
    { zip: 1234, canton: "GE", commune: "Veyrier" },
    { zip: 1255, canton: "GE", commune: "Veyrier" },
    { zip: 1256, canton: "GE", commune: "Veyrier" },
    { zip: 2856, canton: "JU", commune: "Boécourt" },
    { zip: 2857, canton: "JU", commune: "Boécourt" },
    { zip: 2883, canton: "JU", commune: "Boécourt" },
    { zip: 2803, canton: "JU", commune: "Bourrignon" },
    { zip: 2843, canton: "JU", commune: "Châtillon (JU)" },
    { zip: 2826, canton: "JU", commune: "Corban" },
    { zip: 2825, canton: "JU", commune: "Courchapoix" },
    { zip: 2800, canton: "JU", commune: "Courrendlin" },
    { zip: 2830, canton: "JU", commune: "Courrendlin" },
    { zip: 2805, canton: "JU", commune: "Courroux" },
    { zip: 2822, canton: "JU", commune: "Courroux" },
    { zip: 2823, canton: "JU", commune: "Courroux" },
    { zip: 2830, canton: "JU", commune: "Courroux" },
    { zip: 2852, canton: "JU", commune: "Courtételle" },
    { zip: 2800, canton: "JU", commune: "Delémont" },
    { zip: 2802, canton: "JU", commune: "Develier" },
    { zip: 2813, canton: "JU", commune: "Ederswiler" },
    { zip: 2827, canton: "JU", commune: "Mervelier" },
    { zip: 2806, canton: "JU", commune: "Mettembert" },
    { zip: 2812, canton: "JU", commune: "Movelier" },
    { zip: 2813, canton: "JU", commune: "Movelier" },
    { zip: 2803, canton: "JU", commune: "Pleigne" },
    { zip: 2806, canton: "JU", commune: "Pleigne" },
    { zip: 2807, canton: "JU", commune: "Pleigne" },
    { zip: 2813, canton: "JU", commune: "Pleigne" },
    { zip: 2814, canton: "JU", commune: "Pleigne" },
    { zip: 2832, canton: "JU", commune: "Rebeuvelier" },
    { zip: 2842, canton: "JU", commune: "Rossemaison" },
    { zip: 2718, canton: "JU", commune: "Saulcy" },
    { zip: 2873, canton: "JU", commune: "Saulcy" },
    { zip: 2805, canton: "JU", commune: "Soyhières" },
    { zip: 2830, canton: "JU", commune: "Vellerat" },
    { zip: 2748, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2853, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2854, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2855, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2863, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2864, canton: "JU", commune: "Haute-Sorne" },
    { zip: 2824, canton: "JU", commune: "Val Terbi" },
    { zip: 2828, canton: "JU", commune: "Val Terbi" },
    { zip: 2829, canton: "JU", commune: "Val Terbi" },
    { zip: 2832, canton: "JU", commune: "Val Terbi" },
    { zip: 2360, canton: "JU", commune: "Le Bémont (JU)" },
    { zip: 2363, canton: "JU", commune: "Le Bémont (JU)" },
    { zip: 2336, canton: "JU", commune: "Les Bois" },
    { zip: 2345, canton: "JU", commune: "Les Breuleux" },
    { zip: 2345, canton: "JU", commune: "La Chaux-des-Breuleux" },
    { zip: 2353, canton: "JU", commune: "Les Enfers" },
    { zip: 2363, canton: "JU", commune: "Les Enfers" },
    { zip: 2714, canton: "JU", commune: "Les Genevez (JU)" },
    { zip: 2718, canton: "JU", commune: "Lajoux (JU)" },
    { zip: 2362, canton: "JU", commune: "Montfaucon" },
    { zip: 2718, canton: "JU", commune: "Montfaucon" },
    { zip: 2338, canton: "JU", commune: "Muriaux" },
    { zip: 2345, canton: "JU", commune: "Muriaux" },
    { zip: 2336, canton: "JU", commune: "Le Noirmont" },
    { zip: 2340, canton: "JU", commune: "Le Noirmont" },
    { zip: 2345, canton: "JU", commune: "Le Noirmont" },
    { zip: 2350, canton: "JU", commune: "Saignelégier" },
    { zip: 2353, canton: "JU", commune: "Saignelégier" },
    { zip: 2354, canton: "JU", commune: "Saignelégier" },
    { zip: 2364, canton: "JU", commune: "Saint-Brais" },
    { zip: 2873, canton: "JU", commune: "Saint-Brais" },
    { zip: 2882, canton: "JU", commune: "Saint-Brais" },
    { zip: 2883, canton: "JU", commune: "Saint-Brais" },
    { zip: 2886, canton: "JU", commune: "Saint-Brais" },
    { zip: 2887, canton: "JU", commune: "Soubey" },
    { zip: 2942, canton: "JU", commune: "Alle" },
    { zip: 2935, canton: "JU", commune: "Beurnevésin" },
    { zip: 2926, canton: "JU", commune: "Boncourt" },
    { zip: 2944, canton: "JU", commune: "Bonfol" },
    { zip: 2915, canton: "JU", commune: "Bure" },
    { zip: 2932, canton: "JU", commune: "Coeuve" },
    { zip: 2952, canton: "JU", commune: "Cornol" },
    { zip: 2922, canton: "JU", commune: "Courchavon" },
    { zip: 2950, canton: "JU", commune: "Courgenay" },
    { zip: 2952, canton: "JU", commune: "Courgenay" },
    { zip: 2905, canton: "JU", commune: "Courtedoux" },
    { zip: 2933, canton: "JU", commune: "Damphreux" },
    { zip: 2916, canton: "JU", commune: "Fahy" },
    { zip: 2889, canton: "JU", commune: "Fontenais" },
    { zip: 2902, canton: "JU", commune: "Fontenais" },
    { zip: 2903, canton: "JU", commune: "Fontenais" },
    { zip: 2904, canton: "JU", commune: "Fontenais" },
    { zip: 2908, canton: "JU", commune: "Grandfontaine" },
    { zip: 2933, canton: "JU", commune: "Lugnez" },
    { zip: 2900, canton: "JU", commune: "Porrentruy" },
    { zip: 2907, canton: "JU", commune: "Rocourt" },
    { zip: 2943, canton: "JU", commune: "Vendlincourt" },
    { zip: 2915, canton: "JU", commune: "Basse-Allaine" },
    { zip: 2923, canton: "JU", commune: "Basse-Allaine" },
    { zip: 2924, canton: "JU", commune: "Basse-Allaine" },
    { zip: 2925, canton: "JU", commune: "Basse-Allaine" },
    { zip: 2882, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2883, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2884, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2885, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2886, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2888, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2889, canton: "JU", commune: "Clos du Doubs" },
    { zip: 2906, canton: "JU", commune: "Haute-Ajoie" },
    { zip: 2912, canton: "JU", commune: "Haute-Ajoie" },
    { zip: 2914, canton: "JU", commune: "Haute-Ajoie" },
    { zip: 2807, canton: "JU", commune: "La Baroche" },
    { zip: 2883, canton: "JU", commune: "La Baroche" },
    { zip: 2946, canton: "JU", commune: "La Baroche" },
    { zip: 2947, canton: "JU", commune: "La Baroche" },
    { zip: 2953, canton: "JU", commune: "La Baroche" },
    { zip: 2954, canton: "JU", commune: "La Baroche" }
];



//////////////////
// WEBPACK FOOTER
// ./~/swiss-zipcodes/dist/data_bfs.js
// module id = 728
// module chunks = 0